 
/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 * search for CustomEvent in theme.min.js to find other events you can trigger on
 */

 /*============================================================================
  A11y Helpers
==============================================================================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */
window.slate = window.slate || {};
window.theme = window.theme || {};

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace ? 'focusin.' + options.namespace : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace ? 'focusin.' + options.namespace : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

 /*============================================================================
  Helper utilities
==============================================================================*/
window.theme = window.theme || {};

theme.utils = {

  /**
   * Locks the page scroll.
   *
   * @param      {element}  scrollEl  optional
   */
  lockPageScroll: function(scrollEl) {

    document.documentElement.classList.add('scroll-locked');
    if ('bodyScrollLock' in window) {
      bodyScrollLock.lock(scrollEl);
    }

  },

    /**
   * Unlocks the page scroll.
   */
  unlockPageScroll: function() {

    document.documentElement.classList.remove('scroll-locked');

    if ('bodyScrollLock' in window) {
      bodyScrollLock.unlock();
    }
  },

  /**
   * Turns a string into a handle. Mimics Shopify's format.
   */
  handleize: function(str) {
    return str.toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "");
  },

  /**
   * Cross-browser URL query param getter
   */
  getQueryParams: function(qs) {
    qs = qs || document.location.search;

    if (!qs) { 
      return;
    }

    qs = qs.split('+').join(' ');

    var params = {},
        tokens,
        re = /[?&]?([^=]+)=([^&]*)/g;

    while (tokens = re.exec(qs)) {
      params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2]);
    }

    return params;
  },

  parseBase64Value: function(value){
    function escapeRegExp(string) {
      return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
    }
    function replaceAllValues(str, match, replacement){
       return str.replace(new RegExp(escapeRegExp(match), 'g'), ()=>replacement);
    }
    value = value.replace(/\%3D/g, ' ');
    value = value.replace(/\%2B/g, ' ');
    value = value.replace(/\%2F/g, ' ');
    return value;
  },

  updateQueryStringParameter: function(key, value, url) {
    if (!url) url = window.location.href;

    var re = new RegExp("([?&])" + key + "=.*?(&|#|$)(.*)", "gi"),
    hash;

    if (re.test(url)) {
      if (typeof value !== 'undefined' && value !== null)
        return url.replace(re, '$1' + key + "=" + value + '$2$3');
      else {
        hash = url.split('#');
        url = hash[0].replace(re, '$1$3').replace(/(&|\?)$/, '');
        if (typeof hash[1] !== 'undefined' && hash[1] !== null) 
          url += '#' + hash[1];
        return url;
      }
    } else {
      if (typeof value !== 'undefined' && value !== null) {
        var separator = url.indexOf('?') !== -1 ? '&' : '?';
        hash = url.split('#');
        url = hash[0] + separator + key + '=' + value;
        if (typeof hash[1] !== 'undefined' && hash[1] !== null) 
          url += '#' + hash[1];
        return url;
      }
      else
        return url;
    }
  },

  getYoutubeId: function(url) {
    var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
    var match = url.match(regExp);
    return (match&&match[7].length==11)? match[7] : false;
  },

  getProductJSON: function(handle, success, error) {
    return $.ajax({
      url: '/products/' + handle + '?view=json',
      success: success || $.noop,
      error: error || $.noop
    });
  },

  hexToRgb: function(hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    } : null;
  },

  forceRedraw: function(elem) {
    if (!elem) {
      return;
    }

    var disp = elem.style.display;
    elem.style.display = 'none';
    var redrawElem = elem.offsetHeight;
    elem.style.display = disp;
  },

  simpleStringify: function(object){
      var simpleObject = {};
      for (var prop in object ){
          if (!object.hasOwnProperty(prop)){
              continue;
          }
          if (typeof(object[prop]) == 'object'){
              continue;
          }
          if (typeof(object[prop]) == 'function'){
              continue;
          }
          simpleObject[prop] = object[prop];
      }
      return JSON.stringify(simpleObject); // returns cleaned up JSON
  },

  flash: function(elements, color, duration) {
    var opacity = 100;
    color = color || '255, 255, 136';
    duration = duration || 1500;
    
    if (color.indexOf('#') > -1) {
      var rgbColor = theme.utils.hexToRgb(color);
      color = [rgbColor.r,rgbColor.g,rgbColor.b].join(',');
    }
    
    var interval = setInterval(function() {
      opacity -= 2.5;
      
      $(elements).css({ background: 'rgba(' + color + ', ' + opacity / 100 + ')' });
      
      if (opacity <= 0) {
        clearInterval(interval);
        return;
      }
    }, duration / 40);
  },

  getOffset: function(el) {
    var rect = el.getBoundingClientRect(),
    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
  },

  // Gets the rendered size of an image using object-fit
  getRenderedImgSize: function(contains, cWidth, cHeight, width, height, pos){
    var oRatio = width / height,
    cRatio = cWidth / cHeight;
    return function() {
      if (contains ? (oRatio > cRatio) : (oRatio < cRatio)) {
        this.width = cWidth;
        this.height = cWidth / oRatio;
      } else {
        this.width = cHeight * oRatio;
        this.height = cHeight;
      }      
      this.left = (cWidth - this.width)*(pos/100);
      this.right = this.width + this.left;
      return this;
    }.call({});
  },

  // Returns size info for an image rendered with object-fit
  getImgSizeInfo: function(img) {
    var pos = window.getComputedStyle(img).getPropertyValue('object-position').split(' ');
    return theme.utils.getRenderedImgSize(true,
      img.width,
      img.height,
      img.naturalWidth,
      img.naturalHeight,
      parseInt(pos[0]));
  },

  // Returns content of template placed into snippets/js-tempales.liquid
  getTemplate: function(template) {
    return $('[data-template-for="' + template + '"]').html();
  },

  //
  createElementFromHTML: function(htmlString) {
    var div = document.createElement('div');
    div.innerHTML = htmlString.trim();
    return div.firstChild;
  },

  // Returns deep differences between objects, ignoring functions
  difference: function(object, base) {
    function changes(object, base) {
      return _.transform(object, function(result, value, key) {
        if (typeof value !== 'function' && !_.isEqual(value, base[key])) {
          var comparison = (_.isObject(value) && _.isObject(base[key])) ? changes(value, base[key]) : value;

          if (!_.isNil(comparison)) {
            result[key] = comparison;
          }
        }
      });
    }
    return changes(object, base);
  },

  // Adds syntax highlighting to JSON output
  syntaxHighlight: function(json) {
    json = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    json = json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, function (match) {
      var cls = 'number';
      if (/^"/.test(match)) {
        if (/:$/.test(match)) {
          cls = 'key';
        } else {
          cls = 'string';
        }
      } else if (/true|false/.test(match)) {
        cls = 'boolean';
      } else if (/null/.test(match)) {
        cls = 'null';
      }
      return '<span class="' + cls + '">' + match + '</span>';
    });
    json = json.replace(/([\n\r]|^)(\s*){/g, '<span class="group">$2<span class="group-handle">{</span>').replace(/([\n\r]|^)(\s*)}(,|)/g, '$1$2}$3</span>');
    json = json.replace(/(<\/span>|^)(\s*)\[/g, '$1<span class="group group--inline">$2<span class="group-handle">[</span>').replace(/([\n\r]|^)(\s*)](,|)/g, '$2]$3</span>');
    return json;
  },

  getStyleValue: function(variable) {
    var value = window.getComputedStyle(document.documentElement).getPropertyValue(variable);
    if (value) {
      return value.trim();
    }
    return '';
  },

  // returns cross-browser CSS property name
  getCSSProperty: function(propertyName) {
    var properties;

    switch(propertyName) {

      case 'transform':
        properties = ['transform', 'msTransform', 'webkitTransform', 'mozTransform', 'oTransform'];
        break;
    }

    function getSupportedPropertyName(properties) {
      for (var i = 0; i < properties.length; i++) {
        if (typeof document.body.style[properties[i]] != 'undefined') {
          return properties[i];
        }
      }
      return null;
    }

    return getSupportedPropertyName(properties);
  },

  getBottomOffsetFromViewportTop: function(el) {
    var rect = el.getBoundingClientRect();
    return rect.top + rect.height;
  },

  errorTippy: function(target, message) {
    var $el = $(target);
    var tip = tippy($el[0], {
      showOnInit: true,
      content: message,
      theme: 'light',
      animation: 'shift-away',
      arrow: true,
      delay: [0, 1000],
      onHidden: function(e) {
        e.destroy();
      }
    });
  },

  showError: function(message) {
    iziToast.show({
      message: message,
      color: 'red',
      position: 'bottomCenter'
    });
  },

  getVariantLineItemInCart: function(variantId) {
    if (!CartJS || !CartJS.cart || !CartJS.cart.items) {
      return;
    }
    var i = CartJS.cart.items.length;
    while(i--) {
      var lineItem = CartJS.cart.items[i];
      if (lineItem.variant_id === variantId && !(lineItem.properties && lineItem.properties['_order-id'])) {
        return lineItem;
      }
    }
  },

};


// Setup progress bar plugin
if ('NProgress' in window) {
  NProgress.configure({ showSpinner: false });
}


/*============================================================================
  OD MOdal
==============================================================================*/

window.theme = window.theme || {};

theme.Modal = (function() {

  var config = {

  };

  function Modal(content, options) {

    this.modalContent = content;
    this.options = options || {};
    this.modal = this._createNewModal();

  }

  Modal.prototype = _.extend(Modal.prototype, {

    _createNewModal: function() {

      var featherlightOptions = this.options.featherlightOptions;
      var modal = $.odModal($(this.modalContent), featherlightOptions);

      if (this.options.positionX || this.options.positionY) {
        modal.$instance.addClass('od-modal--' + this.options.positionX);
        modal.$instance.addClass('od-modal--' + this.options.positionY);
      }

      return modal;
    }

  });

  return Modal;
})();


/*============================================================================
  Simple Accordion
==============================================================================*/

window.theme = window.theme || {};
window.accordions = window.accordions || {};

theme.SimpleAccordion = (function() {

  var defaults = {
    activeClass: 'active',
    accordionClass: 'simple-accordion',
    accordionTitleClass: 'simple-accordion__title'
  };

  var selectors = {
    accordion: '[data-simple-accordion]',
    title: '.' + defaults.accordionTitleClass,
  };

  function SimpleAccordion(el) {

    this.$el = $(el);

    var mediaQuery = this.$el.data('simpleAccordion');

    if (mediaQuery) {
      this.mediaQuery = theme.settings.mediaQuery[mediaQuery];
    }

    var styleValue = theme.utils.getStyleValue('--accordion-transition-duration') || '0.5s';
 
    this.animationDuration = styleValue.replace('s', '') * 1000;

    this.$titles = this.$el.find(selectors.title);
    if (!this.$titles.length) {
      this.$titles = this.$el.children().first();
      this.$titles.addClass(defaults.accordionTitleClass);
    }

    var self = this;

    if (self.mediaQuery) {
      _registerBreakpoints(self.mediaQuery);
    } else {
      initAccordion();
    }

    function initAccordion() {
      self.$el.addClass(defaults.accordionClass);
      self.$titles.on('click.accordion', _openClose);
    }

    function destroyAccordion() {
      self.$el.removeClass(defaults.accordionClass);
      self.$titles.off('click.accordion');
    }

    function _registerBreakpoints(mediaQuery) {

      enquire.register(mediaQuery, {
        match: function() {
          initAccordion();
        },
        unmatch: function() {
          destroyAccordion();
        }
      });

    }

    function _openClose() {

      var $currentTitle = $(this);

      var $target = $(this).next();
      var $active = self.$titles.filter('.' + defaults.activeClass).next();

      var close = false;
      if ($target[0] == $active[0]) {
        close = true;

        // If target is a link and accordion is open then go to link
        // if (event.target.href || event.currentTarget.href) {
        //   window.location.href = event.target.href || event.currentTarget.href;
        //   return;
        // }
      }

      event.preventDefault();

      self.$titles.removeClass(defaults.activeClass);

      var height = {
        target: {},
        active: {}
      };

      height.target.current = $target.height();
      height.active.new = 0;
      height.active.current = $active.height();

      $active.height(height.active.current);

      if (!close) {
        $(this).addClass(defaults.activeClass);
        $target.height(height.target.current);
        $target.addClass(defaults.activeClass);
      }

      $active.removeClass(defaults.activeClass);

      // if (!close) {
        $target.height('auto');
        $active.height('auto');
        $active.height(height.active.new);
        height.target.new = $target.get(0).scrollHeight;
        $target.offset();
        $active.offset();
        $currentTitle.trigger('accordionTransitionHeightCalc');
        $active.height('auto');
        $active.height(height.active.current);
        $target.height(height.target.current);
        $target.height(height.target.new);
      // }

      $active.height(height.active.new);

      setTimeout(function(){
        $target.height('');
        $active.height('');
        $currentTitle.trigger('accordionTransitionEnd');
       }, self.animationDuration);

      return;
    }
  }

  (function init() {
    var $accordions = $(selectors.accordion);
    if (!$accordions.length) {
      return;
    }
    for (var i = $accordions.length - 1; i >= 0; i--) {
      window.accordions[i] = new SimpleAccordion($accordions[i]);
    }
  })();

  return SimpleAccordion;

})();


/*============================================================================
  View Bindings
==============================================================================*/
 if ('tinybind' in window) {

  tinybind.formatters.replace = function(value, search, replace) {
    return value.replace(search, replace);
  };
   
  tinybind.formatters.style = function (value, style) {
    return `${style}: ${value};`;
  };

  tinybind.formatters.handle = function(string) {
    return theme.utils.handleize(string);
  };

  tinybind.formatters.startsWith = function(value, prefix) {
    return value.indexOf(prefix) === 0;
  };

  tinybind.formatters.endsWith = function(value, suffix) {
    return value.indexOf(suffix, value.length - suffix.length) !== -1;
  };

  tinybind.formatters.gte = function(a, b) {
    return a >= b;
  };

  tinybind.formatters.or = function(a, b) {
    return a || b;
  };

  tinybind.formatters.and = function(a, b) {
    return a && b;
  };


  tinybind.formatters.times = function(a, b) {
    return a * b;
  };

  tinybind.formatters.size = function(a) {
    return _.size(a);
  };

  tinybind.formatters.round_up = function(a) {
    return Math.ceil(a);
  };

  tinybind.formatters.checkOptionAvailability = function(a,b) {
    var satisfied = false;
    if (a.options_with_values.length == 1) {
      var variant = _.find(a.variants, {title: b.title});
      if (variant) {
        if (variant.available) {
          satisfied = true;
        }
      }
    }
    else {
      satisfied = true;
    }
    return satisfied;
  };

  tinybind.formatters.appendIfOptionNotAvailable = function(a,b,c) {
    var satisfied = b + c;
    if (a.options_with_values.length == 1) {
      var variant = _.find(a.variants, {title: b});
      if (variant) {
        if (variant.available) {
          satisfied = b;
        }
      }
    }
    else {
      satisfied = b;
    }
    return satisfied;
  };


  tinybind.formatters.length = tinybind.formatters.size;

  tinybind.formatters.stripHtml = function(html) {
    var parsedHtml = new DOMParser().parseFromString(html, 'text/html');
    return parsedHtml.body.textContent || "";
  };

  tinybind.formatters.escape = function(string) {
    return JSON.stringify(string).replace(/(^"|"$)/g, '');
  };

  tinybind.formatters.json = function(a) {
    return JSON.stringify(a);
  };

  tinybind.formatters.log = function(value) {
    return value;
  };

  tinybind.formatters.format_tel = function(value) {
    return value ? value.toString().replace(/\ /g, '') : value;
  };

  tinybind.formatters.array_position = function(array, value) {
    return (value >= 0 ? array[value] : array[array.length + value]);
  };

  tinybind.formatters.percentage_of = function(a, b) {
    return b / a * 100;
  };

  tinybind.formatters.contains = function(a, b) {
    return (a.indexOf(b) > -1);
  };

  tinybind.formatters.imageExists = function(a) {
    return (a && a.indexOf('no-image') == -1);
  };

  tinybind.formatters.highlight = function(a, b) {
    if (b && a) {
      return theme.utils.highlightSubString(b, a);
    }
    return;
  };

  tinybind.formatters.passedMinSpendRules = function(cartItems,b) {
    // a is cart.items - so event trigger updates, b is cart to get cart total
    if (cartItems) {
      var minSpendProducts = [];
      var failedMinSpendProducts = [];
      var cartTotalExcludingMinSpend = 0;
      
      for (var i = 0; i < cartItems.length; i++) {
        var item = cartItems[i];
        if(item.properties && item.properties['_min_spend']){
          var minSpendAmount = 0;
          //catch for boost filter values that were formatted for money
          if (item.properties._min_spend.indexOf('$') > -1) {
            var cents = item.properties._min_spend.replace('$','').replace('.','');

            minSpendAmount = parseInt(cents);
          }
          else {
            minSpendAmount = parseInt(item.properties._min_spend);
          }
          
          item.minSpendAmount = minSpendAmount;
          minSpendProducts.push(item);
          
        }
        else {
          cartTotalExcludingMinSpend += item.discounted_price * item.quantity;
        }
      }


      for (var i = 0; i < minSpendProducts.length; i++) {
        minSpendProducts[i]
        if(cartTotalExcludingMinSpend < item.minSpendAmount){
          failedMinSpendProducts.push(item);
        }
      }

      if(failedMinSpendProducts.length > 0){
        return false;
      }
    }
    return true;
  };

  tinybind.formatters.getMinimumSpend = function(cartItems,b) {
    // a is cart.items
    if (cartItems) {
      var minSpendProducts = [];
      var failedMinSpendProducts = [];
      var cartTotalExcludingMinSpend = 0;
      
      for (var i = 0; i < cartItems.length; i++) {
        var item = cartItems[i];
        if(item.properties && item.properties['_min_spend']){
          var minSpendAmount = 0;
          //catch for boost filter values that were formatted for money
          if (item.properties._min_spend.indexOf('$') > -1) {
            var cents = item.properties._min_spend.replace('$','').replace('.','');
            minSpendAmount = parseInt(cents);
          }
          else {
            minSpendAmount = parseInt(item.properties._min_spend);
          }
          
          item.minSpendAmount = minSpendAmount;
          minSpendProducts.push(item);
          
        }
        else {
          cartTotalExcludingMinSpend += item.discounted_price * item.quantity;
        }
      }


      for (var i = 0; i < minSpendProducts.length; i++) {
        minSpendProducts[i]
        if(cartTotalExcludingMinSpend < item.minSpendAmount){
          failedMinSpendProducts.push({ 
              'title': item.title, 
              'min_spend': item.minSpendAmount, 
              'amount': item.minSpendAmount,
              'amount_money': Shopify.formatMoney(item.minSpendAmount), 
              'amount_to_go': Shopify.formatMoney(parseFloat(item.minSpendAmount - cartTotalExcludingMinSpend))});
        }
      }


      if(failedMinSpendProducts.length > 0){
        var minSpendToShow = _.orderBy(failedMinSpendProducts, 'minSpendAmount');
        var minSpendHighestMatch = minSpendToShow[0];
        if(minSpendHighestMatch){
          var template = "<div class=''>You need to spend another <strong>"+ minSpendHighestMatch.amount_to_go +"</strong> to purchase " +minSpendHighestMatch.title +"</div>";
          return template;
        }
      }
    }
    return;
  };

  tinybind.formatters.countItemInCart = function(cart, variantId) {
    var itemsInCart = 0;
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].id == variantId){
        itemsInCart += cart.items[i].quantity;
      }
    }
    return itemsInCart;
  };

  tinybind.formatters['price_with_addons'] = function(line_item) {
    var linePrice = line_item.line_price;

    for (var i = 0; i < CartJS.cart.items.length; i++) {
      if (CartJS.cart.items[i].key != line_item.key && CartJS.cart.items[i].properties._optionGroup != undefined && CartJS.cart.items[i].properties._optionGroup == line_item.properties._optionGroup) {
        linePrice += CartJS.cart.items[i].line_price;
      }
    }
    
    return linePrice;
  };

  tinybind.formatters.img = function(image, alt, maxWidth, maxHeight) {

    if (!image) {
      return;
    }

    var imgTemplateURL,
        imgString,
        imgUrl;

    imgUrl = (typeof image == 'string' ? image : image.src);

    imgTemplateURL = slate.Image.getSizedImageUrl(imgUrl, '{width}x');

    maxWidth = maxWidth ? ((image.width ? image.width + 'px' : false) || (typeof maxWidth == 'string' ? maxWidth : maxWidth + 'px')) : 'none';
    maxHeight = maxHeight ? ((image.height ? image.height + 'px' : false) || (typeof maxHeight == 'string' ? maxHeight : maxHeight + 'px')) : 'none';

    alt = alt || null;

    imgString = '<img src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" class="Image--lazyLoad fade-in" style="max-width: ' + maxWidth + '; max-height: ' + maxHeight + ';" data-sizes="auto" data-src="' + imgTemplateURL + '" alt="' + alt + ' "/>';

    return imgString;
  };

  tinybind.formatters.map = function(a, b) {
    return _.map(a, b);
  };

  tinybind.binders.selected = function(el, value) {
    if (value) {
      el.selected = 'selected';
    }
  };

  
  tinybind.binders['slideshow'] = {

    bind: function(el) {
      this.el;
      this.displayCount;
      this.track;
      this.slides;
      this.buttons;
      this.isInit = false;
      this.currentSlideIndex = 0;
      this.slidesToShow = Math.round(parseInt(el.dataset.slidesToShow)) || 1;

      var NAMESPACE = 'slideshow';
      var SLIDSHOW_ELEMENT_CLASS_NAME = 'slideshow-view';
      var SLIDSHOW_BUTTONS_CLASS_NAME = 'slideshow-button';
      var NEXT_DIRECTION_NAME = 'next';
      var PREV_DIRECTION_NAME = 'previous';

      var self = this;

      var enableOrDisableButton = function(button) {
        var direction = button.name;
        if (direction == NEXT_DIRECTION_NAME && self.currentSlideIndex >= self.slides - self.displayCount) {
          button.disabled = true;
        } else if (direction == PREV_DIRECTION_NAME && self.currentSlideIndex == 0) {
          button.disabled = true;
        } else {
          button.disabled = false;
        }
      };

      var goToNextSlide = function() {
        if (self.currentSlideIndex < self.slides - 1) {
          goToSlide(self.currentSlideIndex + 1);
        }
      };

      var goToPrevSlide = function() {
        if (self.currentSlideIndex > 0) {
          goToSlide(self.currentSlideIndex - 1);
        }
      };

      var goToSlide = function(slideIndex) {
        var currentSlide = self.slides[self.currentSlideIndex];
        var targetSlide = self.slides[slideIndex];

        self.track.style.transform = 'translateX(' + slideIndex / self.slides * -100 * self.slidesToShow + '%)';

        if (currentSlide) {
          currentSlide.setAttribute('aria-hidden', true);
        }
        if (targetSlide) {
          targetSlide.setAttribute('aria-hidden', false);
        }
        

        self.currentSlideIndex = slideIndex;

        Array.prototype.forEach.call(self.buttons, function(button) {
          enableOrDisableButton(button);
        });
      };

      var getButtonsTemplate = function(direction) {
        var templateNamePrefix = 'slider-button-';
        return $('[data-template-for="' + templateNamePrefix + direction + '"]').html();
      };

      this._createSlideshow = function(el, options) {

        self.displayMobile = parseInt(self.el.dataset.slidesToShowMobile) || 1;
        self.displayDesktop = parseInt(self.el.dataset.slidesToShowDesktop) || 1;
        self.displayCount = parseInt(self.el.dataset.slidesToShow);

        var width = window.innerWidth;
        if (width > 1024) {
          self.displayCount = self.displayDesktop;
        }
        else {
          self.displayCount = self.displayMobile;
        }

        
        self.track = self.el.firstElementChild;
        self.slides = self.track.children.length;

        self.el.classList.add(SLIDSHOW_ELEMENT_CLASS_NAME);

        Array.prototype.forEach.call(self.slides, function(slide, index) {
          slide.setAttribute('aria-hidden', index != self.currentSlideIndex);
        });

        self.el.addEventListener(NEXT_DIRECTION_NAME + '.' + NAMESPACE, goToNextSlide);
        self.el.addEventListener(PREV_DIRECTION_NAME + '.' + NAMESPACE, goToPrevSlide);

        self.buttons = [NEXT_DIRECTION_NAME, PREV_DIRECTION_NAME].map(function(direction) {
          var button = document.createElement('button');

          button.setAttribute('name', direction);

          button.classList.add(SLIDSHOW_BUTTONS_CLASS_NAME);
          button.classList.add(SLIDSHOW_BUTTONS_CLASS_NAME + '--' + direction);

          button.innerHTML = getButtonsTemplate(direction);

          button.addEventListener('click', function() {
            self.el.dispatchEvent(new Event(direction + '.' + NAMESPACE));
          });

          if(self.slidesToShow > 1){
            self.el.parentNode.appendChild(button);
          }
          

          enableOrDisableButton(button);

          return button;
        });

        self.isInit = true;

      };

      this._destroySlideshow = function(el) {

        if (!self.isInit) {
          return;
        }

        self.el.classList.remove(SLIDSHOW_ELEMENT_CLASS_NAME);

        self.el.removeEventListener(NEXT_DIRECTION_NAME + '.' + NAMESPACE, self.nextSlide);
        self.el.removeEventListener(PREV_DIRECTION_NAME + '.' + NAMESPACE, self.prevSlide);

        Array.prototype.forEach.call(self.buttons, function(button) {
          button.remove();
        });

        self.isInit = false;

      };

    },

    unbind: function(el) {
      this._destroySlideshow(el);
    },

    routine: function(el, value) {
      value == true ? this._createSlideshow(el) : this._destroySlideshow(el);
    }

  };

  tinybind.binders['cart-add'] = {
    bind: function(el) {

      var self = this;

      this.callback = function(variantId) {
        var variantId = self.variantId || el.dataset.variantId;
        var quantity = el.dataset.quantity || 1;
        var propertyInputs = document.querySelector('.cart-drawer-gift-inner[data-item="'+variantId+'"]').getElementsByTagName('input');
        var properties = Array.prototype.map.call(propertyInputs, function(propertyInput) {
          if (propertyInput.name.indexOf('properties') == -1) {
            return false;
          }
          var properyName = propertyInput.name.replace('properties[', '').replace(']', '');
          var obj = {};
          obj[properyName] = propertyInput.value;
          return obj;
        });
        properties = _.assign.apply(_, properties);
        el.classList.add('loading');
        CartJS.addItem(variantId, quantity, properties, {
          "success": function(data, textStatus, jqXHR) {
               el.classList.remove('loading');
          },
          "error": function(jqXHR, textStatus, errorThrown) {
              alert('Error: ' + errorThrown + '!');
          }
        });
      };

      el.addEventListener('click', this.callback);
    },

    unbind: function(el) {
      el.removeEventListener('click', this.callback);
    },

    routine: function(el, value) {
      this.variantId = value;
    }
  };

  tinybind.binders['cart-remove'] = {
    bind: function(el) {

      var self = this;

      this.callback = function(variantId) {
        var variantId = self.variantId || el.dataset.variantId;

        var lineItemInCart = document.querySelector('#cart-drawer-item-'+variantId +' .cart-item-remove');
        var lineItemIndex = lineItemInCart.dataset.cartRemove;

        el.classList.add('loading');
        CartJS.removeItem(lineItemIndex);
      };

      el.addEventListener('click', this.callback);
    },

    unbind: function(el) {
      el.removeEventListener('click', this.callback);
    },

    routine: function(el, value) {
      this.variantId = value;
    }
  };

  tinybind.binders['product-grid-item'] = function(el, product) {
    var gridIndex = el.dataset.index;
    var animateIn = typeof el.dataset.animateIn != 'undefined' ? el.dataset.animateIn : true;
    var options = {
      animateIn: animateIn == 'true' ? true : false
    };
    new theme.ProductGridItem(el, product, gridIndex, options);
  };

  tinybind.binders.transformx = function(el, value) {
    el.style[theme.utils.getCSSProperty('transform')] = 'translateX(' + value + ')';
  };

  tinybind.binders['scroll-to'] = function(el, value) {
    var parent;

    if (value) {
      parent = el.parentElement;
      $(parent).scrollTo(el, {
          duration: 500,
          interrupt: !isMobile.apple.device,
          offset: -20
      });
    }
  };

}

/*============================================================================
  Selected Variant Cache 
==============================================================================*/
window.theme = window.theme || {};

theme.current.selected = theme.current.selected || [];

theme.SelectedVariantCache = (function() {

  var defaults = {
    quantity: 1
  };

  function SelectedVariantCache(variantId) {

    if (!variantId) {
      return false;
    }

    this.id = variantId;
    this.quantity = defaults.quantity;

    this.quantitySelectors = [];

    this._restore();
    theme.current.selected.push(this);

    return this;

  }

  SelectedVariantCache.prototype = _.extend({}, SelectedVariantCache.prototype, {

    add: function() {

      this.quantity += 1;
      this._save();
      this._updateQuantitySelectors();

    },

    subtract: function() {

      this.quantity -= 1;
      this._save();
      this._updateQuantitySelectors();

    },

    set: function(value) {

      if (this.quantity == value) { 
        return;
      }

      this.quantity = value;
      this._save();
      this._updateQuantitySelectors();

    },

    addQuantitySelector: function(quantitySelector) {
      
      var self = this;

      $(quantitySelector.inputEl).on('valueUpdated', function(event, value) {
        self.set(value);
      });

      this.quantitySelectors.push(quantitySelector);
      this._updateQuantitySelectors();
    },

    _updateQuantitySelectors: function() {

      var self = this;
      _.each(this.quantitySelectors, function(quantitySelector) {
        quantitySelector.set(self.quantity);
      });

    },

    _save: function() {

      var dataJSON,
          data,
          variantIndex,
          variantData;

      dataJSON = sessionStorage.getItem('selected-variant-cache');
      data = (dataJSON ? JSON.parse(dataJSON) : []);

      variantIndex = _.findIndex(data, {'id': this.id });

      variantData = {
        id: this.id,
        quantity: this.quantity,
      };

      if (variantIndex > -1) {
        data[variantIndex] = variantData;
      } else {
        data.push(variantData);
      }

      sessionStorage.setItem('selected-variant-cache', JSON.stringify(data));

    },

    _restore: function() {

      var dataJSON,
          data,
          variantIndex,
          variantData;

      dataJSON = sessionStorage.getItem('selected-variant-cache');
      data = (dataJSON ? JSON.parse(dataJSON) : []);

      variantData = _.find(data, {'id': this.id });

      if (variantData) {
        this.set(variantData.quantity);
      }

    }

  });

  return SelectedVariantCache;
})();


window.theme = window.theme || {};
window.theme.drawers = window.theme.drawers || {};
/*============================================================================
  Drawer modules
==============================================================================*/
theme.Drawers = (function() {

  if ('Hammer' in window && isMobile.any) {
    theme.pageSwipeObject = new Hammer.Manager(document.getElementById('PageContainer'), {
      touchAction: 'auto',
      inputClass: Hammer.SUPPORT_POINTER_EVENTS ? Hammer.PointerEventInput : Hammer.TouchMouseInput,
      recognizers: [
        [Hammer.Swipe, {
          direction: Hammer.DIRECTION_HORIZONTAL
        }]
      ]
    });

    theme.pageSwipeObject.on('swiperight', function(evt) {
      if ($('body').hasClass('js-drawer-open-right')) {
        var $drawer = $('.drawer.drawer--right');
        theme[$drawer.attr('id')].close();
        return;
      }

      var $drawer = $('.drawer.drawer--left');
      if (!$drawer.length) {
        return;
      }
      var delta_x = evt.deltaX;
      var final_x = evt.srcEvent.pageX || evt.srcEvent.screenX || 0;
      var startPosition = final_x - delta_x;
      if (startPosition >= 0 && startPosition <= 25) {
        theme[$drawer.attr('id')].open();
      }
      return false;
    });

    theme.pageSwipeObject.on('swipeleft', function(evt) {
      if ($('body').hasClass('js-drawer-open-left')) {
        var $drawer = $('.drawer.drawer--left');
        theme[$drawer.attr('id')].close();
        return;
      }

      var $drawer = $('.drawer.drawer--right');
      if (!$drawer.length) {
        return;
      }

      return;  // Do not open ajax cart with swipe right

      var delta_x = evt.deltaX;
      var final_x = evt.center.x || 0;
      var startPosition = final_x + -delta_x;
      var windowWidthOffset = $(window).width() - 25;
      if (startPosition >= windowWidthOffset) {
        theme[$drawer.attr('id')].open();
      }
      return false;
    });
  }
  
  function Drawer(id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position,
      pageContentSelector: '#PageContent',
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.nodes = {
      $parent: $('html').add('body'),
      $page: $(this.config.pageContentSelector)
    };

    this.$drawer = $('#' + id);

    this.$drawer.addClass('drawer--' + position);

    if (!this.$drawer.length) {
      return false;
    }

    theme.drawers[id] = this;

    this.drawerIsOpen = false;
    this.init();
  }

  Drawer.prototype.init = function() {
    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$drawer.on('click', this.config.close, $.proxy(this.close, this));
    $('.PageOverlay').on('click', $.proxy(this.close, this));
  };

  Drawer.prototype.closeAllDrawers = function(evt) {
    // Close all drawers
    _.forEach(theme.drawers, function(drawer) {
      if (drawer.drawerIsOpen) {
        drawer.close();
      }
    });
  };

  Drawer.prototype.open = function(evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    $('.PageOverlay').addClass('is-visible');


    // Without this, the drawer opens, the click event bubbles up to nodes.$page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    this.closeAllDrawers();

    // Run function when draw opens if set
    if (this.config.beforeDrawerOpen && typeof this.config.beforeDrawerOpen === 'function') {
      // if (!externalCall) {
        this.config.beforeDrawerOpen(this);
      // }
    }

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$drawer.prepareTransition();
    this.$drawer.addClass('is-open');

    this.nodes.$parent.addClass(this.config.openClass + ' ' + this.config.dirOpenClass);
    this.drawerIsOpen = true;

    theme.utils.lockPageScroll(this.$drawer.find('.enable-scroll-xs'));

    // Set focus on drawer
    slate.a11y.trapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });

    // Run function when draw opens if set
    if (this.config.onDrawerOpen && typeof this.config.onDrawerOpen === 'function') {
      if (!externalCall) {
        this.config.onDrawerOpen(this);
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    this.bindEvents();

    return this;
  };

  Drawer.prototype.close = function() {
    if (!this.drawerIsOpen) { // don't close a closed drawer
      return;
    }

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    $('.PageOverlay').removeClass('is-visible');
    // Ensure closing transition is applied to moved elements, like the nav
    this.$drawer.prepareTransition();
    this.$drawer.removeClass('is-open');

    this.nodes.$parent.removeClass(this.config.dirOpenClass + ' ' + this.config.openClass);

    this.drawerIsOpen = false;

    theme.utils.unlockPageScroll();

    // Remove focus on drawer
    slate.a11y.removeTrapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });

    // Run function when draw opens if set
    if (this.config.onDrawerClose && typeof this.config.onDrawerClose === 'function') {
      this.config.onDrawerClose();
    }

    this.unbindEvents();
  };

  Drawer.prototype.bindEvents = function() {
    this.nodes.$parent.on('keyup.drawer', $.proxy(function(evt) {
      // close on 'esc' keypress
      if (evt.keyCode === 27) {
        this.close();
        return false;
      } else {
        return true;
      }
    }, this));

    // Lock scrolling on mobile
    // this.nodes.$page.on('touchmove.drawer', function() {
    //   return false;
    // });

    this.nodes.$page.on('click.drawer', $.proxy(function() {

      if (!this.$drawer[0].contains(event.target)) {
        this.close();
      }

    }, this));
  };

  Drawer.prototype.unbindEvents = function() {
    this.nodes.$page.off('.drawer');
    this.nodes.$parent.off('.drawer');
  };

  Drawer.prototype.getProperties = function() {
    var header, headerLowerHeight, offsetTop;

    if (document.body.classList.contains('show-product-sticky')) {
      var productSticky = document.querySelector('.product-sticky');
      offsetTop = theme.utils.getBottomOffsetFromViewportTop(productSticky);
    } else if (document.body.classList.contains('show-header-lower')) {
      var headerLower = document.querySelector('.site-header-lower');
      offsetTop = theme.utils.getBottomOffsetFromViewportTop(headerLower);
    } else {
      // Calc height of visible header elements
      header = document.querySelector('.header');
      offsetTop = theme.utils.getBottomOffsetFromViewportTop(header);
    }

    return {
      top: Math.floor(offsetTop) + 'px',
      height: 'calc(100% - ' + Math.floor(offsetTop) + 'px)',
    };
  };

  return Drawer;
})();


/*============================================================================
 Cart Upsell Products Slider
==============================================================================*/

theme.CartUpsell = (function() {

  var selectors = {
    dataJsonContainer: '[data-cart-upsell-products]',
    slider: '.slider'
  };

  function CartUpsell(container,forceLoad) {
    this.container = container;

    if (!this.container) {
      return;
    }

    this.cartUpsell = { 
      products: []
    };

    this._getProducts(forceLoad);
  }

  CartUpsell.prototype = _.extend(CartUpsell.prototype, {

    ajaxUpsellProduct: async function(handle){
      
      return new Promise(function(resolve, reject) {

      $.get(handle, function(data) {

        if (data){
          var upsellProduct = JSON.parse(data);
          return resolve(upsellProduct);
        
        } else {
          reject();
          }
        })
      })
    },

    update: function(cart){
      var self = this;

      self._getProducts(false,cart, true);
    },


    buildProductButton: function(upsellProduct){
      var self = this;
      var html = ''
      var viewMoreOnly = false;


      var promotionalItem = false;
      var promotionsCustomer = false;
      var viewMoreOnly = false;
      var productType = upsellProduct.product_type;
      var isMembershipProduct = false;
      
      if(productType == 'Membership' || productType == 'membership'){
        isMembershipProduct = true;
        if (!window.shop.customer.is_logged_in) {
          viewMoreOnly = true; //use consultant kit rules to show more info and not add to cart
        }
      }

      if(upsellProduct.tags.indexOf('view-more-only') > -1){
        viewMoreOnly = true;
      }
      
      
      if (upsellProduct.metafields.promotions  && upsellProduct.metafields.details > 0){
        var promotionMetafield = upsellProduct.metafields.promotions.members_only;
        if(promotionMetafield && promotionMetafield.length > 0){
          var promotionalItem = true;
        }
        var consultantKitMetafield = upsellProduct.metafields.details.kit_product;
        if(consultantKitMetafield && consultantKitMetafield.length > 0){
          viewMoreOnly = true;
        }
      }
      
      var outputProperties = [
        {
          name: '_offer',
          prefix: 'Offer|'
        },
        {
          name: '_members_only',
          prefix: 'Members Only'
        },
        {
          name: '_category',
          prefix:'Category|'
        },
        {
          name: '_promotion_id',
          prefix: 'Promotion ID|'
        },
        {
          name: '_kit_product',
          prefix:'Kit Product'
        },
        {
          name: '_membership_product',
          prefix:'Membership Product'
        },
        {
          name: '_access_type',
          prefix: 'Access Type|'
        }
      ];


      outputProperties.push({
        name: '_price',
        value: Shopify.formatMoney( upsellProduct.price ).toString()
      });

      outputProperties.push({
        name: '_product_type',
        value: upsellProduct.type
      });
      
      var productProperties = ' data-properties_promotion_id="{{_promotion_id}}"'
        +' data-properties_access_type="{{_access_type}}"'
        +' data-properties_members_only="{{_members_only}}"'
        +' data-properties_offer="{{_offer}}"'
        +' data-properties_category="{{_category}}"'
        +' data-properties_membership_product="{{_membership_product}}"'
        +' data-properties_kit_product="{{_kit_product}}"'
        +' data-properties_price="{{_price}}"'
        +' data-properties_product_type="{{_product_type}}"';
      
      if (upsellProduct.metafields) {
        var maxQuantity = upsellProduct.metafields.max_qty_promotion ? upsellProduct.metafields.max_qty_promotion.quantity : "";
        var minSpend = upsellProduct.metafields.min_spend_promotion ? upsellProduct.metafields.min_spend_promotion.price : "";
      
        if(maxQuantity && maxQuantity.length > 0){
          productProperties += ' data-properties_max_quantity="'+maxQuantity.value+'"';
          productProperties += ' data-properties_hide_quantity="true"';
        }
        
        if(minSpend && minSpend.length > 0){
          productProperties += ' data-properties_min_spend="'+minSpend.value * 100+'"';
        }
      
      }
      
      for (var i = 0; i < outputProperties.length; i++) {
        var value = outputProperties[i];
        for (var k = 0; k < upsellProduct.tags.length; k++) {
          var tag = upsellProduct.tags[k];
          if(tag.indexOf(value.prefix) > -1){
            if (tag.indexOf('|') > -1) {
              outputProperties[i].value = tag.split('|')[1];
            }
            else {
              outputProperties[i].value = true;
            }
          }
        }
      }

      for (var i = 0; i < outputProperties.length; i++) {
        var name = outputProperties[i].name;
        var value = outputProperties[i].value || '';
        
        var replaceString = '{{'+name+'}}';
        productProperties = productProperties.replace(replaceString,value);
      }
      
      if (window.shop.customer && window.shop.customer.promotions_customer ) {
        var promotionsCustomer = true;
      }
      else if(window.shop.customer.promotions_customer_live){
        var promotionsCustomer = true;
      }
      
      if(promotionsCustomer && isMembershipProduct){
        viewMoreOnly = true; //use consultant kit rules to show more info and not add to cart
      }
      
      if (!upsellProduct.available) {
        html += '<a class="Heading Button Button--secondary cart-loader" href="' + upsellProduct.url +'">' + window.languages.productSoldOut + '</a>';
      } else if (viewMoreOnly) {
        html += '<a class="Heading Button Button--secondary cart-loader" href="' + upsellProduct.url +'">' + window.theme.strings.productViewMore + '</a>';
      } else if (upsellProduct.variants.length > 1) {
        html += '<a class="Heading Button Button--secondary cart-loader" href="' + upsellProduct.url +'">' + window.theme.strings.productMoreAvailable + '</a>';
      } else if (promotionalItem && !promotionsCustomer) {
        html += '<a class="Heading Button Button--secondary cart-loader" href="' + upsellProduct.url +'" style="padding: 0.5rem;margin: 0.5rem;">'+ window.theme.strings.productRestricted + '</a>';
      } else {
        html += '<button class="Heading Button Button--secondary cart-loader" data-opens-cart-drawer="true" data-displays-success="true" data-success-text="Added %icon.checkmark%" '+productProperties+' data-cart-add="' + upsellProduct.variants[0].id + '">';
        html += window.theme.strings.productQuickAdd;
        html += '</button>';
      }

      return html;
    },

    showHideSlider: function(){
      // let productsToLoad = 1;
      // productsToLoad--;
      // if(productsToLoad == 0){
      //   if(self.cartUpsell.products.length <= 0){
      //     console.log('No upsell products available, cart upsell slider removed.');
      //     $('.cart-drawer__section').remove();
      //   }
      // }
    },

    getProductViaHandle: async function(handle){
      var self = this;

      return new Promise(function(resolve, reject) {

        $.get('/products/' + handle + '?view=json', function(data) {

          if(data){
            var upsellProduct = JSON.parse(data);

            var product = new theme.Product(upsellProduct);

            return resolve(product);
          }
          else {
            reject()
          }
          
        });

        

      });
    },

    loadRecommendedProducts: async function(productID){
      
      return new Promise(function(resolve, reject) {

        var ajaxUrl = "/recommendations/products.json?product_id=" + productID

        $.getJSON(ajaxUrl, function(recommended){
            var results = recommended.products;

            if(results){
              return resolve(results);
            }
            else {
              reject();
            }
            
        })
      })
    },

    findValidProduct: function(results){
      var self = this;

      var validProduct = null;
      
      let cartItemIds = self.cart.items.map(function(item){
        return item.id;
      })

      for (var a = 0; a < results.length; a++) {
        let canPurchase = true;
        var product = results[a];
        
        if (cartItemIds.indexOf(product.id) > -1) {
          canPurchase = false;
        }
        else {

          for (var c = 0; c < product.tags.length; c++) {
            var tag = product.tags[c];
          
            if (tag.includes("Access Type|")) {
              var type = tag.split("|")[1];
              canPurchase = self.checkCustomerAccessType(type);
            } else {
              canPurchase = true;
            }

            if (tag.indexOf('Kit Product') > -1){
              canPurchase = false;
            }

            if (tag.indexOf('view-more-only') > -1){
              canPurchase = false;
            }
          }

        }
        if (['Membership','menbership'].indexOf(product.type) > -1 ){
          canPurchase = false;
        }

        if (canPurchase){
          validProduct = product;
          break;
        }

      }

      return validProduct;
    },

    checkCustomerAccessType: function(type){
      var canPurchase = false;
      var access_tiers = ''
    
      if (type == 'bronze-and-up') {
        access_tiers = 'bronze,silver,gold';
      } else if (type == 'silver-and-up') {
        access_tiers = 'silver,gold';
      } else if (type == 'gold-only') {
        access_tiers = 'gold';
      } else {
        access_tiers = '';
      }
    
      if(access_tiers.length > 0){
        if (access_tiers.indexOf(window.shop.customer.loyalty_tier) > 0){
          canPurchase = true
        }
      }

      return canPurchase;
    },


    buildRecommendedProductButton: function(upsellProduct){
      var self = this;
      var html = ''
      var viewMoreOnly = false;


      var promotionalItem = false;
      var promotionsCustomer = false;
      var viewMoreOnly = false;
      var productType = upsellProduct.product_type;
      var isMembershipProduct = false;
      
      if(productType == 'Membership' || productType == 'membership'){
        isMembershipProduct = true;
        if (!window.shop.customer.is_logged_in) {
          viewMoreOnly = true; //use consultant kit rules to show more info and not add to cart
        }
      }

      if(upsellProduct.tags.indexOf('view-more-only') > -1){
        viewMoreOnly = true;
      }
      
      
      if (upsellProduct.metafields.promotions  && upsellProduct.metafields.details > 0){
        var promotionMetafield = upsellProduct.metafields.promotions.members_only;
        if(promotionMetafield && promotionMetafield.length > 0){
          var promotionalItem = true;
        }
        var consultantKitMetafield = upsellProduct.metafields.details.kit_product;
        if(consultantKitMetafield && consultantKitMetafield.length > 0){
          viewMoreOnly = true;
        }
      }
      
      var outputProperties = [
        {
          name: '_offer',
          prefix: 'Offer|'
        },
        {
          name: '_members_only',
          prefix: 'Members Only'
        },
        {
          name: '_category',
          prefix:'Category|'
        },
        {
          name: '_promotion_id',
          prefix: 'Promotion ID|'
        },
        {
          name: '_kit_product',
          prefix:'Kit Product'
        },
        {
          name: '_membership_product',
          prefix:'Membership Product'
        },
        {
          name: '_access_type',
          prefix: 'Access Type|'
        }
      ];


      outputProperties.push({
        name: '_price',
        value: Shopify.formatMoney( upsellProduct.price ).toString()
      });

      outputProperties.push({
        name: '_product_type',
        value: upsellProduct.type
      });
      
      var productProperties = ' data-properties_promotion_id="{{_promotion_id}}"'
        +' data-properties_access_type="{{_access_type}}"'
        +' data-properties_members_only="{{_members_only}}"'
        +' data-properties_offer="{{_offer}}"'
        +' data-properties_category="{{_category}}"'
        +' data-properties_membership_product="{{_membership_product}}"'
        +' data-properties_kit_product="{{_kit_product}}"'
        +' data-properties_price="{{_price}}"'
        +' data-properties_product_type="{{_product_type}}"';
      
      if (upsellProduct.metafields) {
        var maxQuantity = upsellProduct.metafields.max_qty_promotion ? upsellProduct.metafields.max_qty_promotion.quantity : "";
        var minSpend = upsellProduct.metafields.min_spend_promotion ? upsellProduct.metafields.min_spend_promotion.price : "";
      
        if(maxQuantity && maxQuantity.length > 0){
          productProperties += ' data-properties_max_quantity="'+maxQuantity.value+'"';
          productProperties += ' data-properties_hide_quantity="true"';
        }
        
        if(minSpend && minSpend.length > 0){
          productProperties += ' data-properties_min_spend="'+minSpend.value * 100+'"';
        }
      
      }
      
      for (var i = 0; i < outputProperties.length; i++) {
        var value = outputProperties[i];
        for (var k = 0; k < upsellProduct.tags.length; k++) {
          var tag = upsellProduct.tags[k];
          if(tag.indexOf(value.prefix) > -1){
            if (tag.indexOf('|') > -1) {
              outputProperties[i].value = tag.split('|')[1];
            }
            else {
              outputProperties[i].value = true;
            }
          }
        }
      }

      for (var i = 0; i < outputProperties.length; i++) {
        var name = outputProperties[i].name;
        var value = outputProperties[i].value || '';
        
        var replaceString = '{{'+name+'}}';
        productProperties = productProperties.replace(replaceString,value);
      }
      
      if (window.shop.customer && window.shop.customer.promotions_customer ) {
        var promotionsCustomer = true;
      }
      else if(window.shop.customer.promotions_customer_live){
        var promotionsCustomer = true;
      }
      
      if(promotionsCustomer && isMembershipProduct){
        viewMoreOnly = true; //use consultant kit rules to show more info and not add to cart
      }
      
      if (!upsellProduct.available) {
        html += '<a class="Heading Button Button--secondary cart-loader" href="' + upsellProduct.url +'">' + window.languages.productSoldOut + '</a>';
      } else if (viewMoreOnly) {
        html += '<a class="Heading Button Button--secondary cart-loader" href="' + upsellProduct.url +'">' + window.theme.strings.productViewMore + '</a>';
      } else if (upsellProduct.variants.length > 1) {
        html += '<a class="Heading Button Button--secondary cart-loader" href="' + upsellProduct.url +'">' + window.theme.strings.productMoreAvailable + '</a>';
      } else if (promotionalItem && !promotionsCustomer) {
        html += '<a class="Heading Button Button--secondary cart-loader" href="' + upsellProduct.url +'" style="padding: 0.5rem;margin: 0.5rem;">'+ window.theme.strings.productRestricted + '</a>';
      } else {
        html += '<button class="Heading Button Button--secondary cart-loader" data-opens-cart-drawer="true" data-displays-success="true" data-success-text="Added %icon.checkmark%" '+productProperties+' data-cart-add="' + upsellProduct.variants[0].id + '">';
        html += window.theme.strings.productQuickAdd;
        html += '</button>';
      }

      return html;
    },


    _getProducts: async function(forceLoad, cart, clearArray) {
      var self = this;

      if (clearArray) {
        self.cartUpsell.products = [];
      }

      var ajaxUpsell = document.querySelector("#upsell-products-section");
      useRecommendedProducts = ajaxUpsell.getAttribute("data-ajax-recommended");
      var isOpen = !forceLoad ? document.querySelector('.is-open.cart-drawer') : true

      if (useRecommendedProducts == "true" && isOpen || useRecommendedProducts == "true" && cart){
        self.cart = cart || await self.getCart();

        if(self.cart.items.length > 0){
          self.cartUpsell.products = []
          var productID = self.cart.items[0].product_id;

          var results = await self.loadRecommendedProducts(productID);
    
          if(results){
            var validProduct = self.findValidProduct(results);
  
            if (validProduct) {
              validProduct.featured_image.src = validProduct.featured_image.replace('_{width}x','');
  
              var handle = '/products/' + validProduct.handle + '?view=json'
              var productData = await self.ajaxUpsellProduct(handle);
  
              product = new theme.Product(productData);
              product.actionsHtml = self.buildRecommendedProductButton(product);
  
              // Check if product already exists in the array
              var productExists = self.cartUpsell.products.some(function(p) {
                return p.id === product.id;
              });

              // If product doesn't exist, add it to the array
              if (!productExists) {
                self.cartUpsell.products.push(product);
              }
            }
          }
        }        
        
      } else {
        
        var upsellProductsData = document.querySelector(selectors.dataJsonContainer);

        if(upsellProductsData){
          var upsellProductsJson = JSON.parse(upsellProductsData.innerHTML);

          for (var i = upsellProductsJson.length - 1; i >= 0; i--) {
            
            var handle = upsellProductsJson[i];

            var product = await self.getProductViaHandle(handle);

            if (product) {
              product.actionsHtml = self.buildProductButton(product);
              
              // Check if product already exists in the array
              var productExists = self.cartUpsell.products.some(function(p) {
                return p.id === product.id;
              });

              // If product doesn't exist, add it to the array
              if (!productExists) {
                self.cartUpsell.products.push(product);
              }
            }
          }
          
        }
      }

      window.shop.cartUpsell.products = self.cartUpsell.products;
    },

    getCart: async function(){
      var self = this;
      
       return new Promise(function(resolve, reject) {

        $.getJSON('/cart.js', function(cart) {
          if(cart){
            return resolve(cart);
          }else {
            reject();
          }
        });

      });
 
    }
    
  });

  return CartUpsell;
})();


theme.CartGifts = (function() {

  var selectors = {
    dataJsonContainer: '[data-cart-gifts-json]'
  };

  var cache = {};

  function CartGifts(container) {
    this.container = container;
    this.namespace = '.cartGifts';

    if (!this.container) {
      return;
    }


    this.cartGifts = this._getCartGifts();
    this.progressBar = {};
    window.shop.cartGifts.progressBar.hide = false;

    this._bindCartEventListener();

  }

  CartGifts.prototype = $.extend({}, CartGifts.prototype, {

    _formatProgressGifts: function() {

      var i = this.cartGifts.length, cartGift;

      while(i--) {
        cartGift = this.cartGifts[i];


        if (cartGift.cart_gift_type == 'cart-price-min') {
          cartGift.position_percent = Math.max(Math.min((cartGift.minimum_cart_price - this.progressBar.lowerLimit) / (this.progressBar.upperLimit - this.progressBar.lowerLimit) * 100, 100), 0);
          if (window.shop.cartGifts.progressBar.giftMarkers.indexOf(cartGift) == -1) {
            window.shop.cartGifts.progressBar.giftMarkers.push(cartGift);
          }
        }

      }

    },

    _bindCartEventListener: function() {
      $(document).on('cart.requestComplete' + this.namespace + ' cart.ready' + this.namespace, this._run.bind(this));

      // Force CartJS reload
      CartJS.getCart({success: function() { } });

    },

    _run: function(event, cart) {
      var self = this;

      cache.cart = cart;

      let customerHasAccess = false;
      let customerLoyaltyTier = window.shop.customer.loyalty_tier;
      this.settings.access = [];

      Object.keys(this.settings).map((item)=>{
        if (this.settings[item]){
          this.settings.access.push(item);
        }
      })
    
      if (customerLoyaltyTier && customerLoyaltyTier.length > 0){
        if (this.settings.access.includes(customerLoyaltyTier)){
          customerHasAccess = true;
        }
      }
      else {
        if (this.settings.access.includes('guest')){
          customerHasAccess = true;
        }
      }

      theme.PromotionsCustomerCheck.prototype.checkCart(cart);
      
      if (this.settings.access.includes('silver') && window.shop.customer.promotions_customer_live){
        customerHasAccess = true;
      }

      if (!customerHasAccess){
        window.shop.cartGifts.progressBar.hide = true;
        console.log('customer does not qualify for mystery packs');
        return;
      }
      else {
        window.shop.cartGifts.progressBar.hide = false;
      }
      // Reset options
      window.shop.cartGifts.giftOptions = [];
      window.shop.cartGifts.selected = [];

      if(self.preloadedProducts && self.preloadedProducts.length){
        self._setCartGiftProducts();
        self._addEligibleCartGiftsToCart();
        self._findNextEligibleCartGift();
        self._updateProgressBar();
        self._formatProgressGifts();
        // self._buildSuccessMessage();
      }
      else {
        this._loadCartGiftProducts();
      }
      
    },

    _setCartGiftProducts: function(){
      var self = this;
        
      for (var i = 0; i < this.cartGifts.length; i++) {
        var cartGift = this.cartGifts[i];
        var products = cartGift.options;
        var disabledProducts = [];
        products.forEach(function(product,index) {

          var update = self.preloadedProducts[product.product_handle];
          if(update.product.available){
            product.product = update.product;

            product.featured_image = update.featured_image;
            product.selected = update.selected;

            product.variant = update.variant;
            product.product_variant_id = update.product_variant_id;

            product.displayPrice = update.displayPrice;
            product.loading = false;
          }
          else {
            disabledProducts.push(index);
          }

        });

        if(disabledProducts.length > 0){
          _.pullAt(cartGift.options, disabledProducts);
        }

      }
      
    },

    _loadCartGiftProducts: function(callback){
      var self = this;

      self.preloadedProducts = [];
      
      var productsList = _.flatMap(this.cartGifts, 'options');
      productsToLoad = _.uniq(_.flatMap(productsList, 'product_handle'));
      var callsToMake = productsToLoad.length;

      productsToLoad.forEach(function(handle) {

        $.get('/products/' + handle + '?view=json', function(data) {
          var product = JSON.parse(data, 'shopify');

          option = {
            product: product,
          };
          
          option.variant = '';
          if (option.image) {
            option.featured_image = option.featured_image || option.image;
            delete option.image;
          }
          option.selected = 0;

          option.variant = option.product.variants[0];
          option.product_variant_id = option.variant.id;


          option.displayPrice = option.percentage < 100 && option.variant ? Math.round(option.variant.price * (option.percentage * 0.01)) : false;
          option.loading = false;

          
          self.preloadedProducts[handle] = option;

          MarkComplete();
        });
          

      });

      function MarkComplete(){
        callsToMake --;

        if(callsToMake == 0){
          self._setCartGiftProducts();
          self._addEligibleCartGiftsToCart();
          self._findNextEligibleCartGift();
          self._updateProgressBar();
          self._formatProgressGifts();
          // self._buildSuccessMessage();
        }
      }
    },

    _getVariantsToAdd: function() {
      var variantsToAdd = [];
      var i = cache.cart.items.length;
      while(i--) {
        lineItem = cache.cart.items[i];
        for (var propertyKey in lineItem.properties) {
          if (propertyKey.indexOf('_add-to-cart') > -1) {
            var variantToAdd = lineItem.properties[propertyKey].split(':');
            variantsToAdd.push({
              variantId: variantToAdd[0],
              quantity: variantToAdd[1],
            });
          }
        }
      }
      return variantsToAdd;
    },

    _addGiftsFromProperties: function() {
      var variantsToAdd = this._getVariantsToAdd();

      var variantsAdded = [], i = variantsToAdd.length, variantToAdd;

      while(i--) {
        variantToAdd = variantsToAdd[i];
        if (variantsAdded.indexOf(variantToAdd.variantId) > -1) {
          continue;
        }
        variantsAdded.push(variantToAdd.variantId);
        CartJS.addItem(variantToAdd.variantId, variantToAdd.quantity, { '_is_free_gift': 'true' });
      }

    },

    _buildSuccessMessage: function(currentCartGift) {


      var currentGift;
      
      var cartTotal = cache.cart.total_price;
      
      if(currentCartGift){
        cartTotal = cache.cart.total_price;
        var giftTotal = 0;
        for (var i = 0; i < currentCartGift.selected.length; i++) {
          giftTotal += currentCartGift.selected[i].price;
        }
        cartTotal = cartTotal - giftTotal;
      }

      for (var i = 0; i < this.cartGifts.length; i++) {
        cartGift = this.cartGifts[i];
        if(cartGift.minimum_cart_price <= cartTotal){
          currentGift = cartGift;
        }
      }

       // while(i--) {
       //   cartGift = this.cartGifts[i];
       //   if (cartGift.is_in_cart && cartGift.success_title) {
       //     successMessage = successMessage ? successMessage + ' and <strong>' + cartGift.success_title + '</strong>' : '<strong>' + cartGift.success_title + '</strong>';
       //   }
       // }

       // if (successMessage) {
       //   successMessage = window.shop.cartGiftRewardPrefix + ' ' + successMessage;
       // }

       // window.shop.cartGifts.successMessage = successMessage;
       // if (currentCartGift.is_in_cart){
       //  window.shop.cartGifts.successMessage = currentGift.success_title + ' ' + '<strong>' +currentGift.label + '</strong>' ;
       // }
       // else {

       // }
       window.shop.cartGifts.successMessage = currentGift.success_title + ' ' + '<strong>' +currentGift.label + '</strong>' ;

    },

    _updateProgressBar: function() {

     var i = this.cartGifts.length, cartGift, lowerLimitCartGiftPrice, upperLimitCartGiftPrice, limitPadding, totalPrice;

      while(i--) {
        cartGift = this.cartGifts[i];

        if (cartGift.cart_gift_type == 'cart-price-min') {
          if (!upperLimitCartGiftPrice || (upperLimitCartGiftPrice && upperLimitCartGiftPrice < cartGift.minimum_cart_price)) {
            upperLimitCartGiftPrice = parseInt(cartGift.minimum_cart_price);
          }
          if (!lowerLimitCartGiftPrice || (lowerLimitCartGiftPrice && lowerLimitCartGiftPrice > cartGift.minimum_cart_price)) {
            lowerLimitCartGiftPrice = parseInt(cartGift.minimum_cart_price);
          }
        }
      }

      limitPadding = upperLimitCartGiftPrice / 8;
      totalPrice = cache.cart.total_price;

      this.progressBar.upperLimit = upperLimitCartGiftPrice + limitPadding;
      this.progressBar.lowerLimit = Math.min(lowerLimitCartGiftPrice - limitPadding, Math.max(totalPrice - limitPadding, 0));
      this.progressBar.progressPercent = (totalPrice - this.progressBar.lowerLimit) / (this.progressBar.upperLimit - this.progressBar.lowerLimit) * 100;

      window.shop.cartGifts.progressBar.progressPercent = this.progressBar.progressPercent;

    },

    _findNextEligibleCartGift: function(currentCartGift) {


      var cartGift, nextCartGift;
      var cartTotal = cache.cart.total_price;
      
     
      if(currentCartGift){
        if (currentCartGift.cart_gift_type == 'reg-range'){
          var giftTotal = 0;

          for (var i = 0; i < cache.cart.items.length; i++) {
            if(cache.cart.items[i].product_type.toLowerCase() == currentCartGift.product_type_to_match.toLowerCase()){
              cartTotal += cache.cart.items[i].price * cache.cart.items[i].quantity;
            }
          }

        }
        else {
          cartTotal = cache.cart.total_price;
          var giftTotal = 0;
          for (var i = 0; i < currentCartGift.selected.length; i++) {
            giftTotal += currentCartGift.selected[i].price;
          }
          cartTotal = cartTotal - giftTotal;
        }
        
      }
      else {
        cartTotal = cache.cart.total_price;
        var giftTotal = 0;

        for (var i = 0; i < cache.cart.items.length; i++) {
          var item = cache.cart.items[i];
          if(item.properties['_mystery_pack']){
            giftTotal += (item.price * item.quantity);
          }
        }

        cartTotal = cartTotal - giftTotal;
      }

      var nextGifts = [];
      var nextPriceCartTotalDifferenceCents = 0;

      for (var i = 0; i < this.cartGifts.length; i++) {
        cartGift = this.cartGifts[i];
        if (cartGift.cart_gift_type == 'reg-range'){
          var cartTotal = 0;
          var giftTotal = 0;

          for (var i = 0; i < cache.cart.items.length; i++) {
            if(cache.cart.items[i].product_type.toLowerCase() == cartGift.product_type_to_match.toLowerCase()){
              cartTotal += cache.cart.items[i].price * cache.cart.items[i].quantity;
            }
          }

          if (cartGift.minimum_cart_price > cartTotal){
            nextPriceCartTotalDifferenceCents = cartGift.minimum_cart_price - cartTotal;
            nextGifts.push(cartGift);
          }

        }
        else if(cartGift.minimum_cart_price > cartTotal){
          nextGifts.push(cartGift);
        }

      }

      if(nextGifts.length){
        var nextCartGift = _.orderBy(nextGifts, ['minimum_cart_price'], ['asc'])[0];
      }
      
      
      if(nextCartGift){
         if (nextCartGift.cart_gift_type != 'reg-range'){
          nextPriceCartTotalDifferenceCents = nextCartGift.minimum_cart_price - cartTotal;
        }
      }

      this._setNextCartGift(nextCartGift,nextPriceCartTotalDifferenceCents);
      

    },

    _setNextCartGift: function(cartGift,difference) {

      if (cartGift) {
       
        cartGift.cart_cta_message_formatted = cartGift.cart_cta_message.replace('[price]', Shopify.formatMoney(difference)) + ' '+ '<strong>'+cartGift.label+'</strong>';
        window.shop.cartGifts.next = cartGift;
      }
      else {
        window.shop.cartGifts.next = '';
      }

      
    },

    _addEligibleCartGiftsToCart: function() {

      var i = this.cartGifts.length, cartGift, lineItemInCart, isEligible;
      var enabledCount = 0;
      while(i--) {
        cartGift = this.cartGifts[i];

        isInCart = cartGift.isIncart(cache.cart);
        isEligible = cartGift.isEligible(cache.cart);

        if (isEligible && !isInCart) {
          if (cartGift.type == 'cart-gift-options' || cartGift.type == 'tier-gifts' || cartGift.type == 'reg-range' || cartGift.type == 'product-specific') {
            this._findNextEligibleCartGift(cartGift);
            this._displayGiftOffer(cartGift, cache.cart);
            enabledCount ++;
          } else {
            cartGift.addToCart(cache.cart);
            window.shop.cartGifts.strings = cartGift;
            // window.shop.cartGifts.strings.cart_cta_successmessage_formatted = cartGift.success_title + ' <strong>'+cartGift.label+'</strong>';
            enabledCount ++;
          }
        }

        if (isEligible) {
          cartGift.is_in_cart = true;
        } else {
          cartGift.is_in_cart = false;
        }

      }

      if(enabledCount == 0){
        window.shop.cartGifts.strings = {};
      }
    },

    _displayGiftOffer: function(cartGift, cart) {

      // if (window.shop.cartGifts.giftOptions.length) {
      //   return;
      // }

      var products = cartGift.options;
      if (cartGift.type == 'tier-gifts') {
        products = cartGift.options;
        // cartGift.loadTierProducts(products);
        
        window.shop.cartGifts.giftOptions = cartGift.options;
        window.shop.cartGifts.selected = cartGift.selected;
        window.shop.cartGifts.selectedCount = cartGift.selected.length;
        window.shop.cartGifts.slider = cartGift.options && cartGift.options.length > 0;
        window.shop.cartGifts.strings = cartGift;
        window.shop.cartGifts.max_selected = cartGift.max_selected;
        
        window.shop.cartGifts.strings.cart_cta_successmessage_formatted = cartGift.success_title +' <strong>'+cartGift.label+'</strong>';
      }
      else if (cartGift.type == 'reg-range') {
        products = cartGift.options;
        // cartGift.loadTierProducts(products);
        
        window.shop.cartGifts.giftOptions = cartGift.options;
        window.shop.cartGifts.selected = cartGift.selected;
        window.shop.cartGifts.selectedCount = cartGift.selected.length;
        window.shop.cartGifts.slider = cartGift.options && cartGift.options.length > 0;
        window.shop.cartGifts.strings = cartGift;
        window.shop.cartGifts.max_selected = cartGift.max_selected;
        
        window.shop.cartGifts.strings.cart_cta_successmessage_formatted = cartGift.success_title +' <strong>'+cartGift.label+'</strong>';
      }
      else if (cartGift.type == 'product-specific') {
        products = cartGift.options;
        cartGift.loadTierProducts(products);
        window.shop.cartGifts.giftOptions = cartGift.options;
        window.shop.cartGifts.slider = cartGift.options && cartGift.options.length > 0;
        window.shop.cartGifts.strings = cartGift;
        window.shop.cartGifts.max_selected = cartGift.max_selected;
        window.shop.cartGifts.selected = [];
        window.shop.cartGifts.strings.cart_cta_successmessage_formatted = cartGift.success_title + ' <strong>'+(cartGift.max_selected)+' '+cartGift.label+(cartGift.max_selected > 1 ? 's': '')+'</strong>';
        
      }
      else {
        cartGift.loadProducts(products);
        window.shop.cartGifts.giftOptions = cartGift.options;
        window.shop.cartGifts.slider = cartGift.options && cartGift.options.length > 0;
        window.shop.cartGifts.strings.cart_cta_successmessage_formatted = cartGift.success_title + ' <strong>'+cartGift.label+'</strong>';
        
      }

      
    },

    _getCartGifts: function() {
      var dataJsonContainer = this.container.querySelector(selectors.dataJsonContainer);

      if (!dataJsonContainer) {
        return;
      }

      this.data = JSON.parse(dataJsonContainer.innerHTML);
      this.settings = this.data.settings;
      return _.map(this.data.gifts, function(cartGift) {
        return new CartGift(cartGift);
      });
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      $(document).off(this.namespace);
    }
  });

  function CartGift(data) {
    _.extend(this, data);
    // this.tooltip = {
    //   content: data.tooltip_message,
    //   theme: 'light'
    // }

    if (data.type == 'cart-gift-options') {
      function Option(option) {
        _.extend(this, option);
      }
      this.options.map(function(option) {
        option.cart_gift_type = data.cart_gift_type;
        return new Option(option);
      });
    }

    // if (data.type == 'product-specific' || data.type == 'auto-specific' ) {
    //   $.get('/collections/' + this.collection_to_match + '?view=json', function(data) {
    //     collection = JSON.parse(data, 'shopify');
    //     this.products_to_match = collection;
    //   });
    // }
  }

  CartGift.prototype = $.extend({}, CartGift.prototype, {


    loadTierProducts: function(products) {
      var self = this;
      products.forEach(function(option) {

        if (option.loading) {
          return;
        }

        option.loading = true;

        $.get('/products/' + option.product_handle + '?view=json', function(data) {
          option.product = JSON.parse(data, 'shopify');

          option.variant = '';
          if (option.image) {
            option.featured_image = option.featured_image || option.image;
            delete option.image;
          }
          option.selected = 0;

          option.variant = option.product.variants[0];
          option.product_variant_id = option.variant.id;
          
          var inCartMatch = {};
          var cartVariants = [];
          for (var i = 0; i < cache.cart.items.length; i++) {
            var item = cache.cart.items[i];
            if(item.id == option.product_variant_id){
              if(item.quantity > 1){
                inCartMatch = item;
                for (var k = 0; k < item.quantity; k++) {
                  cartVariants.push(item.id);
                }
              }
              else {
                cartVariants.push(item.id);
              }
            }
          }
          Array.prototype.push.apply(window.shop.cartGifts.selected,cartVariants);
          window.shop.cartGifts.selectedCount = window.shop.cartGifts.selected.length;

          if (inCartMatch) {
            option.selected = inCartMatch.quantity;
          }
          // else if (window.shop.cartGifts.selected.indexOf(option.variant.id) > -1) {
          //   option.selected = 1;
          // }

          option.displayPrice = option.percentage < 100 && option.variant ? Math.round(option.variant.price * (option.percentage * 0.01)) : false;
          option.loading = false;
        });

      });

   
    },

    loadProducts: function(products) {

      products.forEach(function(option) {

        if (option.products || option.loading) {
          return;
        }

        option.loading = true;

        $.get('/products/' + option.product_handle + '?view=json', function(data) {
          option.product = JSON.parse(data, 'shopify');

          option.variant = '';
          for (var i = 0; i < option.product.variants.length; i++) {
           if(option.product.variants[i].id == parseInt(option.product_variant_id)){
            option.variant = option.product.variants[i];
           } 
          }
          

          option.displayPrice = option.percentage < 100 && option.variant ? Math.round(option.variant.price * (option.percentage * 0.01)) : false;
          option.loading = false;
        });

      });
    },


    getLineItemFromCart: function(cart, itemId) {

      var i = cart.items.length, item;
        while(i--) {
        if (cart.items[i].properties['_item_id'] && cart.items[i].properties['_item_id'] == itemId) {
          return cart.items[i];
        }
      }
      return;

    },

    getVariantFromCart: function(cart, itemId) {

      var i = cart.items.length, item;
        while(i--) {
        if (cart.items[i].id == itemId) {
          return cart.items[i];
        }
      }
      return;

    },

    removeFromCart: function(lineItem) {
      CartJS.removeItem(lineItem.line_number);
    },

    isIncart: function(cart) {
      var self = this;

      switch(this.type) {
        case 'cart-gift':

          return !!this.getLineItemFromCart(cart, this.item_id);
          break;

        case 'reg-range':
          var inCartMatch = {};
          var cartVariants = [];

          var products = this.options;

           products.forEach(function(option) {
            for (var i = 0; i < cache.cart.items.length; i++) {
              var item = cache.cart.items[i];
              if(item.id == option.variant.id){
                option.selected = item.quantity;
                if(item.quantity > 1){
                  for (var k = 0; k < item.quantity; k++) {
                    cartVariants.push(item);
                  }
                }
                else {
                  cartVariants.push(item);
                }
              }
            }
            
          });

          this.selected = cartVariants;
          this.selectedCount = this.selected.length;

          if (this.selectedCount <= this.max_selected) {
            return false;
          }
          return true;
          break;

        case 'tier-gifts':
          var inCartMatch = {};
          var cartVariants = [];

          var products = this.options;

           products.forEach(function(option) {
            for (var i = 0; i < cache.cart.items.length; i++) {
              var item = cache.cart.items[i];
              if(item.id == option.variant.id){
                option.selected = item.quantity;
                if(item.quantity > 1){
                  for (var k = 0; k < item.quantity; k++) {
                    cartVariants.push(item);
                  }
                }
                else {
                  cartVariants.push(item);
                }
              }
            }
            
          });

          this.selected = cartVariants;
          this.selectedCount = this.selected.length;

          if (this.selectedCount <= this.max_selected) {
            return false;
          }
          return true;
          break;

        case 'product-specific':

          var itemsMatchInCart = _.map(this.products_to_match, function(product) {
            return !!self.getLineItemFromCart(cart, product.variants[0].id);
          });

          return itemsMatchInCart.indexOf(true) > -1;
          break;

        case 'auto-specific':

          return !!self.getVariantFromCart(cart, parseInt(this.variant_id));

          break;

        case 'cart-gift-options':

          var itemsMatchInCart = _.map(this.options, function(product) {
            return !!self.getLineItemFromCart(cart, product.item_id);
          });

          return itemsMatchInCart.indexOf(true) > -1;
          break;

        case 'free-shipping':

          return !!this.getPropertyFromCart('_free_shipping', cart);
          break;

      }
    },

    getPropertyFromCart: function(property, cart) {

      var i = cart.items.length, item;
        while(i--) {
          if (cart.items[i].properties[property]) {
            return cart.items[i].properties[property];
          }
      }
      return;

    },

    isEligible: function(cart) {

      switch (this.cart_gift_type) {

        case 'cart-price-min':
          var cartTotal = cart.total_price;
          var giftTotal = 0;
          for (var i = 0; i < this.selected.length; i++) {
            giftTotal += this.selected[i].price;
          }
          cartTotal = cartTotal - giftTotal;
          
          var max_spend_rule = (this.maximum_cart_price > 0 ? cartTotal <= this.maximum_cart_price : true);
          return cartTotal >= this.minimum_cart_price && max_spend_rule;

        case 'reg-range':

          var cartTotal = 0;
          var giftTotal = 0;

          if (cart.items.length == 0) {
            return false;
          }

          for (var i = 0; i < cart.items.length; i++) {
            if(cart.items[i].product_type.toLowerCase() == this.product_type_to_match.toLowerCase()){
              cartTotal += cart.items[i].price * cart.items[i].quantity;
            }
          }

          var max_spend_rule = (this.maximum_cart_price > 0 ? cartTotal <= this.maximum_cart_price : true);
          return cartTotal >= this.minimum_cart_price && max_spend_rule;

        case 'tier-gifts':

          var cartTotal = cart.total_price;
          if (this.maximum_cart_price == 0) {
            return cartTotal >= this.minimum_cart_price
          }
          else {
            return cartTotal >= this.minimum_cart_price && cartTotal <= this.maximum_cart_price;
          }
        
        case 'product-specific':

          var variantsToMatch = this.variants_to_match;

          var cartMatchCount = 0;
          for (var i = 0; i < cart.items.length; i++) {
            if(variantsToMatch.indexOf(cart.items[i].variant_id.toString()) > -1){
              cartMatchCount += cart.items[i].quantity;
            }
          }

          this.max_selected = cartMatchCount >= 4 ? 4 : cartMatchCount;

          return cartMatchCount > 0;
          break;

        case 'auto-specific':

          var variantsToMatch = this.variants_to_match;

          var cartMatchCount = 0;
          for (var i = 0; i < cart.items.length; i++) {
            if(variantsToMatch.indexOf(cart.items[i].variant_id.toString()) > -1){
              cartMatchCount += cart.items[i].quantity;
            }
          }

          this.max_selected = cartMatchCount >= 4 ? 4 : cartMatchCount;

          return cartMatchCount > 0;
          break;

        case 'item-property':
          var i = cart.items.length, item;
            while(i--) {
            item = cart.items[i];
            if (item.properties && item.properties[this.eligibility_property]) {
              return true;
            }
          }
          return false;
      }

    },

    addToCart: function(cart) {
      var self = this;

      if (self.requestQueued) {
        return;
      }

      self.requestQueued = true;

      if (document.body.classList.contains('cart-loading')) {
        console.info('Cart is loading. Waiting before applying cart gift.');

        $(document).on('cart.requestComplete.' + self.item_id, function() {

          if (document.body.classList.contains('cart-loading')) {
            console.info('Still loading, waiting before applying cart gift.');
            return;
          }

          $(document).off('cart.requestComplete.' + self.item_id);
          apply();
        });

      } else {

        apply()

      }

      function apply() {
        console.info('Applying cart gift');

        switch (self.type) {

          case 'cart-gift':

            if (self.failureOnAdd) {
              console.error('failed to add to cart');
              return false;
            }

            var properties = {
              '_is_free_gift': self.cart_gift_type,
              '_item_id': self.item_id,
              '_group_id': self.group_id,
              '_hide_quantity': true
            }

            if (self.requires_product) {
              properties._requires_product = "true";
            }

            if (self.minimum_cart_price) {
              properties._min_price = self.minimum_cart_price;
            }

            CartJS.addItem(self.variant_id, 1, properties, {
              "error": function(jqXHR, textStatus, errorThrown) {
                  self.failureOnAdd = true;
                  self.requestQueued = false;
              },
              "success": function(jqXHR, textStatus, errorThrown) {
                  self.requestQueued = false;
              }
            });
            break;

          case 'auto-specific':

            if (self.failureOnAdd) {
              console.error('failed to add to cart');
              return false;
            }

            var properties = {
              '_is_free_gift': self.cart_gift_type,
              '_item_id': self.item_id,
              '_group_id': self.group_id,
              '_hide_quantity': true
            }

            if (self.requires_product) {
              properties._requires_product = "true";
            }

            if (self.minimum_cart_price) {
              properties._min_price = self.minimum_cart_price;
            }

            CartJS.addItem(self.variant_id, 1, properties, {
              "error": function(jqXHR, textStatus, errorThrown) {
                  self.failureOnAdd = true;
                  self.requestQueued = false;
              },
              "success": function(jqXHR, textStatus, errorThrown) {
                  self.requestQueued = false;
              }
            });
            break;
          

          case 'free-shipping':

            console.info('Applying free shipping');

            var firstLineItem = cart.items[0];

            if (!firstLineItem) {
              self.requestQueued = false;
              return;
            }

            var lineNumber = firstLineItem.line_number;
            var quantity = firstLineItem.quantity;
            var properties = firstLineItem.properties;

            properties['_free_shipping'] = self.item_id;

            CartJS.updateItem(lineNumber, quantity, properties);

            self.requestQueued = false;

            break;

          }
        }

      }

  })

  return CartGifts;
})();






/*============================================================================
  AJAX Cart 
==============================================================================*/
window.theme = window.theme || {};

theme.AjaxCart = (function() {
  var selectors = {
    addToCartBtn: '[type="submit"]',
    addToCartForm: 'form[action="/cart/add"]',
    cartCount: '.site-header__cart',
    cartToggle: '.cart__toggle',
    cartDrawer: '.cart-drawer',
    cartDrawerOpen: '.cart-drawer--open',
    cartDrawerTabs: '.cart-drawer__tabs',
  };

  var settings = {
    // 'aboveForm' for top of add to cart form, 
    // 'belowForm' for below the add to cart form, 
    // 'nextButton' for next to add to cart button and
    // 'afterBody' for after the main body content (used for fixed notifications).
    feedbackPosition: 'afterBody'
  };
  var options = {
    requestBodyClass: 'cart-loading',
    moneyFormat: window.shop.moneyFormat,
    moneyWithCurrencyFormat: window.shop.moneyWithCurrencyFormat,
    weightUnit: 'kg', // g, kg, oz, lb
    weightPrecision: 0,
    tinybindModels: {
      'customer': window.shop.customer,
      'cartGifts': window.shop.cartGifts,
      'cartUpsell': window.shop.cartUpsell,
      'dispatch': window.shop.dispatch,
      'methods': {
        updateQuantityFromSelect: function() {
          var quantity = this.options[this.selectedIndex].value;
          var line_number = this.dataset.lineIndex;
          CartJS.updateItem(line_number, quantity);
        },
        removePromotionItem: function() {
          console.log('remove item:', this);
          // var quantity = 0;
          // var line_number = this.dataset.lineIndex;
          // CartJS.updateItem(line_number, quantity);
        }
      }
    },
    errorHandling: {
      cartError: function() {
        $('.cart-loader.loading').removeClass('loading');
        if (this.description) {
          showFeedback('error', this.description);
        }
      }
    }
  };

  var cache = {
    previousCartItems: [],
    updatedItems: []
  };

  function init() {
    if (!$(selectors.cartDrawer).length) {
      return;
    }

    var $tabsGroup = $(selectors.cartDrawerTabs);
    $.each($tabsGroup, function(index, tabsGroup) {
      window.theme.tabsGroups[tabsGroup] = new theme.TabsGroup(tabsGroup, {
        breakpoint: 0
      });
    });

    $(document).on('click', '[data-add-to-cart], [data-cart-add], [data-cart-update], [data-cart-update-id], [data-cart-remove]', function(evt){
      var $this = $(this);
      var progressElementSelector = $this.data('progress-element');
      var $progressElement = progressElementSelector ? $(progressElementSelector) : $this;
      
      if (!$this.is('.disabled')) {
        if ($progressElement.length) {
          $progressElement.addClass('cart-loader loading');
        }

        if ($this.is('[data-opens-cart-drawer]')) {
          $('body').addClass('cart-loading--opens-drawer');
        }

        if ($this.is('[data-opens-cart-drawer]')) {
          $('body').addClass('cart-loading--opens-drawer');
        }

        if ($this.is('[data-displays-success]')) {
          $('body').addClass('cart-loading--trigger-displays-success');
          $(document).on('addToCartSuccess', function(event, cart) {
            $(document).off('addToCartSuccess');

            $this.height($this.height());

            var text = $this.data('success-text');
            text = text.replace('%icon.checkmark%', window.icons.checkmark)

            $this.attr('data-text', $this.html());
            $this.html(text);
            $this.addClass('Button--success')

            setTimeout(function() {
              $this.text($this.data('text'));
              $this.removeClass('Button--success');
              $this.height($this.height(''));
            }, 3000)

          })
        }

      } else {
        evt.preventDefault();
        evt.stopPropagation();

        $progressElement.addClass('error');
        window.setTimeout(function(){
          $progressElement.removeClass('error');
        }, 1500);

        var highlightElements = $this.data('enable-requirements');
        if (highlightElements) {
          theme.utils.flash(highlightElements);
        }
      }
    });
    
    initDrawer();

    $(selectors.cartDrawerOpen).on('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      openCartDrawer();
    });

    // tippy('.cart-drawer', { 
    //   target: '.cart-drawer-item__remove, .cart-drawer__close',
    //   theme: 'light',
    //   placement: 'left',
    //   animation: 'shift-away',
    //   arrow: true,
    //   offset: 0,
    //   distance: 5,
    // });

    CartJS.init(window.shop.cart, options);

    $('#cart-drawer-note, #cart-note').on('blur', function() {
      var note = $(this).val();
      if (note) {
        CartJS.setNote(note);
      } else {
        CartJS.setNote('');
      }
    });

    $('.cart-drawer__submit').click(async function(e){
      e.preventDefault();
      let skus=[];
      var line_item = document.querySelectorAll('.cart-drawer__content .cart-item');
      line_item.forEach(product => {
        skus.push(product.getAttribute('prod-sku'));
      })
      const data = await bulk_inventory_checkout(skus);
      if(!data){
        alert('Product Stocked Out');
        if(window.location.pathname.includes('products')){
            window.location.reload();
          }
      }else{
        window.location.href = '/checkout';
      }
    });

    $(document).on('cart.requestStarted', function(event, cart) {
      cache.previousCartItems = _.values(_.omit(cart.items, _.functions(cart.items)));
      
      if ('NProgress' in window) {
        NProgress.start();
      }
    });

    $(document).on('cart.requestComplete', function(event, cart) {
      if ('NProgress' in window) {
        NProgress.done();
      }
      
      $('.cart-loader.loading').removeClass('loading');

      // cache.updatedItems = theme.utils.difference(_.values(_.omit(cart.items, _.functions(cart.items))), cache.previousCartItems);
      // _.remove(cache.updatedItems, _.isEmpty);

      cache.updatedItems = cart.updatedLineItems;
      
      if (!cache.updatedItems.length && cart.items.length > 0) {
        // showFeedback('error', theme.strings.quantityUnavailable);
      }
      
      shop.cart = cart;

      if (theme.Favicon !== undefined) {
        if (cart.item_count > 0) {
          theme.Favicon.set(cart.item_count);
        } else {
          theme.Favicon.reset();
        }
      }

      var $body = $('body');

      var opensDrawer = $body.is('.cart-loading--opens-drawer');

      if ($body.is('.cart-loading--trigger-displays-success') && cache.updatedItems && cache.updatedItems.length) {
        $body.removeClass('cart-loading--trigger-displays-success');
        $(document).trigger('addToCartSuccess');
      }
      
      if (opensDrawer !== undefined && opensDrawer) {
        if ((theme.cartQueue === undefined || theme.cartQueue.length == 0) && theme.cartQueueProcessing == false) {
          if (!theme.CartDrawer.drawerIsOpen) {
            $body.removeClass('cart-loading--opens-drawer');
            
            openCartDrawer();

            _.each(cache.updatedItems, function(updatedItem) {
              var lineItem, previousItem;
              lineItem = _.find(cart.items, { 'id': updatedItem.id });

              if (lineItem) {
                previousItem = _.find(cache.previousCartItems, { 'id': lineItem.id });
              }

              if (!previousItem || lineItem.quantity > previousItem.quantity) {
               // showMiniCart(lineItem);
              }
              
            });

          }
        }
      }

      if (theme.CartDrawer.drawerIsOpen && cart.item_count < 1) {
        window.setTimeout(function() {
          theme.CartDrawer.close();
        }, 2500);
      }

      // Update selector caches
      for (var i = 0; i < theme.current.selected.length; i++) {
        // theme.current.selected[i].refreshCartQuantity();

        //to do
      }

    });
  }

  function showMiniCart(lineItem) {
    theme.MiniCart.show(lineItem);
  }

  function initDrawer() {
    $('#MainContent').addClass('drawer-page-content');
    $('.js-drawer-open-top').attr('aria-controls', 'CartDrawer').attr('aria-expanded', 'false');

    theme.CartDrawer = new theme.Drawers('CartDrawer', 'right', {
      onDrawerOpen: cartDrawerOpen,
      beforeDrawerOpen: function(drawer) {
        new theme.CartUpsell($('.cart-upsell-section')[0],true);
      }
    });

    // theme.CartDrawer.open();
  }

  function cartDrawerOpen() {
    // $(selectors.cartToggle).addClass(settings.cartDrawerOpen);
  }

  function cartDrawerClose() {
    // $(selectors.cartToggle).removeClass(settings.cartDrawerOpen);
  }

  function openCartDrawer() {

    // if (isMobile.any) {
    //   console.info('Navigating to cart page');
    //   window.location.href = '/cart';
    // } else {
      
    // }

    theme.CartDrawer.open();
    
  }

  function showFeedback(status, response, $addToCartForm) {
    $('.ajax-cart-feedback').remove();
    var feedback = '<div class="ajax-cart-feedback ' + status + '">' + response + '</div>';
    
    if ($addToCartForm !== undefined && $addToCartForm.length > 0) {
      switch (settings.feedbackPosition) {
        case 'aboveForm':
          $addToCartForm.before(feedback);
          break;
        case 'belowForm':
          $addToCartForm.after(feedback);
          break;
        case 'afterBody':
          $(document.body).append(feedback);
          break;
        case 'nextButton':
        default:
          $addToCartForm.find(selectors.addToCartBtn).after(feedback);
          break;
      }
    } else {
      iziToast.show({
        message: response,
        color: 'red',
        position: 'bottomCenter'
      });
    }
    
    var $feedbackElement = $('.ajax-cart-feedback');
    
    $feedbackElement.offset(); // redraw
    $feedbackElement.addClass('active');
    window.setTimeout(function(){
      $feedbackElement.removeClass('active');
    }, 6500);
  };

  return {
    init: init,
    openCartDrawer: openCartDrawer
  };
})();



theme.cartQueue = [];
theme.cartQueueProcessing = false;
theme.processCartQueue = function() {
  // If there's something in the queue, process it
  if (theme.cartQueue.length) {
    theme.cartQueueProcessing = true;
    var request = theme.cartQueue.shift();
    var requestType = request.type || 'add';

    if (requestType == 'add') {
      CartJS.addItem(request.variant_id, request.quantity, request.properties, {
        "success": function(data, textStatus, jqXHR) {
          theme.processCartQueue();
        }
      });
    } else if (requestType == 'update') {
      CartJS.updateItem(line_number, quantity, properties = {}, options = {})
    } else {
      // CartJS.removeItem(line_number, options = {})
    }
    

    ShopifyAPI.addItem(request.variant_id, request.quantity, request.properties, ShopifyAPI.processQueue, requestType);
  }
  else {
    theme.cartQueueProcessing = false;
  }
};



/*============================================================================
  Product 
==============================================================================*/
window.theme = window.theme || {};
theme.Product = (function() {

  function Product(data, options) {
    this._options = options || {};

    switch (this._options.source) {
      case 'boost':
        data = this._preFormatBoostFilterProductData(data);
        break;
      case 'shopify':
        data = this._preFormatShopifyProductData(data);
        break;
    }

    _.extend(this, new Shopify.Product(data));
    this._formatData(data);

    if (this._options.requiredFields) {
      // this._fetchRequiredFields();
    }
  }

  Product.prototype = _.extend(Product.prototype, {

    _preFormatBoostFilterProductData: function(data) {

      // Remove images without src
      if (data.featured_image && data.featured_image.src && data.featured_image.src.indexOf('bc-sf-filter-no-image') > -1) {
        delete data.featured_image;
      }

      // Fix Boost Filter floating point issue
      var priceKeys = ['price', 'price_max', 'price_min'],
          i = priceKeys.length;

      while(i--) {
        data[priceKeys[i]] = data[priceKeys[i]].toFixed();
      }

      // Fix Boost Filter lack of has_only_default_variant
      data.has_only_default_variant = false;
      var productOptions = data.options;
      for (var i = 0; i < productOptions.length; i++) {
        
        if(productOptions[i] == 'title' || productOptions[i] == 'Title'){
          data.has_only_default_variant = true;
        }
      }

      return data;
    },

    _preFormatShopifyProductData: function(data) {
      if (data.image) {
        data.featured_image = data.featured_image || data.image;
        delete data.image;
      }
      
      // add variant image to variant option for matching data with boost
      if (data.options_with_values) {
        for (var i = 0; i < data.options_with_values.length; i++) {
          
          if (data.options_with_values[i].values != null) {

            for (var k = 0; k < data.options_with_values[i].values.length; k++) {
              var variantTitle = data.options_with_values[i].values[k];
              var variantImageIndex = "";
              
              // OPTIONAL - grabs image position index for variant - can be turned off
              // if (setImageIndex) {
              //   var imageUrl = _.find(data.variants, {title: data.options_with_values[i].values[k]}).image;
              // if (imageUrl) {
              //   var imagePosition = _.indexOf(data.images, imageUrl);
              //   variantImageIndex = imagePosition >= 0 ? imagePosition + 1 : "";
              // }
              //   
              // }
              // OPTIONAL 
              
              data.options_with_values[i].values[k] = {
                "title": variantTitle,
                "image": variantImageIndex
              };
    
            }
          }
        }
      }

      return data;
    },

    _formatData: function(data) {
      var self = this;

      this.featured_image = this.featured_image ? this._formatImage(this.featured_image): {};
      this.images = this.images ? this._formatImages(this.images): [];

      if (this.images.length && !this.featured_image) {
      this.featured_image = this.images[0];
      }

      // if inventory is in negative because the store oversells

      for (var i = 0; i < data.variants.length; i++) {
        if(!data.variants[i].inventory_management || (data.variants[i].inventory_management && data.variants[i].inventory_policy == 'continue')){
          data.variants[i].inventory_quantity = 10000;
        }
      }

      var productGroupTag = '';
      var productColor = '';
      for (var i = 0; i < this.tags.length; i++) {
        var tag = this.tags[i];

        if(tag.indexOf('group-') > -1){
          productGroupTag = tag;
        }
        if(tag.indexOf('color-') > -1){
          productColor = tag.replace('color-','');
        }
      }

      var productsRelatedByColor = [];

      if (productGroupTag != '') {
        //get other products with group tag
        $.get('/collections/all/' + productGroupTag + '?view=json', function(data) {
            var productsWithGroupTag = JSON.parse(data);

            for (var i = 0; i < productsWithGroupTag.products.length; i++) {
              var product = productsWithGroupTag.products[i];
              var relatedProductColorName = null;

              for (var i = 0; i < product.tags.length; i++) {
                var tag = product.tags[i];

                if(tag.indexOf('color-') > -1){

                  relatedProductColorName = tag.replace('color-','');
                }
              }

              if(relatedProductColorName != null){
                var colorData = {
                  color: relatedProductColorName,
                  url: product.url,
                  current: product.handle == self.handle ? true : false
                };
                productsRelatedByColor.push(colorData);
              }
            }

        });
       
      }

      this.colors = productsRelatedByColor;
    },

    _formatImage: function(image) {
      if (typeof image == 'string') {
        image = {
          src: image
        };
      }
      return image;
    },

    _formatImages: function(images) {
      var self = this;
      return images.map(function(image) {
        return self._formatImage(image);
      });
    }

  });

  return Product;
})();

/*============================================================================
  Landing Pages Video
==============================================================================*/
window.theme = window.theme || {};
theme.Video = (function() {

  function Video(container) {

    this.element = container;
    this.options = JSON.parse(this.element.getAttribute('data-section-settings'));

    this._loadScript().then(this._setupPlayer.bind(this));

  }

  Video.prototype = _.extend({}, Video.prototype, {
    _loadScript: function() {
      var self = this;

      return new Promise(function (resolve, reject) {
        var script = document.createElement('script');
        document.body.appendChild(script);
        script.onload = resolve;
        script.onerror = reject;
        script.async = true;
        script.src = self.options['videoType'] === 'youtube' ? '//www.youtube.com/iframe_api' : '//player.vimeo.com/api/player.js';
      });
    },

    onUnload: function() {
      if (this.player) {
        this.player.destroy(); // Both YouTube and Vimeo use the same function name
      }
    },

    _setupPlayer: function() {
      var self = this;

      var elementToInsert = this.element.querySelector('.ImageHero__VideoHolder');

      var playerLoadingInterval = setInterval(function () {
        if (self.options['videoType'] === 'youtube') {
          if (window.YT) {
            self.player = new YT.Player(elementToInsert, {
              videoId: self.options['videoId'],
              playerVars: {
                showinfo: 0,
                controls: 0,
                fs: 0,
                rel: 0,
                height: '100%',
                width: '100%',
                iv_load_policy: 3,
                html5: 1,
                loop: 1,
                autoplay: 1,
                muted: 1,
                playsinline: 1,
                modestbranding: 1,
                disablekb: 1,
                origin: self.options['requestHost']
              },
              events: {
                onReady: self._onYouTubeReady.bind(self),
                onStateChange: self._onYouTubeStateChange.bind(self)
              }
            });

            clearInterval(playerLoadingInterval);
          }
        } else {
          if (window.Vimeo) {
            self.player = new Vimeo.Player(elementToInsert.parentNode, {
              id: self.options['videoId'],
              autoplay: true,
              muted: true,
              background: true,
              /*height: '100%',
              width: '100%',*/
              loop: true
            });
          }
        }
      }, 50);

    },

    _onYouTubeReady: function(event) {
      this.player.mute();
      this.player.playVideo();
    },

    _onYouTubeStateChange: function(event) {
      if (event.data === YT.PlayerState.ENDED) {
        this.player.playVideo();
      }
    }

  });

  return Video;
})();

/*============================================================================
  Landing Pages
==============================================================================*/
window.theme = window.theme || {};
theme.LandingPages = (function() {
  function LandingPages() {
    
    initFeaturedProducts();

    function initFeaturedProducts(){
      var elem = document.querySelector('.ProductList--carousel');
      var flkty = new Flickity( elem, {
        // options
        pageDots: false,
        cellAlign: 'left',
        contain: true,
        groupCells: true
      });
    }

    if($('.TestimonialList--landing-page').length > 0){
      initTestimonialsSlider();
    }
    function initTestimonialsSlider(){
      var elem = document.querySelector('.TestimonialList--landing-page');
      var flkty = new Flickity( elem, {
        // options
        pageDots: false,
        cellAlign: 'left',
        contain: true,
        groupCells: true
      });
    }
    
  }

  return LandingPages;
})();

/*============================================================================
  Collection offers
==============================================================================*/
window.theme = window.theme || {};
theme.CollectionOffers = (function() {
  function CollectionOffers() {
    
    initFeaturedOffers();

    function initFeaturedOffers(){
      var elem = document.querySelector('.CollectionOffers--carousel');
      var flkty = new Flickity( elem, {
        // options
        prevNextButtons: false,
        pageDots: false,
        cellAlign: 'left',
        contain: true,
        groupCells: true,
        watchCSS: true
      });
    }
  }

  return CollectionOffers;
})();


/*============================================================================
  Article Page
==============================================================================*/
window.theme = window.theme || {};
theme.ArticlePage = (function() {
  function ArticlePage() {

    if($('.article-featured-products').length > 0){
      initFeaturedProducts();
    }
    function initFeaturedProducts(){
      var elem = document.querySelector('.ProductList--carousel');
      var flkty = new Flickity( elem, {
        // options
        pageDots: false,
        cellAlign: 'left',
        contain: true,
        groupCells: true
      });
    }

    if($('.article-related-articles').length > 0){
      initRelatedArticle();
    }
    function initRelatedArticle(){
      var elem = document.querySelector('.ArticleList--carousel');
      var flkty = new Flickity( elem, {
        // options
        pageDots: false,
        cellAlign: 'left',
        contain: true,
        groupCells: true
      });
    }
    
  }

  return ArticlePage;
})();

/*============================================================================
  Warranty Landing Page
==============================================================================*/
window.theme = window.theme || {};
theme.TileSlider = (function() {
  function TileSlider() {
    document.querySelectorAll('.TileSlider--carousel').forEach(function(elem) {
      new Flickity(elem, {
        // options
        prevNextButtons: true,
        pageDots: false,
        cellAlign: 'left',
        contain: true,
        groupCells: false
      });
    });
  }

  return TileSlider;
})();
/*============================================================================
  Header
==============================================================================*/
window.theme = window.theme || {};
theme.Header = (function() {

  var selectors = {
    invalidMessage: '[data-type="invalid"]',
    notSelectedMessage: '[data-type="no-selected"]',
    headerTinybind: '[data-consultant-view="header"]',
    sidebarTinybind: '[data-consultant-view="sidebar"]',
    productTinybind: '[data-consultant-view="product"]',
    accountTinybind: '[data-consultant-view="account"]',
    tippyTinybind: '[data-consultant-view="tippy"]'
  };

  function Header(container) {
    
    this.data = { 
      consultant: {}
    };
    this.container = container;

    var self = this;
    this.getSelectedConsultant();

    $(container).on('consultant:change', function(evt){
      self.updateSelectedConsultant(evt);
    });

    this.initWishlistHeader();

    this.initHeaderConsultantFinder();
    this.initSidebarConsultantFinder();

    self.updateSelectedConsultant();
    
    if ($('.template-product').length > 0) {
      this.initProductConsultantFinder();
    }
    
    if($('.consultant-messages').length > 0){
      self.initAccountConsultantFinder();
    }
  }

  Header.prototype = _.extend({}, Header.prototype, {
    
    checkValidConsultant: function(consultantId, callback){
      var self = this;

      var urlPrefix = "https://us-central1-astute-smile-292303.cloudfunctions.net/"
      var APIUrl = urlPrefix + "checkConsultant?id="+ consultantId +"&shop=tupperware-au.myshopify.com";//v=" + (production ? '' :new Date().getTime());
      
      $.ajax({ 
        url: APIUrl, 
        type: 'GET', 
        dataType: 'json', 
        success: function(response) {
          var validConsultant = false;

          if(response){
            validConsultant = true;
          }
          else {
            console.log('these was an error getting the data.');
          }

          callback(validConsultant);
        } 
      });

    },

    getConsultantById: function(consultantId,callback){
      var self = this;

      var urlPrefix = "https://us-central1-astute-smile-292303.cloudfunctions.net/";
      var APIUrl = urlPrefix + "findConsultantsByName?searchTerm="+consultantId+"&shop=tupperware-au.myshopify.com";

      $.ajax({ 
        url: APIUrl, 
        type: 'GET', 
        dataType: 'json', 
        success: function(response) {
          if(response){
           // var data = _.filter(response, {'tupsocial': true});
           var data = response;
            callback(data);
          }
          else {
            console.warn('these was an error getting the data.');
          }

        },
        error: function(){
          callback(false);
        } 
      });
    },

    initHeaderConsultantFinder: function(){
      var self = this;

      var template = theme.utils.getTemplate('consultant-finder');
      var trigger = document.getElementById('ConsultantFinderTippyTrigger');

      var tinybindElement = document.querySelector(selectors.headerTinybind);

      tinybind.bind(tinybindElement, {
        data: self.data,
        methods: {}
      });

      var dropdownInitialised = false;
      var dropdown = tippy(trigger, {
       content: template,
       trigger: 'mouseenter',
       theme: 'light',
       interactive: true,
       interactiveBorder: 5,
       animateFill: false,
       placement: 'bottom-start',
       hideOnClick: true,
       offset: '0,0',
       showOnInit: true,
       onHide: function() {

       },
       onMount: function(instance){
        self.getSelectedConsultant();
        var tinybindElement = instance.popperInstance.popper.querySelector(selectors.tippyTinybind);
        tinybind.bind(tinybindElement, {
          data: self.data,
          methods: {}
        });

        if (dropdownInitialised) {
         return;
        }
        else {
         instance.hide();
        }
         
        dropdownInitialised = true;
       }
      });

    },

    initProductConsultantFinder: function(){
      var self = this;

      var tinybindElement = $(selectors.productTinybind);
      tinybind.bind(tinybindElement, {
        data: this.data
      });
    },

    initSidebarConsultantFinder: function(){
      var self = this;

      var tinybindElement = $(selectors.sidebarTinybind);
      tinybind.bind(tinybindElement, {
        data: this.data
      });
    },

    initAccountConsultantFinder: function(){
      var self = this;

      var tinybindElement = $(selectors.accountTinybind);
      tinybind.bind(tinybindElement, {
        data: this.data
      });

      if(self.data.consultant && self.data.consultant.title && self.data.consultant.title.length> 0 ){
        var validConsultant = self.checkValidConsultant(self.data.consultant.handle, updateConsultantStatus);

        function updateConsultantStatus(validConsultant){
          if(validConsultant){
            self.data.condition = 'is-selected';
          }
          else {
            self.data.condition = 'invalid';
          }
        }
        
      }
      else {
        self.data.condition = 'not-selected';
      }
    },

    getSelectedConsultant: function(){
      var self = this;

      var defaultConsultantId = window.shop && window.shop.customer && window.shop.customer.default_consultant_id;
      var consultantData = localStorage.getItem('Selected_Consultant');
      var currentConsultant = JSON.parse(consultantData);

      if (
        currentConsultant &&
        currentConsultant.title &&
        currentConsultant.title.length > 0 &&
        currentConsultant.handle !== defaultConsultantId
      ) {
        self.data.consultant = currentConsultant;
      }
    },

    initWishlistHeader: function(){
      var self = this;

      function swymCallbackFn(){

       window._swat.renderWishlistCount($('.Header__WishlistDot')[0], function(cnt, elem){
         self.data.wishlist_count =  cnt;
       }, 1500);
      }

      if(!window.SwymCallbacks){
       window.SwymCallbacks = [];
      }

      window.SwymCallbacks.push(swymCallbackFn);


    },

    updateSelectedConsultant: function(evt){
      const consultantSyncingEnabled =
        window.shop &&
        window.shop.customer &&
        window.shop.customer.consultant_syncing &&
        window.shop.customer.consultant_syncing.enabled;
      const consultantSyncingEndpoint =
        window.shop &&
        window.shop.customer &&
        window.shop.customer.consultant_syncing &&
        window.shop.customer.consultant_syncing.endpoint;
      const defaultConsultantId =
        window.shop &&
        window.shop.customer &&
        window.shop.customer.default_consultant_id;
      const customerIsLoggedIn =
        window.shop &&
        window.shop.customer &&
        window.shop.customer.is_logged_in;
      const customerId =
        window.shop &&
        window.shop.customer &&
        window.shop.customer.customer_id;
      const customerConsultantId =
        window.shop &&
        window.shop.customer &&
        window.shop.customer.consultant_id;

      var self = this;

      var currentConsultant = {};

      if(evt && evt.consultant){
        currentConsultant = evt.consultant;
      }
      else {
        var consultantData = localStorage.getItem('Selected_Consultant');
        storedConsultant = JSON.parse(consultantData);

        if (
          storedConsultant &&
          storedConsultant.title &&
          storedConsultant.title.length > 0 &&
          storedConsultant.handle !== defaultConsultantId
        ) {
          currentConsultant = storedConsultant
        }
        else {
          // Customer has a consultant ID set against their account but none stored in the browser.
          // Fetch complete consultant data and store in the browser for future page loads.
          if (customerConsultantId && customerConsultantId !== defaultConsultantId) {
            return new Promise(function(resolve, reject) {
              const urlPrefix = "https://us-central1-astute-smile-292303.cloudfunctions.net/";
              const APIUrl = `${urlPrefix}findConsultantsByName?searchTerm=${customerConsultantId}&shop=tupperware-au.myshopify.com`;

              $.ajax({ 
                url: APIUrl, 
                type: 'GET', 
                dataType: 'json', 
                success: function(response) {
                  if (response.length > 0) {
                    const selectedConsultant = response[0];
                    selectedConsultant.selected_consultant_pre_checkout = true;
                    selectedConsultant.selection_type = 'account';

                    localStorage.setItem('Selected_Consultant', theme.utils.simpleStringify(selectedConsultant));

                    if (selectedConsultant && selectedConsultant.title && selectedConsultant.title.length > 0) {
                      self.updateSelectedConsultant();
                    }
                  }
                  return resolve();
                },
                error: function() {
                  console.log('There was an error getting the data.');
                  return reject();
                } 
              });
            }).catch(function(error) {
              console.log(error);
            });
          }

          return;
        }
      }
      
      if(currentConsultant && currentConsultant.title && currentConsultant.title.length > 0){
        // button.innerText = currentConsultant.name;
        self.data.consultant = currentConsultant;
      }

      var cartNote = 'consultantId:' + currentConsultant['handle'];
      var cartAttributes = {};

      var fieldsToUpdate = ['dbEmail', 'dbPhone', 'distributorId', 'email', 'firstName', 'lastName', 'title'];
      for (var i = 0; i < fieldsToUpdate.length; i++) {
        var key = fieldsToUpdate[i];
        var name = 'consultant_' + key;
        var value = currentConsultant[key];

        if(key == 'title'){
          function capitalizeFirstLetter(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
          }
          var value = capitalizeFirstLetter(currentConsultant.firstName.toLowerCase()) + ' ' + capitalizeFirstLetter(currentConsultant.lastName.toLowerCase());
        }

        cartAttributes[name] = value;
      }

      cartAttributes['consultantId'] = currentConsultant['handle'];
      cartAttributes['selected_consultant_pre_checkout'] = currentConsultant['selected_consultant_pre_checkout']; // true
      cartAttributes['selection_type'] = currentConsultant['selection_type']; //'finder'

      CartJS.setNote(cartNote);
      CartJS.setAttributes(cartAttributes);

      // Customer has a different consultant ID stored in the browser compared with their account.
      // Update account value to match that of the browser.
      if (
        consultantSyncingEnabled &&
        consultantSyncingEndpoint &&
        customerIsLoggedIn &&
        currentConsultant.handle &&
        currentConsultant.handle !== customerConsultantId
      ) {
        const url = `${consultantSyncingEndpoint}?customer_id=${customerId}&consultant_id=${currentConsultant.handle}`;
        fetch(url)
          .then((response) => response.json())
          .catch((error) => {
            console.error(error);
          });
      }

      if($('.consultant-messages').length > 0){
        self.initAccountConsultantFinder();
      }
      
    }

  });

  return Header;
})();


window.theme = window.theme || {};

theme.StoreLocator = (function() {

  var selectors = {
    storesDataContainer: 'script#store-locations',
    filtersDataContainer: 'script#store-location-filters',
    mapSkinDataContainer: 'script#store-locatior-skin',
    mapContainer: '#Map-',
    headerContainer: '.Header'
  };

  

  var defaults = {
    map: {
      zoom: 4,
      center: {
        lat: -20.748473520751226,
        lng: 136.25635706558185
      },
      zoomControl: true,
      mapTypeControl: false,
      scaleControl: true,
      streetViewControl: false,
      rotateControl: false,
      fullscreenControl: true,
    },
    rawDataType: 'json',
    googlePlacesFields: [
      'url',
    ],
    enableSearch: true,
    activeStoreZoomLevel: 12,
    showStoreInfoWindow: true,
    showSearchMarker: true,
  };

  function StoreLocator(container) {

    this.container = container;
    this.sectionId = container.dataset.sectionId;
    this.mapContainer = document.querySelector(selectors.mapContainer + this.sectionId);

    this.options = _.defaults(defaults, {});

    if (!this.container) {
      return;
    }

    this.data = {
      parsedData: {},
      stores: [],
      groups: [],
      filters: [],
      tags: [],
      markerClusters: [],
      activeFilters: [],
      activeStore: null,
      activeGroup: null,
      storesInFilter: [],
      storesInView: [],
      selectedConsultant: null,
      initialLoad: true,
      geohash: 'r1x',
      consultants: [],
      loadedConsultants: [],
      searchLocation: {},
      geohashesJustLoaded: [],
      refreshResults: true,
      enableAutocomplete: false,
      autocompleteActive: false,
      minAutocompleteLength: 0,
      autocompleteLimit: 5,
      resultsTotal: 15,
      postcodeSearches: [],
      showSearchButton: true,
      loadingMapMarkers: false,
      findUserPrecision: 5,
      setPostcodePrecision: 4, //country towns wont show enough results on 5
      zoomWarning: false,
      clusterMaxZoomLevel: defaults.activeStoreZoomLevel - 1
    };

    var self = this;

    this.methods = {
      focusStore: this._focusStore.bind(this),
      zoomToFitMarkers: this._zoomToFitMarkers.bind(this),
      selectGroup: this._focusGroup.bind(this),
      selectFilter: this._focusFilter.bind(this),
      clearFilter: this._clearFilters.bind(this),
      clearActiveStore: this._clearActiveStore.bind(this),
      findUser: function(event, binding) { self._findUser(false)},
      setSelectedConsultant: function(event, binding) { self.setSelectedConsultant(event, binding) },
      searchByName: function(event, binding) { self._searchByName(event, binding) },
      setPostcode: function(event, binding) { self.setSelectedPostcode(event, binding) },
      searchMapLocation: function(event, binding) { self._getMarkersInView(event, binding) },
    };

    this._startPage();
  }

  StoreLocator.prototype = _.extend({}, StoreLocator.prototype, {
    
    _startPage: function(){
      var self = this;

      loadJS(window.theme.geohashLib, loadConsultantFinder());

      function loadConsultantFinder(){
        self._preLoadConsultants();

        self._prepareData();

        self._bindView();

        self._buildMap();
        
        self.getSelectedConsultant();

        if ("geolocation" in navigator) {
          self.data.geolocationEnabled = true;
        }
      }
      
    },

    _preLoadConsultants: function(){
      
      var self = this;
      var now = new Date();

      var savedConsultants = localStorage.getItem('savedConsultantData');
      if(savedConsultants){
        var consultants = JSON.parse(savedConsultants);
        
        Array.prototype.push.apply(self.data.loadedConsultants, consultants.value);
        self.data.loadedConsultants = _.uniq(self.data.loadedConsultants);
      }
      
    },

    _saveConsultantsData: function(){
      var self = this;
      var now = new Date()
      
      if(self.data.loadedConsultants){
        //set data to expire after a day
        var item = {
          value: self.data.loadedConsultants,
          expiry: now.getTime() + 1,
        }
        
        localStorage.setItem('savedConsultantData', theme.utils.simpleStringify(item));
      }
    },

    _onMapLoadComplete: function() {

      var self = this;
      //load search once init is complete
      if (self.options.enableSearch) {
        self._prepareSearch();
      }

      this._bindMapListners();
      var queryparams = theme.utils.getQueryParams();
      var queryparamChecks = [
        this._setActiveStoreFromQueryParam(queryparams),
        this._setSelectedConsultantFromQueryParam(queryparams),
        this._setActiveGroupFromQueryParam(queryparams)
      ];

      // var i = queryparamChecks.length;
      // while(i--) {
      //   if (queryparamChecks[i].call(queryparams)) {
      //     break;
      //   }
      // }

    },

    _setActiveGroupFromQueryParam: function(queryparams) {

      var handle,
          group;

      if (queryparams && queryparams.group) {
        handle = queryparams.group;
        group = _.find(this.data.groups, {'handle': handle});
      }

      if (!group) {
        return false;
      }

      return this._setActiveGroup(group);

    },

    loadSelectedConsultant: function(evt){

      var data = localStorage.getItem('Selected_Consultant');
      var selectedConsultant = JSON.parse(data);
      return selectedConsultant;
    },

    getSelectedConsultant: function(){
      var self = this;

      var defaultConsultantId = window.shop && window.shop.customer && window.shop.customer.default_consultant_id;
      var currentConsultant = self.loadSelectedConsultant();

      if (
        currentConsultant &&
        currentConsultant.title &&
        currentConsultant.title.length > 0 &&
        currentConsultant.handle !== defaultConsultantId
      ) {
        self.data.selectedConsultant = currentConsultant.handle;
      }
    },

    setSelectedConsultant: function(event,binding){
      var self = this;

      self.data.selectedConsultant = binding.store.handle;

      var selectedConsultant = binding.store;
      selectedConsultant.selected_consultant_pre_checkout = true;
      selectedConsultant.selection_type = 'finder';

      localStorage.setItem('Selected_Consultant', theme.utils.simpleStringify(selectedConsultant));

      if(selectedConsultant && selectedConsultant.title && selectedConsultant.title.length > 0){
        $(selectors.headerContainer).trigger({
          type: 'consultant:change',
          consultant: selectedConsultant
        });
      }
    },

    setSelectedPostcode: function(event,binding){
      var self = this;
      self.data.autocompleteActive = false;
      self.data.selectedPostcode = binding.postcode;

      if (!self.data.selectedPostcode.lat || !self.data.selectedPostcode.long) {

        iziToast.error({
          title: 'We couldn\'t find this location',
          position: 'bottomCenter',
          theme: 'light',
        });

        return;
      }

      self.updateSearchText();
      self.data.searchLocation.lat = self.data.selectedPostcode.lat;
      self.data.searchLocation.lng = self.data.selectedPostcode.long;

      // clear all current results so only search hits are in map
      self._clearStores();

      // nessisary to unbind and rebind listeners for map so page doesnt load a bigger search result than required
      self.data.searchInProgress = true; 
      self.data.searching = true;

      self._getMoreStoresViaGeohash(self.data.setPostcodePrecision,true)

    },

    updateSearchText: function(){
      var self = this;

      var postcodeSearch = document.getElementById('store-locator-search');
      postcodeSearch.value = self.data.selectedPostcode.postcode + ' ' + self.data.selectedPostcode.locality + ' ' + self.data.selectedPostcode.state;

    },

    _clearSearch: function(){

      var self = this;

      self._clearSearchByNameInput();
      self._clearSearchByPostcodeInput();

      ///clear current results
      self._clearStores();

      // don't load more consultans on zoom change
      self.data.searchInProgress = true;

      self.map.setZoom(5);
    },

    _searchByName: function(event, binding){
      var self = this;

      self.data.cancelLocationSearch = true;

      // only search on enter
      if(event.type != 'click' && event.keyCode != 13){
        return;
      }
      
      var postcodeSearch = document.getElementById('store-locator-search');
      //get search field so button can trigger search
      var nameSearchField = document.getElementById('store-locator-search-secondary');
      var searchValue = nameSearchField.value;

      if(searchValue != ''){
        self._clearSearchByPostcodeInput();
      }

      if(searchValue == '' && postcodeSearch.value.length > 0){
        return;
      }

      this.data.searching = true;

      self.data.loading = true;
      // skip the eventlistener for map moving once
      self.data.searchInProgress = true;

      var searchValueLowercase = searchValue.toLowerCase();
      self._submitNameIdSearch(searchValueLowercase);

      // function showSearchResults(){
      //   ///clear current results
      //   self._clearStores();
      //   self._prepareStoresData();
      //   self._addStoresToView();
      //   self._updateMapMarkers();

      //   self._zoomToFitMarkers();

      //   self.data.loading = false;
      // }
    },

    _submitNameIdSearch: function(searchValue){

      var self = this;

      var urlPrefix = "https://us-central1-astute-smile-292303.cloudfunctions.net/";
      var APIUrl = urlPrefix + "findConsultantsByName?searchTerm="+searchValue+"&shop=tupperware-au.myshopify.com";

      $.ajax({ 
        url: APIUrl, 
        type: 'GET', 
        dataType: 'json', 
        success: function(response) {
          if(response){
            self.data.parsedData.data = _.filter(response, {'tupsocial': true});

            console.log(response)
            
            self._clearStores();


            self.data.stores = self._prepareStoresData();
            //sort by status
            self.data.stores = _.orderBy(self.data.stores,['status'],['postcode'],['title']);
            self._addStoresToView();
            self._updateMapMarkers();

            self._zoomToFitMarkers();

            self.data.loading = false;
            // callback(callback);
          }
          else {
            console.warn('these was an error getting the data.');
          }

        },
        error: function(){
          theme.utils.showError('Please provide a name or id.');
          self.data.loading = false;
        } 
      });
    },

    _setSelectedConsultantFromQueryParam: function(queryparams) {
      var self = this;
      
      var handle,
          store;

      if (queryparams && queryparams.setstore) {
        handle = queryparams.setstore;
        store = _.find(this.data.stores, function(item){
          if(item.handle == handle){
            return item;
          }
        });
      }

      if (!store) {
        return false;
      }

      var event = {};
      var binding = { store: store };
      self.setSelectedConsultant(event, binding);

      return this._setActiveStore(store);

    },

    _setActiveStoreFromQueryParam: function(queryparams) {

      var handle,
          store;

      if (queryparams && queryparams.store) {
        handle = queryparams.store;

        //get store by handle
        // self._submitNameIdSearch(handle);

        // function showSearchResults(){
        //   ///clear current results
        //   self._clearStores();
        //   self._prepareStoresData();
        //   self._addStoresToView();
        //   self._updateMapMarkers();

        //   self.data.loading = false;
        // }

        // store = _.find(this.data.stores, function(item){
        //   if(item.handle == handle){
        //     return item;
        //   }
        // });
      }

      if (!store) {
        return false;
      }

      return this._setActiveStore(store);

    },

    _focusFilter: function() {

      var id,
          filter,
          filterAction;

      id = event.currentTarget.dataset.filterId;
      filter = _.find(this.data.filters, {'id': id});

      if (!filter) {
        console.error(new Error('No filter found!'));
        return;
      }

      if (filter.active) {

        filterAction = 'remove';

      } else {

        if (this.options.allowMultipleFilters) {
          filterAction = 'add';
        } else {
          filterAction = 'replace';
        }

      }

      this._setActiveFilter(filter, filterAction);
    },

    _setActiveFilter: function(filter, action, updateMap) {

      var self = this;

      // action = 'add', 'remove', 'replace', 'reset'

      if (!action) {
        console.error('An action must be defined');
        console.error('action = add, remove, replace, reset');
        return;
      }

      this._setActiveStore(false, false);

      switch(action) {

        case 'replace':

          _.each(this.data.activeFilters, function(filter) {
            filter.active = false;
          });

          this.data.activeFilters = [];

          filter.active = true;
          this.data.activeFilters.push(filter);
          break;

        case 'remove':

          filter.active = false;

          var i = this.data.activeFilters.length;
          while(i--) {
            if (this.data.activeFilters[i] == filter) {
              this.data.activeFilters.splice(i, 1);
              break;
            }
          }
          break;

        case 'add':

          filter.active = true;
          this.data.activeFilters.push(filter);
          break;

        case 'reset':

          _.each(this.data.activeFilters, function(filter) {
            filter.active = false;
          });

          this.data.activeFilters = [];
          break;

      }

      _.each(this.data.stores, function(store, i) {
        var storeInFilter = true;

        _.each(self.data.activeFilters, function(filter) {

          if (!store.tags || store.tags.indexOf(filter.tag) == -1) {
            storeInFilter = false;
          }

        });

        if (storeInFilter) {
          self._addStoreToFilter(store);
        } else {
          self._removeStoreFromFilter(store);
        }

      });

      if (self.data.activeFilters.length == 0) {
        this.data.storesAreFiltered = false;
      } else {
        this.data.storesAreFiltered = true;
      }



      this._toggleFiltersNoResultsMessage();

      _.each(this.data.markerClusters, function(markerCluster, i) {
        markerCluster.repaint();
      })

    },

    _toggleFiltersNoResultsMessage: function() {

      if (this.data.storesAreFiltered && this.data.storesInFilter.length == 0) {
        this.data.filterNoResults = true;
      } else {
        this.data.filterNoResults = false;
      }

    },

    _clearFilters: function() {
      //this._setActiveFilter(false, 'reset');
      this._clearSearch();
    },

    _addStoreToFilter: function(store) {

      if (store.in_filter == true) {
        return;
      }

      store.in_filter = true;
      store.marker.setMap(this.map);
      store.markerCluster.addMarker(store.marker);
      // store.markerCluster.redraw();

      this.data.storesInFilter.push(store);

    },

    _removeStoreFromFilter: function(store) {

      if (store.in_filter == false) {
        return;
      }

      store.in_filter = false;
      store.markerCluster.removeMarker(store.marker);
      store.marker.setMap(null);
      // store.markerCluster.redraw();

      _.pull(this.data.storesInFilter, store);

    },

    _focusStore: function() {
      var self = this;

      var id,
          store;

      id = event.currentTarget.dataset.storeId;
      store = _.find(self.data.stores, {'id': id});

      if (!store) {
        console.error(new Error('No store found!'));
        return;
      }

      this.map.setZoom(this.options.activeStoreZoomLevel);

      self.data.refreshResults = false;

      //if mobile scroll to map on select
      enquire.register('screen and (max-width: 899px)', {
        match: function() {
          $('body').scrollTo($('.store-locator__map-view'), {
              duration: 500,
              interrupt: !isMobile.apple.device,
              offset: -200
          });
        }
      });
       

      // If a link is cliked, only follow the link if the store is active
      if (event.target && event.target.nodeName == 'A') {
        if (store.active) {
          return;
        } else {
          event.preventDefault();
        }
      }

      self._setActiveStore(store);

    },

    _clearActiveStore: function() {
      this._setActiveStore(false, false);
    },

    _setActiveStore: function(store, updateMap) {

      var self = this;

      var marker,
          markerPosition,
          activeStore,
          currentMapBounds,
          currentMapZoom,
          boundsContainsMarker;

      activeStore = this.data.activeStore;

      if (activeStore) {
        activeStore.active = false;

        if (activeStore.infoWindow) {
          activeStore.infoWindow.close();
        }

      }

      if (store == false) {
        this.data.activeStore = null;
        return;
      }

      if (updateMap != false) {

        marker = store.marker;

        markerPosition = marker.getPosition();
        currentMapBounds = this.map.getBounds();
        boundsContainsMarker = currentMapBounds ? currentMapBounds.contains(markerPosition) : false;
        currentMapZoom = this.map.getZoom();

        if (!boundsContainsMarker || currentMapZoom < this.options.activeStoreZoomLevel) {
          this.map.panTo(markerPosition);
          this.map.setZoom(this.options.activeStoreZoomLevel);
        }

      }

      if (store.group) {
        this._setActiveGroup(store.group, false);
      }

      this.data.activeStore = store;
      store.active = true;

      var awaitFetchStoreDetails = false;

      if (awaitFetchStoreDetails && store.place_id && !store.place && !store.is_loading) {
        this._fetchStoreDetails(store, function() {
          self._openStoreInfoWindow(store);
        });
      } else {
        self._openStoreInfoWindow(store);
      }

      return store;

    },

    _fetchStoreDetails: function(store, callback) {

      var request;

      store.is_loading = true;

      request = {
        placeId: store.place_id,
        fields: this.options.googlePlacesFields
      };

      function formatOpeningHours(periods) {
        // Formats opening hours provided by Google Places API

        var days,
            dayNames,
            dayIndex,
            dayTitle,
            daysString,
            openAmPm,
            openHours,
            openMinutes,
            openTime,
            closeAmPm,
            closeHours,
            closeMinutes,
            closeTime,
            timesString;

        days = [];
        dayNames = ['mon', 'tues', 'wed', 'thurs', 'fri', 'sat', 'sun'];

        _.each(periods, function(period) {

          dayIndex = period.open.day;
          dayTitle = dayNames[dayIndex];

          openAmPm = (period.open.hours < 12 ? 'am' : 'pm');
          openHours = (period.open.hours < 12 ? period.open.hours : period.open.hours - 12);
          openMinutes = (period.open.minutes ? ':' + period.open.minutes : '');
          openTime = openHours + openMinutes + openAmPm;

          closeAmPm = (period.close.hours < 12 ? 'am' : 'pm');
          closeHours = (period.close.hours < 12 ? period.close.hours : period.close.hours - 12);
          closeMinutes = (period.close.minutes ? ':' + period.close.minutes : '');
          closeTime = closeHours + closeMinutes + closeAmPm;

          timesString = openTime + ' - ' + closeTime;

          daysString = dayTitle;

          function TimePeriod(options) {
            _.extend(this, options);
          }

          days.push(new TimePeriod({
            startDay: dayTitle,
            endDay: dayTitle,
            daysString: daysString,
            timesString: timesString,
            open: openTime,
            close: closeTime,
          }));

        });

        _.each(days, function(day, i) {
          var nextDay;

          nextDay = days[i + 1];

          if (nextDay && day.timesString == nextDay.timesString) {
            nextDay.startDay = day.startDay;
            nextDay.daysString = nextDay.startDay + ' - ' + nextDay.endDay;
            day.toDelete = true;
          }

        });

        _.remove(days, {'toDelete': true});

        return days;

      }

      this.placesService.getDetails(request, function(place, status) {

        if (status === google.maps.places.PlacesServiceStatus.OK) {

          store.place = place;

          // store.open_now = place.opening_hours.open_now;
          // store.opening_hours = (place.opening_hours.periods ? formatOpeningHours(place.opening_hours.periods) : []);
          // store.int_phone = place.international_phone_number;
          // store.phone = (place.formatted_phone_number ? place.formatted_phone_number.replace(/\-/g, ' ') : false);
          // store.permanently_closed = place.permanently_closed;
          store.google_url = place.url;

          store.is_loading = false;

          if (callback && typeof callback == 'function') {
            callback();
          }

        } else {
          console.error(new Error('Error receiving data from Places service'));

          if (callback && typeof callback == 'function') {
            callback();
          }
        }

      });

    },

    _openStoreInfoWindow: function(store) {

      var self = this;

      var marker;

      if (!self.options.showStoreInfoWindow) {
        return;
      }

      marker = store.marker;

      if (!store.infoWindow) {
        store.infoWindowContent = document.createElement('div');
        store.infoWindowContent.innerHTML = theme.utils.getTemplate('store-location-info-popup');

        tinybind.bind(store.infoWindowContent, {
          store: store,
          data: self.data,
          methods: {
            setSelectedConsultant: function(event, binding) { 
              self.setSelectedConsultant(event, binding)
            }
          }
        });


        store.infoWindow = new google.maps.InfoWindow({
          content: store.infoWindowContent,
        });
      }

      store.infoWindow.open(self.map, store.marker);

    },

    _focusGroup: function() {

      var id,
          group;

      id = event.currentTarget.value;

      if (id == '' || id =='none') {
        this._setActiveGroup(false);
        return;
      }

      group = _.find(this.data.groups, {'id': id});

      if (!group) {
        console.error(new Error('No group found!'));
        return;
      }

      this._setActiveGroup(group);

    },

    _setActiveGroup: function(group, updateMap) {

      var self = this;

      var center,
          address,
          markerPosition,
          activeGroup;

      activeGroup = this.data.activeGroup;
      if (activeGroup) {
        activeGroup.active = false;
      }

      if (group == false) {
        this.data.activeGroup = null;
        this._zoomToFitMarkers();
        this._setActiveStore(false, false);
        return;
      }

      this.data.activeGroup = group;
      group.active = true;

      if (updateMap == false) {
        return;
      }

      this._setActiveStore(false, false);

      if (group.markers.length > 1) {

        bounds = new google.maps.LatLngBounds();

        _.each(group.markers, function(marker, i) {
          bounds.extend(marker.getPosition());
        });

        self.map.fitBounds(bounds);

      } else {

        markerPosition = group.markers[0].getPosition();

        this.map.panTo(markerPosition);
        this.map.setZoom(20);

      }


      //  IF LOOKUP UP A REGION FROM MAPS API

      // if (region.geo) {
      //   console.info(this.data);
      //   this.map.fitBounds(region.geo.bounds);
      //   return;
      // }

      // this.geocoder.geocode({
      //   'address': region.title,
      //   'bounds': bounds
      // }, function(results, status) {

      //   if (status == 'OK') {
      //     center = results[0].geometry;
      //     region.geo = center;

      //     self.map.fitBounds(region.geo.bounds);
      //   } else {
      //     console.error(new Error('Geocode error: ' + status));
      //   }

      // });

      return group;

    },

    _prepareData: function() {

      var self = this;

      // this._getData(processData);
      processData();
      function processData(callback) {
        // self._prepareStoresData();
        // self._addStoresToView();
        // add map markers once map is loaded
        self._prepareStoresTagsData();
        self._prepareGroupsData();
        self._prepareFiltersData();
        
        

        self.data.is_ready = true;
      }

      

    },

    _getData: function(callback) {
      var self = this;

      var dataContainer,
          rawData,
          parsedData,
          parseOptions,
          rawDataType;


      var urlPrefix = "https://us-central1-astute-smile-292303.cloudfunctions.net/"
      var APIUrl = urlPrefix + "readConsultants?shop=tupperware-au.myshopify.com";

      self.data.loading = true;
      
      var urlPrefix = "https://us-central1-astute-smile-292303.cloudfunctions.net/"
      var APIUrl = urlPrefix + "findConsultants?geohash="+self.data.geohash+"&shop=tupperware-au.myshopify.com";
      var loadStoresOnLoad = true;

      if (!loadStoresOnLoad) {
        callback();
      }

      $.ajax({ 
        url: APIUrl, 
        type: 'GET', 
        dataType: 'json', 
        success: function(response) {

          if(response){
            self.data.parsedData.data = _.filter(response, {'tupsocial': true});
            
            self.data.loading = false;
            callback();
            
          }
          else {
            console.warn('these was an error getting the data.');
          }

        },
        error: function(){
          theme.utils.showError('Oops something went wrong trying to load the consultant finder.');
        } 

      });

      
    },

    _prepareStoresData: function() {

      var self = this;

      var ajaxConsultants = [];
      self.data.initialLoad = false;

      var locationMarkerSVG,
          googleMapsSearchURLPrefix;

      locationMarkerSVG = theme.utils.getTemplate('store-location-marker-icon');
      googleMapsSearchURLPrefix = 'https://www.google.com/maps/search/';

      function Store(data) {

        _.extend(this, data);

        this.lat = parseFloat(this.lat);
        this.long = parseFloat(this.long);

        this.id = theme.utils.handleize(this.title);
        this.icon = locationMarkerSVG;
        this.google_url = googleMapsSearchURLPrefix + theme.utils.handleize(this.title).replace(/\-/g, '+')

        if (this.street && typeof this.street == 'string') {
          this.google_url = this.google_url + '+' + theme.utils.handleize(this.street).replace(/\-/g, '+');
        }

        if (this.opening_hours) {
          this.opening_hours = _.map(this.opening_hours.split(/,/), function(period) {
            return _.map(period.replace(/:/, '#').split(/#/), _.trim);
          });
        }
      }

      self.data.parsedData.data = _.filter(self.data.parsedData.data, function(item){
        if(!item.title || !item.lat || !item.long ){
          //insufficent data
        }
        else {
          return item;
        }
      });

      _.each(self.data.parsedData.data, function(value) {

        var store,
            locationData,
            existingArea;

        // Build store data
        store = new Store(value);
        ajaxConsultants.push(store);

      });

      return ajaxConsultants;

    },

    _prepareStoresTagsData: function() {

      var self = this;

      function Tag(data) {
        _.extend(this, data);
        this.id = theme.utils.handleize(this.title);
      }

      _.each(this.data.stores, function(store, i) {
        var existingTag,
            tagString,
            tags;

        if (store.tags && typeof store.tags == 'string') {

          tags = store.tags.split(',');

          store.tags = [];

          _.each(tags, function(tagString) {

            tagString = theme.utils.handleize(tagString);

            existingTag = _.find(self.data.tags, {'title': tagString });

            if (!existingTag) {

              tag = new Tag({ title: tagString });
              self.data.tags.push(tag);

              
            } else {
              tag = existingTag;
            }

            store.tags.push(tag);

          });

        }

      });

    },

    _prepareGroupsData: function() {

      var self = this;

      function Group(data) {
        _.extend(this, data);
        this.handle = theme.utils.handleize(this.title);
      }

      _.each(self.data.storesInView, function(store, i) {
        var locationData,
            existingGroup;

        if (typeof store.group === 'undefined') {
          store.group = 'ungrouped';
        }

        if (store.group && typeof store.group == 'string') {

          existingGroup = _.find(self.data.groups, {'title': store.location });

          if (!existingGroup) {
            locationData = {
              title: store.location
            };

            group = new Group(locationData);
            self.data.groups.push(group);
            group.stores = [];

          } else {
            group = existingGroup;
          }

          store.group = group;

          group.stores.push(store);

        }

       });

      // _(this.data.stores).uniqBy('lat')
      //    .groupBy('lat')
      //    .forOwn(function(v,k){
      //       v[0]['group'] = k;
      //    });
      //    console.log(this.data.stores)
      //  _.each(this.data.stores, function(store, i) {
      //   var locationData,
      //       existingGroup;

      //   if (typeof store.group === 'undefined') {
      //     store.group = 'ungrouped';
      //   }

      //   var matchingLat _.find(this.data.stores, { 'lat': store.lat});
      //   if (matchingLat && typeof store.group == 'string') {

      //     existingGroup = _.find(self.data.groups, {'title': store.group });

      //     if (!existingGroup) {
      //       locationData = {
      //         title: store.group
      //       };

      //       group = new Group(locationData);
      //       self.data.groups.push(group);
      //       group.stores = [];

      //     } else {
      //       group = existingGroup;
      //     }

      //     store.group = group;

      //     group.stores.push(store);

      //   }

      // });

    },

    _prepareFiltersData: function() {

      var self = this;

      var dataContainer,
          rawData,
          jsonData;

      dataContainer = document.querySelector(selectors.filtersDataContainer);

      if (!dataContainer) {
        console.error(new Error('Missing data container'));
        return;
      }

      rawData = dataContainer.innerHTML;
      jsonData = JSON.parse(rawData);

      function Filter(data) {
        _.extend(this, data);
        this.id = theme.utils.handleize(this.title);
      }

      _.each(jsonData, function(value) {
        var filter,
            tag;

        value.tag = _.find(self.data.tags, {'title': value.tag });

        if (value.tag) {
          value.tag.icon = value.icon;
        }

        filter = new Filter(value);
        self.data.filters.push(filter);

      });

    },

    _bindView: function() {

      tinybind.bind(this.container, {
        data: this.data,
        methods: this.methods
      });

    },

    _getMapStyles: function() {
      dataContainer = document.querySelector(selectors.mapSkinDataContainer);

      if (!dataContainer || !dataContainer.innerHTML) {
        return;
      }

      rawData = dataContainer.innerHTML;
      return JSON.parse(rawData);
    },

    _buildMap: function() {

      var self = this;


      var googleMapsAPIURL = 'https://maps.googleapis.com/maps/api/js?key=',
          googleMapsAPIKEY =  shop.keys.googleMaps,
          googleMapsAdditionalLibraries  = '',
          options = this.options.map,
          mapSkin = this._getMapStyles();

      if(mapSkin) {
        options.styles = mapSkin;
      }

      if (!googleMapsAPIKEY) {
        return console.error(new Error('Google Maps API key is required. You can set this up as as Store metafield: '))
      }

      function initMap() {
        self.geocoder = new google.maps.Geocoder();
        self.map = new google.maps.Map(self.mapContainer, options);
        // self.placesService = new google.maps.places.PlacesService(self.map);

        google.maps.event.addListenerOnce(self.map, 'idle', function() {
          self._onMapLoadComplete();
          self._findUser(true);
          
          document.addEventListener('consultant-landing:open-overlay', () => self._findUser(true));
          document.addEventListener('consultant-landing:clear-search', () => self._clearSearch());
        });
      }

      loadJS(googleMapsAPIURL + googleMapsAPIKEY + googleMapsAdditionalLibraries, initMap);
    },

    _updateMapMarkers: function(){
      var self = this;

      _.each(this.data.stores, function(store, i) {
        var position,
            icon;

        if(!store.lat || !store.long){
          return;
        }

        position = {
          'lat': store.lat,
          'lng': store.long
        };

        icon = store.icon;

        store.marker = new google.maps.Marker({
          position: position,
          map: self.map,
          icon: {
            url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(icon),
            size: new google.maps.Size(28, 40),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(14, 40),
            scaledSize: new google.maps.Size(28, 40)
          },
          optimized: false
        });

        // store.inMap = true;

        if (store.group) {
          store.group.markers = store.group.markers || [];
          store.group.markers.push(store.marker);
        }

        store.marker.addListener('click', function() {
          self._setActiveStore(store);
        });
      });
    },

    _clusterMarkers: function() {
      var self = this;

      var clusterMarkerSVG = theme.utils.getTemplate('store-location-cluster-marker-icon');

      _.each(this.data.groups, function(group, i) {

        var clusterStyles = [
          {
            width: 28,
            height: 28,
            url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(clusterMarkerSVG),
            textSize: 13,
            iconAnchor: [50, 100],
            textColor: '#ffffff'
          }
        ];

        group.markerCluster = new MarkerClusterer(self.map, group.markers, {
          gridSize: 30,
          styles: clusterStyles,
          zoomOnClick: true,
          maxZoom: self.data.clusterMaxZoomLevel,
          minimumClusterSize: 3,
        });

        self.data.markerClusters.push(group.markerCluster);

        _.each(group.stores, function(store) {
          store.markerCluster = group.markerCluster;
        });

      });

    },

    _zoomToFitMarkers: function() {

      var bounds = new google.maps.LatLngBounds();

      _.each(this.data.stores, function(store, i) {
        bounds.extend(store.marker.getPosition());
      });

      this.map.fitBounds(bounds);

    },

    _bindMapListners: function() {

      var self = this;

      this.map.addListener('zoom_changed', _.debounce(this._updateZoomMessage.bind(self), 100));

    },

    _updateZoomMessage: function(){
      var self = this;

      // this is based off map area because different devices show different areas
      var bounds = this.map.getBounds();

      var area = self.calcMapArea(bounds) / 1000; //square kms
      
      var precision = self.calcPrecision(area);

      if(precision == 3){
        self.data.zoomWarning = true;
      }
      else {
        self.data.zoomWarning = false;
      }
    },

    _getMarkersInView: function() {
      var self = this;

      self.data.loadingMapMarkers = true;
      self._getStoresFromMapPosition();
      
    },

    _unbindMapListners: function() {

      var self = this;

      google.maps.event.clearListeners(this.map, 'bounds_changed');

    },

    _getStoresFromMapPosition: function(){
      var self = this;

      // if(self.data.searchInProgress){
      //   self.data.searchInProgress = false;
      //   return;
      // }

      var bounds = this.map.getBounds();

      var area = self.calcMapArea(bounds) / 1000; //square kms

      var precision = self.calcPrecision(area);

      self._setSearchLocation(this.map.center);

      $('.store-locator__map').height();
     
      
      self._getMoreStoresViaGeohash(precision, false);
            


    },

    calcPrecision: function(area){
      var self = this;

      //extra 5's kept for troubleshooting
      if (area <= 10000){
        return 6;
      }
      else if (area <= 50000){
        return 5;
      }
      else if (area <= 60000){
        return 5;
      }
      else if (area <= 200000){
        return 5;
      }
      else if (area <= 1000000){
        return 5;
      }
      else if (area <= 2000000){
        return 4;
      }
      else if (area <= 25000000){
        return 4;
      }
      else {
        return 3;
      }
    },

    calcMapArea: function(bounds){
      var self = this;

      var ne = bounds.getNorthEast(); // LatLng of the north-east corner
      var sw = bounds.getSouthWest(); // LatLng of the south-west corder

      var nw = new google.maps.LatLng(ne.lat(), sw.lng());
      var se = new google.maps.LatLng(sw.lat(), ne.lng());

      function getDistanceInMeters(location1, location2) {
          var lat1 = location1.lat();
          var lon1 = location1.lng();

          var lat2 = location2.lat();
          var lon2 = location2.lng();

          var R = 6371; // Radius of the earth in km
          var dLat = deg2rad(lat2 - lat1);
          var dLon = deg2rad(lon2 - lon1);
          var a =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
            Math.sin(dLon / 2) * Math.sin(dLon / 2);
          var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
          var d = R * c; // Distance in km
          return (d * 1000);

          function deg2rad(deg) {
              return deg * (Math.PI / 180);
          }
      }

      var length = getDistanceInMeters(sw, nw);
      var breadth = getDistanceInMeters(sw, se);

      return length * breadth; // in square meters
    },

    _clearStores: function(){
      var self = this;

      _.each(self.data.stores, function(store, i) {
        if(store.marker){
          store.marker.setMap(null);
        }
        store.inMap = false;
      });

      self.data.groups = [];
      self.data.markerClusters = [];
      self.data.consultants = [];
      self.data.stores = [];
      self.data.storesInView = [];
    },

    _drawGeohashBox: function(geohash){
      var self = this;

      if (self.box) self.box.setMap(null);

      var bounds = Geohash.bounds(geohash);

      // google maps doesn't extend beyond ±85°
      bounds.sw.lat = Math.min(Math.max(bounds.sw.lat, -85), 85);
      bounds.ne.lat = Math.min(Math.max(bounds.ne.lat, -85), 85);

      var boxBounds = new google.maps.LatLngBounds(
              new google.maps.LatLng(bounds.sw.lat, bounds.sw.lon),
              new google.maps.LatLng(bounds.ne.lat, bounds.ne.lon)
      );
      self.box = new google.maps.Rectangle({
          bounds: boxBounds,
          strokeColor: '#0000ff',
          strokeOpacity: 0.8,
          strokeWeight: 1,
          fillColor: '#0000ff',
          fillOpacity: 0.2
      });
      //console.log(box);
      self.box.setMap(self.map);
    
      var centre = Geohash.decode(geohash);

      if (typeof self.label == 'undefined') {
          self.label = new google.maps.InfoWindow({
              maxWidth: 100
          });
      }
      self.label.setContent(geohash);
      self.label.setPosition(new google.maps.LatLng(centre.lat, centre.lon));
      self.label.open(self.map)
    },

    _getMoreStoresViaGeohash: function(precision,zoom){
      
      var self = this;

      var precision = precision ? precision : 2;
      var geohash = Geohash.encode(self.data.searchLocation.lat,self.data.searchLocation.lng,precision);

      self.data.cancelLocationSearch = true;

      if(self.data.geohash == geohash && !self.data.searchInProgress){
        return;
      }

      // for testing
      // self._drawGeohashBox(geohash);
      
      var geohashesToLoad = Geohash.neighbours(geohash);

      self.data.loading = true;

      // if moving away from 2 char geohash, clear list and start again - to keep map from overloading
      // if(self.data.geohash.substring(0,2) != geohash.substring(0,2) || self.data.stores.length > 490){
      //   console.log('clearing old results markers')
      //   self._clearStores();
      // }

      self._clearStores();
      self.data.geohashesJustLoaded = geohashesToLoad;
      var geohashesInLastLoad = _.map(self.data.geohashesJustLoaded, 'geohash');

      var callsToMake = geohashesToLoad.length;

      for (var i = 0; i < geohashesToLoad.length; i++) {
        var geohash = geohashesToLoad[i].geohash;

        var existingData = _.find(self.data.loadedConsultants, {'geohash' : geohash});
        
        if(existingData){
          
          // if(geohashesInLastLoad.indexOf(geohash) > -1){
          //   // don't double up on geohash data
          // }
          // else {
          //   Array.prototype.push.apply(self.data.consultants, existingData.results);
          // }
          
          Array.prototype.push.apply(self.data.consultants, existingData.results);
          MarkComplete();
        }
        else {
          var urlPrefix = "https://us-central1-astute-smile-292303.cloudfunctions.net/"
          var APIUrl = urlPrefix + "findConsultants?geohash="+geohash+"&shop=tupperware-au.myshopify.com";

          self._getConsultantsByGeohash(geohash,APIUrl,MarkComplete);
        }

        function MarkComplete(){
          callsToMake --;

          if(callsToMake == 0){
            self._sortConsultantsResults();
            self._updateConsultants();
            self.data.cancelLocationSearch = false;
            self.data.loading = false;

            if(zoom){
              self.data.searchInProgress = true;

              self._zoomToFitMarkers();
            }
            self.data.loadingMapMarkers = false;
          }
        }
        
      }
      
      
    },

    _sortConsultantsResults: function(){

      var self = this;

      self.data.consultants = self._calConsultantDistances(self.data.consultants);

      self.data.consultants = _.orderBy(self.data.consultants,['distanceToCurrentSearch']);

      self.data.consultants = self.data.consultants.splice(0,self.data.resultsTotal);

      self.data.consultants = _.orderBy(self.data.consultants,['status'], ['distanceToCurrentSearch'], ['tempSort'],['postcode'],['title']);
   

    },

    _getConsultantsByGeohash: function(geohash,APIUrl,callback){

      self = this;

      $.ajax({ 
        url: APIUrl, 
        type: 'GET', 
        dataType: 'json', 
        success: function(response) {

          if(response){
            self.data.parsedData.data = _.filter(response, {'tupsocial': true});
       
            var consultants = self._prepareStoresData();

            var geohashResults = {
              geohash: geohash,
              results: consultants
            }

            Array.prototype.push.apply(self.data.consultants, consultants);

            self.data.loadedConsultants.push(geohashResults);
            self._saveConsultantsData();
            callback();
          }
          else {
            console.warn('these was an error getting the data.');
          }

        },
        error: function(){
          theme.utils.showError('Oops something went wrong trying to load the consultant finder.');
        } 

      });
    },

    _updateConsultants: function(){
      var self = this;

      for (var i = 0; i < self.data.consultants.length; i++) {
        consultant = self.data.consultants[i];
        self.data.stores.push(consultant);
      }

      self._addStoresToView();
      self._prepareGroupsData();
      self._updateMapMarkers();
      self._clusterMarkers();

      self.data.loading = false;
    },

    _addStoresToView: function(){
      var self = this;

      _.each(self.data.stores, function(store, i) {
        var markerPosition,
            boundsContainsMarker;

        store.location = store.lat.toString() + store.long.toString();
        var existingLocations = _.filter(self.data.storesInView, { 'location': store.location});
        
        if (existingLocations.length > 0) {
      
          var accuracy = 0.004;
          if (Math.random() > 0.5) {
            store.lat += Math.random() * accuracy;
            store.long += Math.random() * accuracy;
          }
          else {
            store.lat -= Math.random() * accuracy;
            store.long -= Math.random() * accuracy;
          }
        }
        
        self.data.storesInView.push(store);

        store.in_view = true;
        // if(self.data.storesInView.length >= 100){
        //   self.data.maxStores = self.data.stores.length;
        //   console.log('reached 100')
        //   return false;
        // }

        

        // markerPosition = store.marker.getPosition();
        // boundsContainsMarker =  bounds.contains(markerPosition);

        // if (boundsContainsMarker && (!self.data.storesAreFiltered || self.data.storesAreFiltered && store.in_filter)) {
        //   store.in_view = true;

        //   self.data.storesInView.push(store);
        
          
        // } else {
        //   store.in_view = false;
        // }
        

        // if (store.group == self.data.activeGroup) {
        //   store.in_active_group = true;
        //   // self.data.storesInActiveGroup.push(store);
        // } else {
        //    store.in_active_group = false;
        // }

      });
    },

    _findUser: function(loadFromCache) {
      var self = this;

      this.data.loading = true;
      this.data.geolocationLoading = true;

      if(loadFromCache){
        var cachedLocation = localStorage.getItem('currentCustomerLocation');
        if(cachedLocation){
          var customerLocationData = JSON.parse(cachedLocation);
          success(customerLocationData);
        }
        else {
          navigator.geolocation.getCurrentPosition(success, error,{timeout:10000});
        }
      }
      else {
        navigator.geolocation.getCurrentPosition(success, error,{timeout:10000});
      }

      function success(position) {
        var pos;

        //don't show results if user moved onto search value
        if (self.data.cancelLocationSearch) {
          self.data.cancelLocationSearch = false;
          return;
        }

        if(position.lat != null){
          pos = {
            lat: position.lat,
            long: position.long
          };
        }
        else {
          pos = {
            lat: position.coords.latitude,
            long: position.coords.longitude
          };
        }
        
        userLocation = new google.maps.LatLng(pos.lat, pos.long);

        localStorage.setItem('currentCustomerLocation',JSON.stringify({ lat: pos.lat, long: pos.long }));

        self._setSearchLocation(userLocation);

        self.data.searchInProgress = true; 
        self.data.searching = true;

        self._getMoreStoresViaGeohash(self.data.findUserPrecision,true);
        // self._updateUserMarker(userLocation);

        // self._findClosestStore(userLocation);
        self.data.geolocationLoading = false;
      }

      function error() {
        
        self.data.geolocationLoading = false;
        self.data.geolocationEnabled = false;

        //don't show fail if user moved onto search value
        if (self.data.cancelLocationSearch) {
          self.data.cancelLocationSearch = false;
          return;
        }

        iziToast.error({
          title: 'We couldn\'t find your location',
          position: 'bottomCenter',
          theme: 'light',
        });

        self.data.loading = false;

      }


    },

    _findClosestStore: function(latLng) {

      var self = this;

      var closestStore,
          bounds,
          userLocation,
          currentMapZoom;

      bounds = new google.maps.LatLngBounds();

      closestStore = getClosestStore(latLng);

      self._setActiveStore(closestStore, false);

      bounds.extend(closestStore.marker.getPosition());
      bounds.extend(latLng);

      self.map.fitBounds(bounds);

      currentMapZoom = this.map.getZoom();

      if (currentMapZoom > this.options.activeStoreZoomLevel) {
        self.map.setZoom(this.options.activeStoreZoomLevel);
      }

      function getClosestStore(latLng) {

        // https://stackoverflow.com/questions/4057665/google-maps-api-v3-find-nearest-markers
        var lat = latLng.lat();
        var long = latLng.lng();
        var R = 6371; // radius of earth in km
        var distances = [];
        var closest = -1;

        var closestStore = null;

        function rad(x) {return x*Math.PI/180;}

        _.each(self.data.stores, function(store, i) {

            var mlat = store.lat;
            var mlng = store.long;

            var dLat  = rad(mlat - lat);
            var dLong = rad(mlng - long);
            var a = Math.sin(dLat/2) * Math.sin(dLat/2) +
                Math.cos(rad(lat)) * Math.cos(rad(lat)) * Math.sin(dLong/2) * Math.sin(dLong/2);
            var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
            var d = R * c;
            distances[i] = d;

            if ( closest == -1 || d < distances[closest] ) {
                closest = i;
                closestStore = store;
            }

        });

        return closestStore;

      }

    },

    _updateUserMarker: function(latLng) {

      var self = this;

      var pos,
          icon,
          user,
          locationMarkerSVG;

      if (!latLng) {
        console.error(new Error('latLng must be defined'));
        return;
      }

      function User(data) {
        _.extend(this, data);
      }

      if (!this.data.user) {

        locationMarkerSVG = theme.utils.getTemplate('user-location-marker-icon');
        this.data.user = new User({
          icon: locationMarkerSVG
        });

      }

      user = this.data.user;

      user.latLng = latLng;

      if (!user.marker) {
        icon = user.icon;

        user.marker = new google.maps.Marker({
          position: user.latLng,
          map: self.map,

          icon: {
            url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(icon),
            size: new google.maps.Size(24, 24),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(12, 12),
            scaledSize: new google.maps.Size(24, 24)
          },

          optimized: false

        });

      } else {

        user.marker.setPosition(user.latLng);

      }

    },

    _prepareSearch: function() {

      this.data.searchEnabled = true;

      var self = this;

      var searchField;

      // If the search box breaks it is because we are
      // using TinyBind but searching for the input field
      // with an ID. Perhaps use a tinybind binder to 
      // reference the input field.
      searchField = document.getElementById('store-locator-search')

      if (self.data.enableAutocomplete) {
        this.autocomplete = new google.maps.places.Autocomplete(searchField, {types: ['(regions)'], componentRestrictions: {'country': "au"}});

        // this.autocomplete.setComponentRestrictions({'country': ['au']});
        // this.autocomplete.setFields(["name", "address_component", "formatted_address"]);

        this.autocomplete.addListener('place_changed', function() {
          
          self.data.cancelLocationSearch = true;
          self._clearSearchByNameInput();

          var place;

          place = self.autocomplete.getPlace();

          if (!place.geometry) {

            iziToast.error({
              title: 'We couldn\'t find this location',
              position: 'bottomCenter',
              theme: 'light',
            });

            return;
          }

          self._setSearchLocation(place.geometry.location);
          // self._findClosestStore(place.geometry.location);
          //load location so geohash can load matches
          

          // clear all current results so only search hits are in map
          self._clearStores();

          // nessisary to unbind and rebind listeners for map so page doesnt load a bigger search result than required
          self.data.searchInProgress = true; 
          self.data.searching = true;

          self._getMoreStoresViaGeohash(4,true)

        });
      } else {

        searchField = document.getElementById('store-locator-search')
        $(searchField).on('keyup', function(event){
          self.initAutocomplete(event);
        });//_.debounce(, 1000));
        
        $(searchField).on('click', function(){
          self.data.autocompleteActive = true;
        });

        $('.store-locator__head').on('mouseleave', function(){
          self.data.autocompleteActive = false;
        });
      }
      
    },

    initAutocomplete: function(event){

      var self = this;

      // only search on enter
      if(event.keyCode == 13){
        return;
      }

      var searchField = document.getElementById('store-locator-search');

      var searchTerm = searchField.value;

      self.data.autocompleteActive = true;
      if(searchTerm.length < self.data.minAutocompleteLength){
        return;
      }

      self._clearSearchByNameInput();
      self.data.noresults = false;

      var pastResults = _.find(self.data.postcodeSearches, {'searchTerm' : searchTerm});
      if (pastResults) {
        var results = self.validateResponseLength(pastResults.response,searchTerm);
        self.data.postcodes = results;

      } else {
        self.searchByPostcode(searchTerm);
      }

    },

    searchByPostcode: function(searchTerm){  

      var self = this;

      var urlPrefix = "https://us-central1-astute-smile-292303.cloudfunctions.net/"
      var APIUrl = urlPrefix + "findPostcodeLatLong?searchTerm="+ searchTerm +"&shop=tupperware-au.myshopify.com";//v=" + (production ? '' :new Date().getTime());
      
      $.ajax({ 
        url: APIUrl, 
        type: 'GET', 
        dataType: 'json', 
        success: function(response) {
          var results = [];
          if(response){
            if(response.length > 5){
              results = self.validateResponseLength(response,searchTerm)
        
            } else {
              results = response;
            }
            
            self.data.postcodes = results
            self.data.postcodeSearches.push({ 'searchTerm': searchTerm, 'response': results });
       
            self.data.loading = false;
          
            
          }
          else {
            console.warn('these was an error getting the data.');
          }

        },
        error: function(){
          self.data.noresults = true;
          // theme.utils.showError('Oops something went wrong trying to load the postcode.');
        } 

      });
    },

    validateResponseLength: function(response,searchTerm){
      var self = this;
      var postcodes = response;
      
      if (searchTerm.length > 3) {
        var multipleResults = _.filter(response, function(item){
          if (item.postcode == searchTerm) {
            return item;
          }
        });
        if(multipleResults.length > 5){
          postcodes = response.splice(0,multipleResults.length);
        }
        else {
          postcodes = response.splice(0,self.data.autocompleteLimit);
        }
      }
      else {
        postcodes = response.splice(0,self.data.autocompleteLimit);
      }

      return postcodes;
    },

    _setSearchLocation: function(location){
      var self = this;

      self.data.searchLocation.lat = location.lat();
      self.data.searchLocation.lng = location.lng();
    },

    _clearSearchByPostcodeInput: function(){
      var searchInput = document.getElementById('store-locator-search');
      if(searchInput){
        searchInput.value = '';
      }
    },

    _clearSearchByNameInput: function(){
      var searchInput = document.getElementById('store-locator-search-secondary');
      if(searchInput){
        searchInput.value = '';
      }
    },

    _clearTempSearchParams: function(){
      var self = this;

      _.each(self.data.stores, function(store, i) {
        if(store.distanceToCurrentSearch){
          store.distanceToCurrentSearch = 0;
        }
        if(store.tempSort){
          store.tempSort = 0;
        }
      });
    },

    _calConsultantDistances: function(results){
      var self = this;

      for (var i = 0; i < results.length; i++) {
        var store = results[i];
        var lat = store.lat;
        var lng = store.long;

        results[i].distanceToCurrentSearch = self._calcHaversineDistance([lat,lng],[self.data.searchLocation.lat,self.data.searchLocation.lng]);
      }

      return results;

    },

    _sortResultsByName: function(searchValue){
      var self = this;

      var searchValue = searchValue.join(',');

      for (var i = 0; i < self.data.stores.length; i++) {
        var store = self.data.stores[i];
        if(searchValue.toLowerCase().includes(store.suburb.toLowerCase()) || searchValue.toLowerCase().includes(store.postcode)){
          store.tempSort = -1; //resets to 0 
        }
        else {
          store.tempSort = 2;
        }
      }
    },

    _calcHaversineDistance: function(mk1, mk2) {
      var R = 6371.0710; // Radius of the Earth in kilometers
      var rlat1 = mk1[0] * (Math.PI/180); // Convert degrees to radians
      var rlat2 = mk2[0] * (Math.PI/180); // Convert degrees to radians
      var difflat = rlat2-rlat1; // Radian difference (latitudes)
      var difflon = (mk2[1]-mk1[1]) * (Math.PI/180); // Radian difference (longitudes)

      var d = 2 * R * Math.asin(Math.sqrt(Math.sin(difflat/2)*Math.sin(difflat/2)+Math.cos(rlat1)*Math.cos(rlat2)*Math.sin(difflon/2)*Math.sin(difflon/2)));
      return d;
    },

    _updateSearchMarker: function(latLng) {

      if (!this.options.showSearchMarker) {
        return;
      }

      var self = this;

      var pos,
          icon,
          locationMarkerSVG;

      if (!latLng) {
        console.error(new Error('latLng must be defined'));
        return;
      }

      function Search(data) {
        _.extend(this, data);
      }

      if (!this.data.search) {

        locationMarkerSVG = theme.utils.getTemplate('search-location-marker-icon');
        this.data.search = new Search({
          icon: locationMarkerSVG
        });

      }

      search = this.data.search;
      search.latLng = latLng;

      if (!search.marker) {

        icon = search.icon;

        search.marker = new google.maps.Marker({
          position: search.latLng,
          map: self.map,

          icon: {
            url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(icon),
            size: new google.maps.Size(24, 24),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(12, 12),
            scaledSize: new google.maps.Size(24, 24)
          },

          optimized: false

        });

      } else {

        search.marker.setPosition(search.latLng);
        
      }

      this.map.panTo(latLng);
      this.map.setZoom(12);
    },


  });
  
  return StoreLocator;

})();



theme.ConsultantFinder = (function() {
  function ConsultantFinder() {
    

    if($('.TestimonialList--consultant').length > 0){
      initTestimonialsSlider();
    }
    function initTestimonialsSlider(){
      var elem = document.querySelector('.TestimonialList--consultant');
      $(elem).on( 'ready.flickity', function() {
        console.log('Flickity ready');
      });
      var flkty = new Flickity( elem, {
        // options
        pageDots: false,
        cellAlign: 'left',
        contain: true,
        groupCells: true
      });
    }

  }


  return ConsultantFinder;
})();

/*============================================================================
  Wishlist Events 
==============================================================================*/

function initialiseWishlistOnRecommendations() {
  // Initialise Swymm wishlist on Recommendedd products
  if ('_swat' in window) {
    var productRecommendationsContainer = document.querySelector('.ProductRecommendations');
    if (!productRecommendationsContainer) {
      return
    }
    var i = 0;
    var interval = setInterval(function () {
      i++
      if (i > 100) {
        clearInterval(interval);
      }
      if (productRecommendationsContainer.innerHTML.length > 0) {
        clearInterval(interval);
        _swat.initializeActionButtons('.ProductRecommendations')
      }
    }, 200);
  }
}

function initialiseWishlistOnRecentlyViewedProducts() {
  if ('_swat' in window) {
    var recentlyViewedProductsSectionContainer = document.getElementById('shopify-section-recently-viewed-products');
    if (!recentlyViewedProductsSectionContainer) {
      return;
    }
    var i = 0;
    var interval = setInterval(function () {
      i++
      if (i > 100) {
        clearInterval(interval);
      }
      var productItems = recentlyViewedProductsSectionContainer.querySelectorAll('.ProductItem');
      if (productItems.length) {
        clearInterval(interval);
        _swat.initializeActionButtons('#shopify-section-recently-viewed-products');
      }
    }, 200)
  }
}


window.theme = window.theme || {};

theme.ProductPage = (function() {

  function ProductPage(container) {

    if($('.ProductForm__OpenTerms').length > 0){
      initConsultantKitModal();
    }

    loyaltyLionBreakdowns();
    
    var direct_link = localStorage.getItem('party_information');
    direct_link = JSON.parse(direct_link);

    if($('.ArticleListWrapper').length > 0) {
      initRelatedProductArticles();
    }
    function initRelatedProductArticles(){
      var elem = document.querySelector('.ArticleList--carousel');
      var flkty = new Flickity( elem, {
        pageDots: false,
        cellAlign: 'left',
        contain: true,
        groupCells: true
      });
    }
    
    var direct_link = localStorage.getItem('party_information');
    direct_link = JSON.parse(direct_link);

    if(direct_link){
      document.addEventListener('success:recently-viewed-products-loaded',function(){
        checkMembershipGridItemDiscount();
      });
      document.addEventListener('success:related-products-loaded',function(){
        checkMembershipGridItemDiscount();
      });
    }


    var is_member_product = document.querySelector('[data-membership-product]');
    if(is_member_product){
      var id = is_member_product.dataset.membershipProduct;
      var discount = is_member_product.dataset.membershipDiscount;
      var key = id + '##' + discount;
      checkMembershipDiscount(key);
    }

    function checkMembershipDiscount(key){
      var direct_link = localStorage.getItem('party_information');

      let overrideElement = document.querySelector('.membership-price-override');
      if (overrideElement){
        return;
      }
      
      if(direct_link){
        direct_link = JSON.parse(direct_link);

        if(direct_link.is_direct_link){
          var input = document.createElement('input');
          input.classList.add('hidden');
          input.value = key;
          input.name = 'properties[_discount]';
          $('.ProductForm').append(input);
        }
 
        let discountedPriceElement = document.querySelector('[data-discounted-price]');
        if (discountedPriceElement){
          let discountedPriceMoney = discountedPriceElement.dataset.discountedMoney;
          let discountedPriceAmount = discountedPrice = discountedPriceElement.dataset.discountedPrice;

          $('.ProductMeta__Price').css('text-decoration','line-through');
          $('.ProductMeta__PriceList').prepend('<span class="ProductMeta__Price Price Price--highlight Text--subdued u-h4" style="margin-right:1rem;">'+discountedPriceMoney+'</span>');

          
          let loyaltyPointsElement = document.querySelector('[data-lion-points-for-redemption]');
          let loyaltyPointsEarnt = parseInt(loyaltyPointsElement.dataset.lionPointsForRedemption) * parseInt(discountedPriceAmount)
          loyaltyPointsElement.innerHTML = loyaltyPointsEarnt / 100;

          let breakdown = parseInt(discountedPriceAmount) / 4;
          let afterpayAmount = document.getElementById('afterpay_instalments');
          afterpayAmount.innerHTML = Shopify.formatMoney(breakdown);
        }
        
      }
      
    }

    function checkMembershipGridItemDiscount(){

      let membershipProductPrice = document.querySelectorAll('.ProductItem .is-membership-product');

      if (membershipProductPrice.length == 0){
        return;
      }
      
      for (var i = 0; i < membershipProductPrice.length; i++) {
        
        let gridItem = membershipProductPrice[i].closest('.ProductItem')
        if (gridItem.querySelector('.membership-price-override')){
          continue; 
        }

        let productPrice = parseFloat(gridItem.querySelector('.ProductItem__Price').dataset.price);
        let discountDecimal = window.shop.membershipProduct.discount_in_decimal;
        let discountedPriceAmount = productPrice * discountDecimal;

        let priceElement = gridItem.querySelector('.ProductItem__Price')
        let priceListElement = gridItem.querySelector('.ProductItem__PriceList')
        $(priceElement).css('text-decoration','line-through');
        $(priceListElement).prepend('<span class="ProductItem__Price Price Price--highlight Text--subdued membership-price-override" style="margin-right:1rem;">'+ Shopify.formatMoney(discountedPriceAmount) +'</span>');
        
      }
      
    }

    function loyaltyLionBreakdowns(){

      var loyaltyPrice = document.querySelector('[data-lion-price-for-product-id]'); 

      if(!loyaltyPrice){
        return;
      }

      var loyaltyPriceValue = loyaltyPrice.innerHTML;
      var loyaltyLionValue = parseFloat(loyaltyPrice.innerHTML.replace('$', ''));

      if ($('[data-lion-purchase-points]').length){
        var perDollar = parseFloat($('[data-lion-purchase-points]').attr('data-lion-purchase-points'));
        $('[data-lion-purchase-points]').text(loyaltyLionValue * perDollar);
      }

      if ($('[data-lion-dollars-for-product-id]').length){
        $('[data-lion-dollars-for-product-id]').text(loyaltyPriceValue);
      }

      if ($('[data-lion-points-for-redemption]').length){
        var perRedeem = parseFloat($('[data-lion-points-for-redemption]').attr('data-lion-points-for-redemption'));
        $('[data-lion-points-for-redemption]').text(loyaltyLionValue * perRedeem);
      }

    }

    function initConsultantKitModal(){
      var modalContent = theme.utils.getTemplate('consultant-kit-modal');

      $('.ProductForm__OpenTerms').on('click', function(){
        var modal = new theme.Modal(modalContent, {
          featherlightOptions: {
            variant: 'od-modal--primary',
          }
        });
      });

      var productForm = $('.ProductForm');
      $('body').on('click', '.consultant-kit-modal__button', function(){
        // productForm.submit();
      });
    }
  }


 return ProductPage;

})();


window.theme = window.theme || {};

theme.NewsletterPopup = (function() {

  function NewsletterPopup(container) {

    function hideOnChallengePage(){
      $('.NewsletterPopup').addClass('hidden');
    }

    function showPopup(){
      $('.NewsletterPopup').attr('aria-hidden', "false");  
    }

    if($('.shopify-challenge__container').length > 0){
      hideOnChallengePage();
    }
    
    if($('.NewsletterPopup--success').length > 0 || $('.NewsletterPopup--error').length > 0 || $('.NewsletterPopup--return').length > 0){
      showPopup();
    }

  }

 return {
    NewsletterPopup: NewsletterPopup
  };

})();

window.theme = window.theme || {};

theme.NewsletterFooter = (function() {

  function NewsletterFooter(container) {

    function hideOnChallengePage(){
      $('.Footer__Newsletter').addClass('hidden');
    }

    function showNewsletterSuccessPopup(){
      scrollToForm();

      var message = $('.Footer__Newsletter .Alert--success').text();
      iziToast.show({
        message: message,
        color: 'green',
        position: 'bottomCenter'
      });

    }

    function showNewsletterErrorPopup(){
      
      scrollToForm();
      var message = $('.Footer__Newsletter .Alert--error').text();
      iziToast.show({
        message: message,
        color: 'red',
        position: 'bottomCenter'
      });

    }

    function scrollToForm(){
      var currentFieldElement = document.getElementById('section-footer');
      $(window).stop(true).scrollTo(currentFieldElement, {
        duration: 700,
        interrupt: false, // Don't allow interupt on iOS
        offset: 100
      });
    }

    if($('.shopify-challenge__container').length > 0){
      hideOnChallengePage();
    }
    
    if($('.newsletter-form--success').length > 0 || $('.newsletter-form--return').length > 0){
      showNewsletterSuccessPopup();
    }

    if($('.newsletter-form--error').length > 0){
      showNewsletterErrorPopup();
    }



  }

 return {
    NewsletterFooter: NewsletterFooter
  };

})();



window.theme = window.theme || {};

theme.AsyncForms = (function() {

  function AsyncForms(container) {
    // Submit customer forms with Accentuate
    var asyncForms = document.querySelectorAll('[data-async-submit]');
    for (var i = asyncForms.length - 1; i >= 0; i--) {
      var asyncForm = asyncForms[i];
      $(asyncForm).on('submit.asyncSubmit', function() {
        event.preventDefault();
        
        
        var validForm = true;
        var phoneField = $(this).find('[name="customer[phone]"]');
        if (phoneField.length > 0){
          var validForm = validatePhoneNumber(phoneField[0])
          if (!validForm){
            showErrorMessage(phoneField[0]);
            return;
          }
          else {
            removeErrorMessage(phoneField[0]);
          }
        }
        
        var form = $(this)[0];
        asyncSubmitForm(form);
      });
    }

    function showErrorMessage(field){
      field.classList.add('error');
    }

    function removeErrorMessage(field){
      field.classList.remove('error');
    }

    function validatePhoneNumber(field){
      var phonenumber = field.value.toString().replaceAll(' ','');
      let newValue = ''
      if (phonenumber[0] == "+" ) {
        newValue = phonenumber;
      }
      else if (phonenumber[0] == "6" && phonenumber[1] == "1"){
        newValue = '+' + phonenumber;
      }
      else if (phonenumber[0] == "0"){
        newValue = '+61' + phonenumber.substring(1);
      }
      else {
        phonenumber = phonenumber.length == 10 ?  phonenumber.replace(/^0+/, "") : phonenumber;
        newValue = '+61' + phonenumber;
      }

      if (newValue.length != 12){
        return false;
      }

      newValue = newValue.match(/.{1,3}/g);
      newValue = newValue.join(' ');

      if (newValue.length != 15){
        return false;
      }

      field.value = newValue;

      return true;
    }

    function asyncSubmitForm(form) {

      var submitButton = form.querySelector('[type="submit"]');
      form.classList.add('loading');
      submitButton.classList.add('loading');

      var $form = $(form);
      loadJS('https://app.accentuate.io/dist/proxy.js', function() {

        $form.off('submit.asyncSubmit');

        Accentuate($form, function() {
          setTimeout(function() {
            window.location.reload();
          }, 500);
        });

        $form.submit();

      });

    }
  }

  return {
    AsyncForms: AsyncForms
  };

})();

window.theme = window.theme || {};

theme.PromotionsCustomerCheck = (function() {

  function PromotionsCustomerCheck(cart) {
    
    this.checkCart(cart);

    
  }

  PromotionsCustomerCheck.prototype = $.extend({}, PromotionsCustomerCheck.prototype, {
    
    checkCart: function(cart){
      var self = this;
      var cart = cart.items;

      if(window.shop.customer.promotions_customer){
        window.shop.customer.promotions_customer_live = true;
      }
      else {
        var promotionsProductInCart = _.find(cart, { 'product_type': 'Membership'});
        window.shop.customer.promotions_customer_live = promotionsProductInCart || window.shop.customer.promotions_customer ? true : false;
      }

      var promotions_customer = window.shop.customer.promotions_customer_live;
      this.updateCart(promotions_customer);
      this.updateGridItems(promotions_customer);

      if ($('.Product').length > 0) {
        this.updateProductPage(promotions_customer);
      }
    },

    updateProductPage: function(promotions_customer){

      if(promotions_customer){
        showProductForm();
        showMysteryPackButton();
        hidePromotionsProductWarning();
      }
      else {
        hideMysteryPackButton();
        showPromotionsProductWarning();
        hideProductForm();
      }

      

      function showPromotionsProductWarning(){
        $('.promotion-item-warning.cart-override--silver-gold').removeClass('hidden');
      }

      function hidePromotionsProductWarning(){
        $('.promotion-item-warning.cart-override--silver-gold').addClass('hidden');
      }

      function showProductForm(){
        $('.ProductForm.cart-override--silver-gold').removeClass('hidden');
      }

      function hideProductForm(){
        $('.ProductForm.cart-override--silver-gold').addClass('hidden');
        $('.ProductForm.cart-override--silver-gold .ProductForm__Actions').addClass('hidden');
      }

      function showMysteryPackButton(){
        $('.mystery-pack-product__btn.cart-override--silver-gold').removeClass('hidden');
      }

      function hideMysteryPackButton(){
        $('.mystery-pack-product__btn.cart-override--silver-gold').addClass('hidden');
      }

    },

    updateGridItems: function(promotions_customer){


      if(promotions_customer){
        showPromotionQuickAdd();
      }
      else {
        
      }

      function showPromotionQuickAdd(){
        $('.ProductItem__ActionButton--add.cart-override--silver-gold').removeClass('hidden');
        $('.ProductItem__ActionButton--restricted.cart-override--silver-gold').addClass('hidden');
      }
    },

    updateCart: function(promotions_customer){
      // no longer a promotions customer based rule
      // if(promotions_customer){
      //   showCartGifts();
      // }
      // else {
      //   hideCartGifts();
      // }

      function hideCartGifts(){
        $('.cart-drawer__section.cart-drawer__cart-gifts').addClass('hideGifts');
      }

      function showCartGifts(){
        $('.cart-drawer__section.cart-drawer__cart-gifts').removeClass('hideGifts');
      }
        setTimeout(function(){
          if(document.body.classList.contains('special_customer')){
            // brandBuiler_offer();
            Bottle_offerProduct();
            //  disc_prodcutAdd();
            // guest_offer();
            // week11_special();
            // pv_one_time();
            // b1g1();
          }else{
             Bottle_offerProduct();
            //  disc_prodcutAdd();
            // guest_offer();
            // week11_special();
            // pv_one_time();
            // b1g1();
          }
        $('.cart-item').each(function() {
        var prdid = $(this).attr('data-product-id');
        var qty_prd = $('.cart-item-quantity__quantity').text();
        // console.log('qty_prd', qty_prd);
        var $actualPrice = $(this).find('.actual_price[matched_id="' + prdid + '"]');
        
        if ($actualPrice.length > 0) {
        // console.log('$actualPrice', $actualPrice);
        $actualPrice.css('display', 'block');
        }
        });
        function updatePrices() {
        const cartItems = document.querySelectorAll('.cart-item');
        
        cartItems.forEach(item => {
        const productId = item.getAttribute('data-product-id');
        const quantityElement = item.querySelector('.cart-item-quantity__quantity');
        const quantity = parseInt(quantityElement.textContent) || 0; // Default to 0 if quantity is NaN
        const actualPriceElements = item.querySelectorAll('.actual_price');
        
        actualPriceElements.forEach(priceElement => {
        const matchedId = priceElement.getAttribute('matched_id');
        if (matchedId === productId) {
        const comparePriceElement = priceElement.querySelector('.compare_price');
        const comPrice = parseFloat(comparePriceElement.getAttribute('com_price'));
        
        // Check if comPrice is a valid number
        if (!isNaN(comPrice) && comPrice !== null) {
        const updatedComPrice = comPrice * quantity;
        comparePriceElement.textContent = `₹${updatedComPrice.toFixed(2)}`;
        } else {
        comparePriceElement.textContent = ''; // Clear the content if comPrice is invalid
        }
        }
        });
        });
        if(!document.body.classList.contains('special_customer')){
          var priceCartDrawer = document.querySelectorAll('.cart-item-price__price');
          var compare_priceCartDrawer = document.querySelectorAll('.actual_price .compare_price');
          priceCartDrawer.forEach(price => {
            compare_priceCartDrawer.forEach(compare_price => {
              if (price.textContent.replace(',','').trim() === compare_price.textContent.trim()) {
                price.classList.add('hidden');
                compare_price.classList.remove('Price--compareAt');
              }
            });
          });
        }
          // $('#CartDrawer').load(location.href +  " #CartDrawer");
        }
        const special_customer_price = () => {
        $.ajax({
        url: '/cart.js',
        method: 'GET',
        dataType: 'json',
        success: function(data) {
        data.items.forEach(function(item) {
        const itemContainer = $(`.cart-item[data-product-id="${item.id}"]`);
        const savingPriceDiv = itemContainer.find('.saving_price');
        savingPriceDiv.text(`₹${(item.total_discount / 100).toFixed(2)}`);
        const comparePriceDiv = itemContainer.find('.compareprice');
        comparePriceDiv.text(`₹${(item.original_line_price / 100).toFixed(2)}`);
        });
        },
        error: function(error) {
        console.error('Error:', error);
        }
        });
        };
        if ($('body').hasClass('special_customer')) {
        special_customer_price();
        }
        else{
        updatePrices()  
        }         
        }, 100);
    }
  });

  return PromotionsCustomerCheck;

})();


window.theme = window.theme || {};

theme.CustomerAttribution = (function() {

  function CustomerAttribution(cart) {
    
    this.checkAttributes(cart);

    
  }

  CustomerAttribution.prototype = $.extend({}, CustomerAttribution.prototype, {
    
    checkAttributes: function(cart){
      var self = this;
      
      if (!cart.attributes.selected_consultant_pre_checkout){
        var cartAttributes = {
          selected_consultant_pre_checkout: false,
          selection_type: 'none'
        };

        CartJS.setAttributes(cartAttributes);
      }
    },


  });

  return CustomerAttribution;

})();



window.theme = window.theme || {};

theme.ConsultantDirectLink = (function() {
  var selectors = {
    consultantKey: 'cId',
    partyKey: 'pn',
    partyType: 'ptype',
    recId: 'rId',
    guestId: 'gId',
    hostName: 'hn',
    partyDate: 'pd',
    headerContainer: '.Header'
  }

  function ConsultantDirectLink() {
    
    this.queryparams = theme.utils.getQueryParams();
    if(!this.queryparams[selectors.consultantKey]){
      return;
    }
    
    this.getDirectLinkData();

    if(!this.consultantId){
      console.log('no consultant id');
      return;
    }

    this.showLoadingModal();

    this.runConsultantDirectLinks();
    
  }

  ConsultantDirectLink.prototype = $.extend({}, ConsultantDirectLink.prototype, {

    runConsultantDirectLinks: async function(){
      var self = this;

      await self.getDirectLinkConsultant();
      self.setConsultantAndPartyInformation();

      var batchArray = [];
      batchArray.push( self.submitSelectedConsultantNote() );
      batchArray.push( self.submitConsultantAndPartyAttributes() );

      await Promise.all(batchArray).then(function() {
        self.showSuccessModal();
      }).catch(function(error) {
        console.log(error);
      });
    },

    closeModal: function(){
      var self = this;

      var modalContent = theme.utils.getTemplate('consultant-link-modal-error');
      self.modal.modal.$content.replaceWith(modalContent.replace('loading',''));
      self.modal.modal.$instance.removeClass('loading');

      //self.modal.modal.close();
    },

    getDirectLinkData: function(){
      var self = this;
      
      self.consultantId = self.queryparams[selectors.consultantKey];

      var toDecode = {
        partyId: self.queryparams[selectors.partyKey],
        partyType: self.queryparams[selectors.partyType],
        recId: self.queryparams[selectors.recId],
        guestId: self.queryparams[selectors.guestId],
        hostName: self.queryparams[selectors.hostName],
        partyDate: self.queryparams[selectors.partyDate]
      };

      try{
        var parsedValue = theme.utils.parseBase64Value(self.consultantId);
        self.consultantId = atob(parsedValue);
      }
      catch(e){
        console.error(e);
        self.consultantId = '';
      }

      if(!self.consultantId){
        return;
      }

      self.partyInformation = {};
      for (var i = 0; i < Object.keys(toDecode).length; i++) {
        var key = Object.keys(toDecode)[i];
        var value = toDecode[Object.keys(toDecode)[i]];
        
        if(value){
          var parsedValue = '';
          try{
            parsedValue = theme.utils.parseBase64Value(value);
            
          }
          catch(e){
            console.error(e);
            self.partyInformation[key] = '';
          }

          try{
            self.partyInformation[key] = atob(parsedValue);
          }
          catch(e){
            console.error(e);
            self.partyInformation[key] = '';
          }
        }
      }
      self.partyInformation['is_direct_link'] = true;
    },

    getDirectLinkConsultant: async function(){
      var self = this;

      return new Promise(function(resolve, reject) {

        var urlPrefix = "https://us-central1-astute-smile-292303.cloudfunctions.net/";
        var APIUrl = urlPrefix + "findConsultantsByName?searchTerm="+self.consultantId+"&shop=tupperware-au.myshopify.com";

        $.ajax({ 
          url: APIUrl, 
          type: 'GET', 
          dataType: 'json', 
          success: function(response) {
            if(response.length > 0){
              var data = response;
              self.selectedConsultant = data[0];
              return resolve();
            }
            else {
              console.log('Not a valid consultant id');
              self.selectedConsultant = '';
              return resolve();
            }

          },
          error: function(){
            console.log('these was an error getting the data.');
            reject();
          } 
        });

      }).catch(function(error) {
        console.log(error);
      });

    },

    setConsultantAndPartyInformation: function(data){
      var self = this;

      if(!self.selectedConsultant){
        console.log('no consultant by that id');
        self.closeModal();
        return;
      }

      self.selectedConsultant.selected_consultant_pre_checkout = true;
      self.selectedConsultant.selection_type = 'direct';

      localStorage.setItem('Selected_Consultant', theme.utils.simpleStringify(self.selectedConsultant));
      
      self.cartNote = 'consultantId:' + self.selectedConsultant.handle;
      self.cartAttributes = {};

      var fieldsToUpdate = ['dbEmail', 'dbPhone', 'distributorId', 'email', 'firstName', 'lastName', 'title'];
      for (var i = 0; i < fieldsToUpdate.length; i++) {
        var key = fieldsToUpdate[i];
        var name = 'consultant_' + key;
        var value = self.selectedConsultant[key];

        if(key == 'title'){
          function capitalizeFirstLetter(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
          }
          var value = capitalizeFirstLetter(self.selectedConsultant.firstName.toLowerCase()) + ' ' + capitalizeFirstLetter(self.selectedConsultant.lastName.toLowerCase());
        }

        self.cartAttributes[name] = value;
      }

      localStorage.setItem('party_information', theme.utils.simpleStringify(self.partyInformation));

      for (var i = 0; i < Object.keys(self.partyInformation).length; i++) {
        var key = Object.keys(self.partyInformation)[i];
        var value = self.partyInformation[Object.keys(self.partyInformation)[i]];
        
        if(value){
          self.cartAttributes[key] = self.partyInformation[key];
        }
      }

      self.cartAttributes['consultantId'] = self.selectedConsultant.handle;
      self.cartAttributes['selected_consultant_pre_checkout'] = self.selectedConsultant.selected_consultant_pre_checkout;
      self.cartAttributes['selection_type'] = self.selectedConsultant.selection_type;
    },

    submitSelectedConsultantNote: async function(data){
      var self = this;

      return new Promise(function(resolve, reject) {
        CartJS.setNote(self.cartNote,{
          "success": function(data, textStatus, jqXHR) {

            return resolve();
            
          },
          "error": function(jqXHR, textStatus, errorThrown) {
            console.log('Error: ' + errorThrown + '!');
            reject(errorThrown);
          }
        });
      }).catch(function(error) {
        console.log(error);
      });
    },

    submitConsultantAndPartyAttributes: async function(data){
      var self = this;

      return new Promise(function(resolve, reject) {
        CartJS.setAttributes(self.cartAttributes,{
          "success": function(data, textStatus, jqXHR) {

            return resolve();
            
          },
          "error": function(jqXHR, textStatus, errorThrown) {
            console.log('Error: ' + errorThrown + '!');
            reject();
          }
        });
      }).catch(function(error) {
        console.log(error);
      });
    },

    showLoadingModal: function(){
      var self = this;
      var modalContent = theme.utils.getTemplate('consultant-link-modal');

      self.modal = new theme.Modal(modalContent, {
        featherlightOptions: {
          variant: 'od-modal--primary',
        }
      });
      self.modal.modal.$instance.addClass('loading');
    },


    showSuccessModal: function(){
      var self = this;

      var modalContent = theme.utils.getTemplate('consultant-link-modal');
      
      
      if (self.partyInformation['hostName']){
        self.modal.modal.$content.replaceWith(modalContent.replaceAll('[name]',self.selectedConsultant.title).replaceAll('loading','').replaceAll('[host-name]',self.partyInformation['hostName']).replaceAll('[party-date]',self.partyInformation['partyDate']).replaceAll('[consultant-class]','hidden').replaceAll('[party-class]','active'));
      } 
      else {
        self.modal.modal.$content.replaceWith(modalContent.replaceAll('[name]',self.selectedConsultant.title).replaceAll('loading','').replaceAll('[party-class]','hidden').replaceAll('[consultant-class]','active'));
      }
      self.modal.modal.$instance.removeClass('loading');
    }

  });

  return ConsultantDirectLink;

})();

window.theme = window.theme || {};

theme.CollectionPage = (function() {

  function CollectionPage() {

    let collectionHeader = document.querySelector('.collection-header');
    
     checkMembershipDiscount()
    
    function checkMembershipDiscount(key){
      var direct_link = localStorage.getItem('party_information');

      let membershipProductPrice = document.querySelector('.ProductItem .is-membership-product');
      let overrideElement = document.querySelector('.ProductItem .membership-price-override');
      if (!membershipProductPrice || overrideElement){
        return;
      }
      
      if(direct_link){
        direct_link = JSON.parse(direct_link);
        let gridItem = membershipProductPrice.closest('.ProductItem')

        let productPrice = parseFloat(gridItem.querySelector('.ProductItem__Price').dataset.price);
        let discountDecimal = window.shop.membershipProduct.discount_in_decimal;
        let discountedPriceAmount = productPrice * discountDecimal;

        let priceElement = gridItem.querySelector('.ProductItem__Price')
        let priceListElement = gridItem.querySelector('.ProductItem__PriceList')
        $(priceElement).css('text-decoration','line-through');
        $(priceListElement).prepend('<span class="ProductItem__Price Price Price--highlight Text--subdued" style="margin-right:1rem;">'+ Shopify.formatMoney(discountedPriceAmount) +'</span>');
      
        
      }
      
    }
  }

  return CollectionPage;

})();

$(document).on('ready', function () {

  theme.AjaxCart.init();
  var cartGiftsContainer = document.querySelector('[data-section-type="cart-gifts"]');
  if (cartGiftsContainer) {
    new theme.CartGifts(cartGiftsContainer);
  }

  new theme.Header($('.Header')[0]);
  let cartUpsell = new theme.CartUpsell($('.cart-upsell-section')[0],true);

  $(document).on('cart.requestComplete', function(event, cart) {
    cartUpsell.update(cart);
  });

  
  // must come directly after cart and before page sections
  new theme.PromotionsCustomerCheck(CartJS.cart);
  new theme.CustomerAttribution(CartJS.cart);

  $(document).on('cart.requestComplete', function(event, cart) {
    theme.PromotionsCustomerCheck.prototype.checkCart(cart);
  });


  if($('.landing-page-row').length > 0){
    theme.LandingPages();

    var videoContainer = document.querySelector('[data-video]');
    if($('[data-video]').length > 0){
      new theme.Video(videoContainer);
    }
  }

  var collectionPage = document.querySelector('.template-collection')
  if(collectionPage){
    new theme.CollectionPage();
  }

  var newsletterPopup = document.querySelector('.NewsletterPopup');
  
  
  if (newsletterPopup) {
    theme.NewsletterPopup.NewsletterPopup();
  }

  var NewsletterFooter = document.getElementById('footer-newsletter');
  if (NewsletterFooter && !newsletterPopup) {
    theme.NewsletterFooter.NewsletterFooter();
  }

  if ($('.Product').length > 0) {
    new theme.ProductPage();
  }

  if($('.store-locator').length > 0){
    new theme.StoreLocator($('.store-locator')[0]);
  }

  if($('.template--consultant-finder').length > 0){
    theme.ConsultantFinder();
  }

  if($('.Article').length > 0){
    theme.ArticlePage();
  }

  if($('.CollectionOffers__offer').length > 0){
    theme.CollectionOffers();
  }

  if($('.TileSlider__Block').length > 0){
    theme.TileSlider();
  }


  if($('[data-async-submit]').length > 0){
    theme.AsyncForms.AsyncForms();
  }

  const pdpExpandDescription = document.querySelector('.js-open-description');
  if (pdpExpandDescription) {
    pdpExpandDescription.addEventListener('click', () => {
      const pdpProductDescription = document.querySelector('.product-page--description .accordion--product-description');
      if (!pdpProductDescription) return;

      if (!pdpProductDescription.classList.contains('active')) {
        const clickEvent = new Event('click');
        pdpProductDescription.dispatchEvent(clickEvent);
      }

      const smoothScrollToEle = () => {
        window.scrollTo({
          top: (pdpProductDescription.offsetTop),
          behavior: 'smooth',
        });
      };
      window.requestAnimationFrame(smoothScrollToEle);
    });
  }

  // initCheckNewsletterPopupSuccess();
  initialiseWishlistOnRecommendations();
  initialiseWishlistOnRecentlyViewedProducts();

  

  

  var queryparams = theme.utils.getQueryParams();
  if(queryparams){
    new theme.ConsultantDirectLink();
  }

  $('section').on('section:slider:ready', function() {
    theme.PromotionsCustomerCheck.prototype.updateGridItems(window.shop.customer.promotions_customer_live);
  });

  document.addEventListener('product:changed', function(event) {
    console.log('product:changed');
  });

  document.addEventListener('theme:loading:end', function(event) {
    console.log('theme:loading:end');
  });

  // Update AfterPay price
  document.addEventListener('variant:changed', function(event) {
    var variant = event.detail.variant;
    var afterpayPriceContainer = document.getElementById('afterpay_instalments');
    if (afterpayPriceContainer){
      afterpayPriceContainer.innerText = Shopify.formatMoney(variant.price / 4);
    }
    
    if ($('.properties_selected_price')){
      $('.properties_selected_price')[0].value = variant.price;
    }
    

    if(variant.available){
      $('.loyalty-lion-product-points-count').removeClass('hidden');
    }
    else {
      $('.loyalty-lion-product-points-count').addClass('hidden');
      
    }
  });

  document.addEventListener('product:added', function(event) {
    $('body').addClass('cart-loading--opens-drawer');
    CartJS.getCart();
  });

});

document.addEventListener('DOMContentLoaded', (event) => {
  let mobileLoyaltyButton = document.querySelector('.js-loyalty-button');
  
  if (!mobileLoyaltyButton) return;
  mobileLoyaltyButton.addEventListener('click', function(){
    let loyaltyLionTrigger = document.querySelector('.lion-loyalty-widget__body');
    loyaltyLionTrigger.click();
  })
});


// ===================================================
// TWP | CONSULTANT FINDER HERO SECTION
// ===================================================

// class PostCodeSearch extends HTMLElement {
  // constructor() {
  //   super();
  //   this.formEl = this.querySelector('form');
  //   this.postcodeInputEl = this.querySelector("[data-search-postcode-input]");
  //   this.suggestionsEl = this.querySelector('[data-suggestions]');
  //   this.consultantInputEl = this.querySelector("[data-search-consultant-input]");

  //   this.strings = {
  //     hint: this.suggestionsEl?.getAttribute('data-default-string')
  //   }

  //   if (this.formEl) {
  //     this.formEl.addEventListener('submit', this.handleSubmit.bind(this));
  //   }

  //   if (this.postcodeInputEl) {
  //     this.postcodeInputEl.addEventListener('keyup', this.searchByPostcode.bind(this));
  //   }

  //   this.selectSuggestion();
  // }

  // async searchByPostcode() {
  //   const query = this.postcodeInputEl.value;
  //   const url = `https://us-central1-astute-smile-292303.cloudfunctions.net/findPostcodeLatLong?searchTerm=${query}&shop=tupperware-au.myshopify.com`

  //   if (query.length < 2) {
  //     this.updateSuggestions([], query);
  //     return;
  //   }
    
  //   await fetch(url)
  //   .then((response) => response.json())
  //   .then((json) => {
  //     this.updateSuggestions(json, query);
  //   })
  //   .catch((error) => {
  //     this.updateSuggestions([], query);
  //     console.error(error);
  //   });
  // }

  // updateSuggestions(suggestions, query) {
  //   const suggestionMarkup = (suggestion) => {
  //     const data = {
  //       ...suggestion,
  //       text: [suggestion.postcode, suggestion.locality, suggestion.state].join(' '),
  //     }

  //     return `
  //       <li>
  //         <button data-suggestion='${JSON.stringify(data)}'>
  //           ${data.text.toLowerCase().replace(query.toLowerCase(), `<strong>${query.toLowerCase()}</strong>`)}
  //         </button>
  //       </li>
  //     `
  //   };

  //   if (suggestions.length) {
  //     this.suggestionsEl.innerHTML = suggestions.slice(0, 5).map(suggestion => suggestionMarkup(suggestion)).join('');
  //     this.suggestionsEl.setAttribute('aria-expanded', 'true');
  //   } else {
  //     this.suggestionsEl.innerHTML = `<li>${this.strings.hint}</li>`;
  //     this.suggestionsEl.setAttribute('aria-expanded', query.length ? 'true' : 'false');
  //   }
  // }

  // selectSuggestion() {
  //   this.suggestionsEl?.addEventListener('click', (event) => {
  //     event.preventDefault();
  //     if (event.target.dataset.suggestion) {
  //       const location = JSON.parse(event.target.dataset.suggestion);
        
  //       localStorage?.setItem('currentCustomerLocation', JSON.stringify({ lat: location.lat, long: location.long }));

  //       this.postcodeInputEl.value = location.text;
  //       // this.suggestionsEl.innerHTML = `<li>${this.strings.hint}</li>`;
  //       this.suggestionsEl?.setAttribute('aria-expanded', 'false');
  //       this.handleSubmit();
  //     }
  //   })
  // }

  // handleSubmit(event) {
  //   if (event) {
  //     event.preventDefault();
  //   }

  //   const storefinderSection = document.querySelector('[data-consultant-finder-section]');
  //   if (!storefinderSection) return;

  //   // Update overlay section
  //   const searchField = storefinderSection.querySelector('#store-locator-search');
  //   if (searchField && this.postcodeInputEl) {
  //     searchField.value = this.postcodeInputEl.value;
  //   }

  //   const secondarySearchField = storefinderSection.querySelector("#store-locator-search-secondary");
  //   if (secondarySearchField && this.consultantInputEl) {
  //     if (this.consultantInputEl.value && !this.postcodeInputEl.value) {
  //       secondarySearchField.value = this.consultantInputEl.value;
  //     } else {
  //       secondarySearchField.value = '';
  //     }
  //   }

  //   storefinderSection.setAttribute('aria-expanded', 'true');
  //   document.body.classList.add('consultant-search-expanded');

  //   if (this.postcodeInputEl.value || this.consultantInputEl.value) {
  //     document.dispatchEvent(new CustomEvent('consultant-landing:open-overlay'));
  //   }

  //   // Trigger searchByName only if consultantInputEl is not empty, and postcode input is empty
  //   if (this.consultantInputEl.value && !this.postcodeInputEl.value) {
  //     const storefinderSectionBtn = storefinderSection.querySelector('.store-locator__group-search button');
  //     if (storefinderSectionBtn) {
  //       storefinderSectionBtn.dispatchEvent(new Event("click"));
  //     }
  //   }

  //   // Reset form
  //   if (this.postcodeInputEl) {
  //     this.postcodeInputEl.value = '';
  //   } 
  //   if (this.consultantInputEl) {
  //     this.consultantInputEl.value = '';
  //   } 
  //   if (this.suggestionsEl) {
  //     this.suggestionsEl.innerHTML = `<li>${this.strings.hint}</li>`;
  //     this.suggestionsEl.setAttribute('aria-expanded', 'false');
  //   }
  // }
// }


// function initPostCodeSearch () {
//   customElements.define('post-code-search', PostCodeSearch);
// }

document.addEventListener('DOMContentLoaded', function () {
  const consultantHeroSection = document.querySelector('[data-section-type="consultant-finder-hero"]');
  if (consultantHeroSection) {
    // initPostCodeSearch();

    // Close overlay
    consultantHeroSection.addEventListener('click', (event) => {
      if (!document.body.classList.contains('consultant-search-expanded')) return;
      if (!event.target.classList.contains('consultant-finder-hero__background')) return;

      const storefinderSection = document.querySelector('[data-consultant-finder-section]');
      if (storefinderSection) {
        storefinderSection.setAttribute('aria-expanded', 'false');
      }
      
      document.body.classList.remove('consultant-search-expanded');
      document.dispatchEvent(new CustomEvent('consultant-landing:clear-search'));
    });
  }
});

// ===================================================
// TWP | CONSULTANT LANDING TESTIMONIAL SECTION
// ===================================================

function initConsultantFinderTestimonialSection(container) {
  const sliderEl = container.querySelector('[data-slider]');
  if (!sliderEl) return;

  const slider = new Flickity(sliderEl, {
    pageDots: false,
    prevNextButtons: true,
    cellAlign: 'center',
    watchCSS: true,
    wrapAround: true,
  });
};

document.addEventListener('DOMContentLoaded', function () {
  const consultantTestimonialSection = document.querySelector('[data-section-type="consultant-finder-testimonials"]');
  if (consultantTestimonialSection) {
    initConsultantFinderTestimonialSection(consultantTestimonialSection);
  }
});

// Inventory Check before adding to cart on atc click for customer only
const warehouseId = document.body.classList.contains('special_customer') ? window.shop.customer.consultant_warehouse : window.shop.customer.customer_warehouse_id;
async function handleInventory(skuId, warehouseId){
var inventory_status;

  // if(skuId == 980650002902 || skuId == 980650002928 || skuId == 980650002927 || skuId == 980650002929 || skuId == 980650002934 ){
  //   inventory_status = {status: true, quantity: 1};
  //   return inventory_status;
  // }
  
try{
    const raw = JSON.stringify({
      "sku": skuId,
      "warehouse": warehouseId
    });
    
    const requestOptions = {
      method: "POST",
      headers: {"Content-Type": "application/json"},
      body: raw,
      redirect: "follow"
    };
    
    const response = await fetch("https://tupperware.enscommerce.in/tupperwear/checkinventory", requestOptions);
    const result = await response.json();
    if(result.success){
     inventory_status = (result.availableQty > 0) ? {status: true, quantity: result.availableQty} : {status: false, quantity: 0} ;
    }
  }catch(error){
    console.log(error.message);
    return;
  }
  // console.log('inventory_status',inventory_status);
  return inventory_status;
}

const Bottle_offerProduct = async () => {
  try {
    const freeProductId = '49942671818968'; 
    const res = await fetch('/cart.js');
    const data = await res.json(); 
    let freeProductLineItemId = null;
    data.items.forEach(item => {
      if (item.id == freeProductId) {
        freeProductLineItemId = item.key; 
      }
    });
    
    // const bottle_special_price = data.items.filter( item => freeProductId.includes(item.id) && item.final_line_price === 500 );
    // console.log('bottle_special_price', bottle_special_price.length)
    const bottle_price = data.items.filter(item => freeProductId.includes(item.id)).map(item => item.original_line_price)[0] || 0;
    const bottle_quantity = data.items.filter(item => freeProductId.includes(item.id)).map(item => item.quantity)[0] || 0;
    const onlyBottlePresentInCart = data.items.some(item => freeProductId.includes(item.id));

    // const hideRemoveBtn = bottle_special_price.length == 0 ? 'hidden' : '';
    const lineItem__bottle_rs5 = document.querySelectorAll('.cart-item-price__price');
    lineItem__bottle_rs5.forEach(item => {
      // if(item.textContent == '₹5.00'){
      //   item.closest('.cart-item--mobile').querySelector('.cart-item-remove').classList.add('hidden');
      // }
    })
    
    if (data.items_subtotal_price >= 100000) {
      const quantity = 1;
      if (!freeProductLineItemId) {
        var inventoryStatus = await handleInventory(11178330, warehouseId);
        var api_qyt = inventoryStatus?.quantity; 
        if(quantity < api_qyt){
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
              quantity: 1,
              id: freeProductId
            },
            dataType: 'json',
            success: function (data) {
              CartJS.getCart();
            },
            error: function(xhr, ajaxOption, thrownError) {
            }
          });
        }
      }
      // else if(onlyBottlePresentInCart && bottle_quantity > 1){
      //   var inventoryStatus = await handleInventory(11178330, warehouseId);
      //   var api_qyt = inventoryStatus?.quantity; 
      //   if(quantity < api_qyt){
      //     $.ajax({
      //       type: 'POST',
      //       url: '/cart/add.js',
      //       data: {
      //         quantity: 1,
      //         id: freeProductId
      //       },
      //       dataType: 'json',
      //       success: function (data) {
      //         CartJS.getCart();
      //       },
      //       error: function(xhr, ajaxOption, thrownError) {
      //       }
      //     });
      //   }
      // }
    } 

    // else {
    //   if (freeProductLineItemId) {
    //     $.ajax({
    //       type: 'POST',
    //       url: '/cart/update.js',
    //       data: {
    //         updates: {
    //           [freeProductLineItemId]: 0 
    //         }
    //       },
    //       dataType: 'json',
    //       success: function (data) {
    //       CartJS.getCart();
    //       },
    //       error: function(xhr, ajaxOption, thrownError) {
    //         console.log("Error while removing free product from cart:", thrownError);
    //       }
    //     });
    //   }
    // }

    // const cart_quan_section = document.querySelectorAll('.cart-item-quantity--buttons .cart-item-quantity__quantity');
    // cart_quan_section.forEach(item => {
    //   var cart_includeBottleID = parseInt(item.getAttribute('lineitem__variantid'));
    //   if(freeProductId.includes(cart_includeBottleID)){
    //     item.previousElementSibling.classList.add('hidden');
    //     item.nextElementSibling.classList.add('hidden');
    //     item.closest('.qty-and-remove').querySelector('.cart-item-remove').classList.add('hidden');
    //   }
    // });
  } catch (error) {
    console.error('Error fetching cart data:', error);
  }
};

const pv_one_time = async () => {
  const pv_cart_drawer = document.querySelector('.pv__week11');
  
  try {
    const pv__ID = '50375885488344';
    const bottleID = '49942671818968';
    const brand_builderID = '50327284449496';
  
    const res = await fetch('/cart.js');
    const data = await res.json();
  
    const getItemData = (id) => data.items.find(item => item.id == id);
    const getQuantity = (id) => (getItemData(id)?.quantity) || 0;
    const getLinePrice = (id) => (getItemData(id)?.original_line_price) || 0;
  
    const has__pv = getQuantity(pv__ID);
    const pv__price = getLinePrice(pv__ID);
    const bottle_price = getLinePrice(bottleID);
    const brand_builder_price = getLinePrice(brand_builderID);
  
    const finalized_price = data.original_total_price - pv__price - brand_builder_price - bottle_price;
  
    if (has__pv >= 2) {
      pv_cart_drawer.classList.add('hidden');
      await $.ajax({
        type: "POST",
        url: "/cart/update.js",
        data: { updates: { [pv__ID]: 1 } },
        dataType: "json"
      });
      CartJS.getCart();
      return;
    }
    if(finalized_price < 290000){
      pv_cart_drawer.classList.add('hidden');
    }
    if (finalized_price >= 290000) {
      pv_cart_drawer.classList.toggle('hidden', has__pv > 0);
    } else if (has__pv > 0) {
      pv_cart_drawer.classList.add('hidden');
      await $.ajax({
        type: "POST",
        url: "/cart/update.js",
        data: { updates: { [pv__ID]: 0 } },
        dataType: "json"
      });
      CartJS.getCart();
    }
  } catch (error) {
    console.error('Error fetching cart data:', error);
  }
};

const brandBuiler_offer = async () => {
  let freeProduct_ids = [];
  const freeProduct_list = document.querySelectorAll('.privilaged_offer_main .container_body_offer .ProductItem__Action button');
  freeProduct_list.forEach(item => {
    freeProduct_ids.push(item.getAttribute('variantid'));
  });
  freeProduct_ids = freeProduct_ids.map(Number);

  try {
    const brandBuilder__id = '50327284449496'; 
    const bottleTriangular__id = '49942671818968';
    const res = await fetch('/cart.js');
    const data = await res.json(); 
    var inventoryStatus = await handleInventory(11178205, warehouseId);
    var api_qyt = inventoryStatus?.quantity; 
    let freeProductLineItemIds = null;
    data.items.forEach(item => {
      if (item.id == brandBuilder__id) {
        freeProductLineItemIds = item.key; 
      }
    });

    // Calculate bottle price and remove it
    const bottle_price = data.items.filter(item => bottleTriangular__id.includes(item.id)).map(item => item.original_line_price)[0] || 0;
    const brandBuilder_price = data.items.filter(item => brandBuilder__id.includes(item.id)).map(item => item.original_line_price)[0] || 0;
    const brandBuilder_quantity = data.items.filter(item => brandBuilder__id.includes(item.id)).map(item => item.quantity).reduce((sum, quan) => sum + quan, 0);
    const privilage_buy_price = data.items.filter(item => freeProduct_ids.includes(item.id)).map(item => item.original_line_price)[0] || 0;
    const threshold_price = data.original_total_price - bottle_price - privilage_buy_price - brandBuilder_price;

    function removeBrand_builder(freeProductLineItemIds){
      if (freeProductLineItemIds) {
        $.ajax({
          type: 'POST',
          url: '/cart/update.js',
          data: {
            updates: {
              [freeProductLineItemIds]: 0
            }
          },
          dataType: 'json',
          success: function (data) {
          CartJS.getCart();
          },
          error: function(xhr, ajaxOption, thrownError) {
            console.log("Error while removing builder from cart:", thrownError);
          }
        });
      }
    }

    const containerBrand_builder = document.querySelector('.brand_builder_active');
    if (threshold_price > 275000) {
      containerBrand_builder.classList.remove('hidden');
      containerBrand_builder.addEventListener("click",()=>{
        document.querySelector(".container_brand_builder").classList.toggle("hidden");
        console.log('22222')
      });      
      const addBtn_brand = document.querySelector('.add_brand_builder');
      if(freeProductLineItemIds){
        containerBrand_builder.classList.add('hidden');
        if(brandBuilder_quantity > 1){
          removeBrand_builder(freeProductLineItemIds);
        }
      }
      
      addBtn_brand.addEventListener('click',() => {
        const quantity = 1;
        if (!freeProductLineItemIds) {
          if(quantity < api_qyt){
            $.ajax({
              type: 'POST',
              url: '/cart/add.js',
              data: {
                quantity: 1,
                id: brandBuilder__id
              },
              dataType: 'json',
              success: function (data) {
                CartJS.getCart();
              },
              error: function(xhr, ajaxOption, thrownError) {
              }
            });
          }
        }
      })
    } else {
      containerBrand_builder.classList.add('hidden');
      removeBrand_builder(freeProductLineItemIds);
    }

    const cart_quan_section = document.querySelectorAll('.cart-item-quantity--buttons .cart-item-quantity__quantity');
    cart_quan_section.forEach(item => {
      var cart_includeBottleID = parseInt(item.getAttribute('lineitem__variantid'));
      if(brandBuilder__id.includes(cart_includeBottleID)){
        item.previousElementSibling.classList.add('hidden');
        item.nextElementSibling.classList.add('hidden');
      }
    });
  } catch (error) {
    console.error('Error fetching cart data:', error);
  }
};



// checkFreeProduct();
const brandBuilder__id = '50327284449496';
const bottleTriangular__id = '49942671818968';
let freeProduct_ids =[];
let freeProduct_skus = [];
const overlay_pv = document.querySelector('.overlay_privilage');
const container_pv = document.querySelector('.privilaged_offer_main');
const freeProduct_list = document.querySelectorAll('.privilaged_offer_main .container_body_offer .ProductItem__Action button');
freeProduct_list.forEach(item => {
  freeProduct_ids.push(item.getAttribute('variantid'));
});

const disc_prodcutAdd = async () => {
  try {
    const res = await fetch('/cart.js');
    const cart_data = await res.json();
    freeProduct_ids = freeProduct_ids.map(Number);
    
    const pv_quantity = cart_data.items
      .filter(ele => freeProduct_ids.includes(ele.id))
      .map(item => item.quantity);
    
    const pv_price = cart_data.items
      .filter(ele => freeProduct_ids.includes(ele.id))
      .map(item => item.original_line_price);

    const brand_builderProduct = cart_data.items
    .filter(item => brandBuilder__id.includes(item.id))
    .map(item => item.original_line_price)[0] || 0;

    const bottlePrice = cart_data.items
    .filter(item => bottleTriangular__id.includes(item.id))
    .map(item => item.original_line_price)[0] || 0;
    
    const pv__total_quantity = pv_quantity.reduce((sum, quan) => sum + quan, 0);
    const pv__total_line_price = pv_price.reduce((sum, price) => sum + price, 0);

    // console.log('cart_data.original_total_price',cart_data.original_total_price, 'pv__total_line_price',pv__total_line_price);

    const final_calculative_amount = cart_data.original_total_price - pv__total_line_price - bottlePrice - brand_builderProduct;
    const threshold_price = (final_calculative_amount) - (final_calculative_amount % 300000);
    const max_quantity_privilaged_product = threshold_price / 300000;
    
    console.log('pv__total_quantity',pv__total_quantity,'max_quantity_privilaged_product',max_quantity_privilaged_product,'threshold_price',threshold_price);

    // console.log('cart_data.original_total_price',cart_data.original_total_price - brand_builderProduct);
    
    var exclude_bottle = cart_data.original_total_price - bottlePrice;
    const cart_subtotal = threshold_price >= 300000 && pv__total_quantity < max_quantity_privilaged_product && exclude_bottle > 300000;
    
    if(document.querySelector('.privilaged_offer_main .product_count span')){
      document.querySelector('.privilaged_offer_main .product_count span').textContent = `Add ${max_quantity_privilaged_product - pv__total_quantity} Product`;
    }
    
    overlay_pv.classList.toggle('hidden', !cart_subtotal);
    container_pv.classList.toggle('hidden', !cart_subtotal);

    const pv_cart_sku = cart_data.items
    .filter(ele => freeProduct_ids.includes(ele.id))
    .map(item => item.sku).map(Number);

    const cart_quan_section = document.querySelectorAll('.cart-item-quantity--buttons a');
    cart_quan_section.forEach(item => {
      var cart_sku = parseInt(item.getAttribute('data-product-sku'));
      if(pv_cart_sku.includes(cart_sku)){
        item.classList.add('hidden');
      }
    });

    if (cart_subtotal) {
      // freeProduct_list.forEach(btn => {
      //   btn.addEventListener('click', async function handleClick(e) {
      //     e.preventDefault();
      //     btn.disabled = true;
      
      //     try {
      //       const varinat_id = parseInt(this.getAttribute('variantid'));
      //       const sku = parseInt(this.getAttribute('sku'));
      //       const inventoryStatus = await handleInventory(sku, warehouseId);
      //       const api_qyt = (inventoryStatus?.quantity) - 1;
      
      //       if (api_qyt > 0) {
      //         await $.ajax({
      //           type: 'POST',
      //           url: '/cart/add.js',
      //           data: {
      //             quantity: 1,
      //             id: varinat_id
      //           },
      //           dataType: 'json'
      //         });
      //         CartJS.getCart();
      //       } else if (api_qyt < 0) {
      //         await $.ajax({
      //           type: 'POST',
      //           url: '/cart/update.js',
      //           data: {
      //             updates: {
      //               [varinat_id]: 1
      //             }
      //           },
      //           dataType: 'json'
      //         });
      //         CartJS.getCart();
      //       }
      //     } catch (error) {
      //       console.error('Error handling cart action:', error);
      //     } finally {
      //       btn.disabled = false;
      //     }
      //   }, { once: true }); 
      // });
    } 
    else {
      if (pv__total_quantity > 0 && ((final_calculative_amount) < 300000 || threshold_price < 10000)) {
      const pv_cart_varinatID = cart_data.items
      .filter(ele => freeProduct_ids.includes(ele.id))
      .map(item => item.id);
        $.ajax({
          type: 'POST',
          url: '/cart/update.js',
          data: {
            updates: {
              [pv_cart_varinatID]: 0
            }
          },
          dataType: 'json',
          success: function (data) {
            CartJS.getCart();
          },
          error: function (xhr, ajaxOption, thrownError) {
            console.error("Error removing free product from cart:", thrownError);
          }
        });
      }
    }

  const swapCheckout_btn = pv__total_quantity > max_quantity_privilaged_product;
  const checkout_btn = document.querySelector('.cart-drawer__submit');
    if (checkout_btn) {
      if (swapCheckout_btn) {
        checkout_btn.setAttribute('type', 'button');
        checkout_btn.replaceWith(checkout_btn.cloneNode(true));
        
        const updated_btn = document.querySelector('.cart-drawer__submit[type="button"]');
        updated_btn.addEventListener('click', (e) => {
          e.preventDefault();
          alert(`Please remove ${pv__total_quantity - max_quantity_privilaged_product} privilege buy product`);
        });
      } else {
        checkout_btn.setAttribute('type', 'submit');
      }
    }
    
  } catch (error) {
    console.error('Error fetching cart data:', error);
  }
};



// Week 11 privilege buy and guest offer combined
let pv_week11_ids =[];
  const level1 = [45326663909592, 50585186992344];  
  const level2 = [50727510081752];
  const level3 = [50221483557080, 50221480575192, 50727696728280];
 
const atc_offer_btn = document.querySelectorAll('.pv__week11 .ProductItem__Action button');
atc_offer_btn.forEach(item => {
  pv_week11_ids.push(item.getAttribute('variantid'));
});
const week11_special = async () => {
  try {
    const res = await fetch('/cart.js');
    const cart_data = await res.json();
    pv_week11_ids = pv_week11_ids.map(Number);

    const guest_offer_price_total = cart_data.items.filter(item => [...level1, ...level2, ...level3].includes(item.id)).reduce((total, num) => total + num.original_line_price , 0); 
    
    const pv_quantity = cart_data.items.filter(ele => pv_week11_ids.includes(ele.id)).map(item => item.quantity);
    const pv_price = cart_data.items.filter(ele => pv_week11_ids.includes(ele.id)).map(item => item.original_line_price);
    const brand_builderProduct = cart_data.items.filter(item => brandBuilder__id.includes(item.id)).map(item => item.original_line_price)[0] || 0;
    const bottlePrice = cart_data.items.filter(item => bottleTriangular__id.includes(item.id)).map(item => item.original_line_price)[0] || 0;
    const pv__total_quantity = pv_quantity.reduce((sum, quan) => sum + quan, 0);
    const pv__total_line_price = pv_price.reduce((sum, price) => sum + price, 0);

    const final_calculative_amount = cart_data.original_total_price - pv__total_line_price - bottlePrice - brand_builderProduct - guest_offer_price_total;
    const threshold_price = (final_calculative_amount) - (final_calculative_amount % 200000);
    const max_quantity_privilaged_product = threshold_price / 200000;
    
    console.log('pv__total_quantity',pv__total_quantity,'max_quantity_privilaged_product',max_quantity_privilaged_product,'threshold_price',threshold_price);
    
    var exclude_bottle = cart_data.original_total_price - bottlePrice;
    const cart_subtotal = threshold_price >= 200000 && pv__total_quantity < max_quantity_privilaged_product && exclude_bottle > 200000;
    
    if(document.querySelector('.pv__week11 .count__pv')){
      document.querySelector('.pv__week11 .count__pv').textContent = `Add Upto ${max_quantity_privilaged_product - pv__total_quantity}`;
    }

    const pv_cart_sku = cart_data.items.filter(ele => pv_week11_ids.includes(ele.id)).map(item => item.sku).map(Number);

    if (cart_subtotal) {
       document.querySelector('.pv__week11').classList.remove('hidden');
    } 
    else {
       document.querySelector('.pv__week11').classList.add('hidden');
      if (pv__total_quantity > 0 && ((final_calculative_amount) < 200000 || threshold_price < 10000)) {
      const pv_cart_varinatID = cart_data.items.filter(ele => pv_week11_ids.includes(ele.id)).map(item => item.id);
        $.ajax({
          type: 'POST',
          url: '/cart/update.js',
          data: {
            updates: {
              [pv_cart_varinatID]: 0
            }
          },
          dataType: 'json',
          success: function (data) {
            CartJS.getCart();
          },
          error: function (xhr, ajaxOption, thrownError) {
            console.error("Error removing free product from cart:", thrownError);
          }
        });
      }
    }

  const swapCheckout_btn = pv__total_quantity > max_quantity_privilaged_product;
  const checkout_btn = document.querySelector('.cart-drawer__submit');
    if (checkout_btn) {
      if (swapCheckout_btn) {
        checkout_btn.setAttribute('type', 'button');
        checkout_btn.replaceWith(checkout_btn.cloneNode(true));
        
        const updated_btn = document.querySelector('.cart-drawer__submit[type="button"]');
        updated_btn.addEventListener('click', (e) => {
          e.preventDefault();
          alert(`Please remove ${pv__total_quantity - max_quantity_privilaged_product} privilege buy product`);
        });
      } else {
        checkout_btn.setAttribute('type', 'submit');
      }
    }
    
  } catch (error) {
    console.error('Error fetching cart data:', error);
  }
};

// Week 10 Code or Guest Offer
const pv_popup = document.querySelectorAll('.privilaged_grid_box');
const container_pv_grid = document.querySelector('.privilaged_offer_main');
const pv_special_week11 = document.querySelectorAll('.pv__week11 .ProductItem__Action .add_pv_week11')
let variantID_popup = [];
let pv_special_variant_id = [];
pv_popup.forEach(id => {
  var ID = id.getAttribute('variantID');
    variantID_popup.push(ID);
})
pv_special_week11.forEach(id => {
  var ID = id.getAttribute('variantID');
    pv_special_variant_id.push(ID);
})
variantID_popup = variantID_popup.map(Number);

const guest_offer = async () => {
  const container_pv_grid = document.querySelector('.privilaged_offer_main');
  const res = await fetch('/cart.js');
  const cart_data = await res.json();

  // level1 --- 5500
  const level1 = [50347772575960, 50915333898456];  
  // level2 --- 7500
  const level2 = [50915353919704, 50915357294808];
  //level3 --- 12000
  const level3 = [50915275079896, 50915293790424, 50915297067224, 50915304210648];
  //level4 --- 16000
  // const level4 = [50727620575448];

  const brand_builderProduct = cart_data.items
  .filter(item => brandBuilder__id.includes(item.id))
  .map(item => item.original_line_price)[0] || 0;

  const bottlePrice = cart_data.items
  .filter(item => bottleTriangular__id.includes(item.id))
  .map(item => item.original_line_price)[0] || 0;
  const privilage_buy_price = cart_data.items.filter(item => pv_special_variant_id[0].includes(item.id)).reduce((total, num) => total + num.original_line_price, 0);
  
  var ids_cartDrawer = cart_data.items.filter(item => item.id).map(item => item.id);
  var offer_drawer_conditional_price = cart_data.items.filter(item => [...level1, ...level2, ...level3].includes(item.id)).map(item => {
    let priceMultiplier = 0;
    if (level1.includes(item.id)) {
      priceMultiplier = 5500;
    } else if (level2.includes(item.id)) {
      priceMultiplier = 7500;
    }else if(level3.includes(item.id)){
      priceMultiplier = 12000;
    }
    // else if(level4.includes(item.id)){
    //   priceMultiplier = 16000;
    // }
    return priceMultiplier * item.quantity;
  }).reduce((total, price) => total + price, 0); 
  
  const offer_mrp_total_cart = cart_data.items.filter(item => [...level1, ...level2, ...level3].includes(item.id)).reduce((sum, item) => sum + item.original_line_price / 100, 0);
  const pv_inCart_quantity = cart_data.items.filter(item => [...level1, ...level2, ...level3].includes(item.id)).reduce((sum, item) => sum + item.quantity, 0);

  // console.log('OfferProduct MRP',offer_mrp_total_cart);
  var cart_mrp_price_total = ((cart_data.original_total_price - brand_builderProduct - bottlePrice )/100) - offer_mrp_total_cart;
  console.log('Cart MRP',cart_mrp_price_total);

  console.log('cart_data.original_total_price',(cart_data.original_total_price)/100,'brand_builderProduct',(brand_builderProduct)/100,'bottlePrice',(bottlePrice)/100,'privilage_buy_price',(privilage_buy_price)/100,'offer_mrp_total_cart',offer_mrp_total_cart);
  
  overlay_pv.classList.toggle('hidden',!(cart_mrp_price_total > 5500));
  container_pv_grid.classList.toggle('hidden',!(cart_mrp_price_total > 5500));

  const balanced_amount = (cart_mrp_price_total - offer_drawer_conditional_price);
  let price_categories = [];
//  if(balanced_amount >= 16000){
//     price_categories = [...level1, ...level2, ...level3, ...level4];
//   }
  if(balanced_amount >= 12000){
    price_categories = [...level1, ...level2, ...level3];
  }else if(balanced_amount >= 7500){
    price_categories = [...level1, ...level2];
  }else if(balanced_amount >= 5500){
    price_categories = [...level1];
  }
// console.log('offer_drawer_conditional_price',offer_drawer_conditional_price,);
pv_popup.forEach((item,index) => {
  const id__variant = parseInt(item.getAttribute('varid'));
  item.classList.toggle('hidden', !(price_categories.includes(id__variant)));
  
  // console.log('balance',balanced_amount);

  overlay_pv.classList.toggle('hidden', !(cart_mrp_price_total > 5500 && balanced_amount > 5500));
  container_pv_grid.classList.toggle('hidden', !(cart_mrp_price_total > 5500 && balanced_amount > 5500));

  function removeProduct_cart(id){
    if(id.length > 0){
      $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: {
          updates: {
            [id]: 0
          }
        },
        dataType: 'json',
        success: function (data) {
          CartJS.getCart();
        },
        error: function (xhr, ajaxOption, thrownError) {
          console.error("Error removing free product from cart:", thrownError);
        }
      });
    }
  }
console.log('---------------------',cart_mrp_price_total);
  if(cart_mrp_price_total < 5500){
    const pv_cart_varinatID = cart_data.items.filter(ele => [...level1, ...level2, ...level3].includes(ele.id)).map(item => item.id);
    removeProduct_cart(pv_cart_varinatID);
  }
  else if(cart_mrp_price_total < 7500){
    const pv_cart_varinatID = cart_data.items.filter(ele => [...level2,...level3].includes(ele.id)).map(item => item.id);
    removeProduct_cart(pv_cart_varinatID)
  }
  else if(cart_mrp_price_total < 12000){
    const pv_cart_varinatID = cart_data.items.filter(ele => [...level3].includes(ele.id)).map(item => item.id);
    removeProduct_cart(pv_cart_varinatID);
  }
  // else if(cart_mrp_price_total < 16000){
  //   const pv_cart_varinatID = cart_data.items.filter(ele => [...level4].includes(ele.id)).map(item => item.id);
  //   removeProduct_cart(pv_cart_varinatID);
  // }
  
  // const swapCheckout_btn = cart_mrp_price_total > offer_drawer_conditional_price
  // const checkout_btn = document.querySelector('.cart-drawer__submit');
  // if(checkout_btn){
  //   !swapCheckout_btn ? checkout_btn.setAttribute('type','button') : checkout_btn.setAttribute('type','submit');
  // }
});

  const pv_cart_sku = cart_data.items
  .filter(ele => [...level1, ...level2, ...level3].includes(ele.id))
  .map(item => item.sku).map(Number);

  const cart_quan_section = document.querySelectorAll('.cart-item-quantity--buttons a');
  cart_quan_section.forEach(item => {
    var cart_sku = parseInt(item.getAttribute('data-product-sku'));
    if(pv_cart_sku.includes(cart_sku)){
      item.classList.add('hidden');
    }
  });

  wrapAll_weekly_offer();
  
  // $('body').on('click', '.cart-drawer__submit[type="button"]', function(event){
  //   event.preventDefault();
  //   alert('Please reduce the Privilaged buy product quantity');
  //   return;
  // });

  const swapCheckout_btn = cart_mrp_price_total < offer_drawer_conditional_price;
  const checkout_btn = document.querySelector('.cart-drawer__submit');
    if (checkout_btn) {
      if (swapCheckout_btn) {
        checkout_btn.setAttribute('type', 'button');
        // checkout_btn.replaceWith(checkout_btn.cloneNode(true));
        
        const updated_btn = document.querySelector('.cart-drawer__submit[type="button"]');
        updated_btn.addEventListener('click', (e) => {
          e.preventDefault();
          alert(`Please reduce quantity of guest product`);
        });
      } else {
        checkout_btn.setAttribute('type', 'submit');
      }
    }
}

async function bulk_inventory_checkout(cartDrawer_skus){
  const raw = JSON.stringify({
    "products":cartDrawer_skus,
    "warehouse":warehouseId
  });
  
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type":"application/json",
    },
    body: raw,
    redirect: "follow"
  };
  
  const response = await fetch("https://tupperware.enscommerce.in/tupperwear/bulk/inventory", requestOptions);
  const output = await response.json();
  if(output.success){
    console.log(output.result);
    var isUnavailable = !output.result.some(item => item.inventory === false);
    // return output.result[0].inventory ? true : false;
    return isUnavailable;
  }else{
    alert(`Product is out of stock`);
    return false;
  }
}

function wrapAll_weekly_offer() {
  jQuery(document).ready(function ($) {
    const groups = [
      { indexes: [1, 2], amount: 5500 },
      { indexes: [3, 4], amount: 7500 },
      { indexes: [5, 6, 7, 8], amount: 12000 }
      // { indexes: [6], amount: 16000 },
    ];

    // ✅ Step 1: Remove existing wrappers, keep grid boxes
    $('.privilaged_group').each(function () {
      const items = $(this).find('.privilaged_grid_box');
      $(this).replaceWith(items); // Unwrap into DOM
    });

    // ✅ Step 2: Build wrappers fresh
    groups.forEach((group, index) => {
      const selector = group.indexes
        .map(num => `.privilaged_grid_box[indexing='${num}']`)
        .join(',');
      const elements = $(selector);

      if (elements.length) {
        // Wrap group
        elements.wrapAll(`
          <div class="privilaged_group group-${index + 1}">
            <span class="title_product_offer hidden">
              Buy Tupperware worth ₹${group.amount} & unlock Offer At ₹5
            </span>
            <div class="wrap_privilege_container"></div>
          </div>
        `);

        // Move products into container with OR separator
        const wrapper = elements.closest('.privilaged_group');
        const container = wrapper.find('.wrap_privilege_container');
        elements.each(function (i) {
          container.append($(this));
          if (i < elements.length - 1) {
            container.append('<span class="or_seperator">OR</span>');
          }
        });

        // Hide wrapper if no visible items
        const visibleCount = elements.filter(':visible').length;
        wrapper.toggleClass('hidden', visibleCount === 0);
      }
    });

    // ✅ Step 3: Update dynamic title *after* DOM fully updated
    setTimeout(() => {
      const lastVisibleTitle = $('.privilaged_group:not(.hidden)')
        .find('.title_product_offer')
        .last()
        .text()
        .trim();
      $('.dynamic_title_level').text(lastVisibleTitle || '');
    }, 0); // delay ensures DOM changes from wrapAll() complete
  });
}



async function b1g1() {
  const variantId = 45291293475032;

  try {
    const response = await fetch('/cart.js');
    const cart = await response.json();
    const matchingItems = cart.items.filter(item => item.id === variantId);
     console.log(matchingItems.length, 'matchingItem')
    // if (matchingItems.length <= 2) return;
    const totalQuantity = matchingItems.reduce((sum, item) => sum + item.quantity, 0);
    console.log(totalQuantity, 'totalQuantity')
    if (totalQuantity % 2 === 0) return;
    const targetKey = matchingItems[0].key; 
    const updates = {
      [targetKey]: matchingItems[0].quantity + 1
    };

    await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ updates })
    });

    // Optional: refresh the cart UI
    if (typeof CartJS !== 'undefined') {
      CartJS.getCart();
    }

  } catch (error) {
    console.error('Error applying b1g1 logic:', error);
  }
}



// Sticky ATC Mobile
if (window.location.pathname.includes('products') && window.innerWidth < 750) {
  const atc_btn_pdp = document.querySelector('.add-to-cart-conatiner .ProductForm__Actions');
  if (atc_btn_pdp) {
    window.addEventListener('scroll', function () {
      const rect = atc_btn_pdp.getBoundingClientRect();
      const inView = rect.top >= 0 && rect.bottom <= window.innerHeight;

      if (inView) {
        atc_btn_pdp.classList.add('sticky_atc_btn');
      } else {
        atc_btn_pdp.classList.remove('sticky_atc_btn');
      }
    });
  }
}